import {
  ADMIN_MY_PRODUCTS_3DMODAL_EACH,
  ADMIN_MY_PRODUCTS_ROOMS_DETAILS,
  COLLECTION_ID,
  INVITE_ROUTE,
  RENDER_DETAILS,
} from '../constants/routePathConstants';
import {
  API_UPLOAD_TYPE,
  FRAPPE_APP_URL,
  MODULE_TYPES,
  ONE_MINUTE,
  ONE_SECOND,
} from '../constants/constants';
import {
  CREATE_AUTOMATION_PREVIEW_API,
  ENABLE_AUTOMATION_RENDER_API,
  GET_AUTOMATION_API,
  GET_AUTOMATION_DETAIl_API,
  GET_AUTOMATION_EXCELS_API,
  GET_IMAGES_SIDEFILTER_BRANDS,
  GET_IMAGES_SIDEFILTER_COLLECTIONS,
  GET_IMAGES_SIDEFILTER_LABELS,
  GET_IMAGES_SIDEFILTER_OPTIONS,
  GET_IMAGES_SIDEFILTER_PROPS,
  GET_PROJECTS_SIDEFILTER_BRANDS,
  GET_PROJECTS_SIDEFILTER_COLLECTIONS,
  GET_PROJECTS_SIDEFILTER_LABELS,
  GET_PROJECTS_SIDEFILTER_OPTIONS,
  GET_PROJECTS_SIDEFILTER_PROPS,
  GET_PROP_SIDEFILTER_BRANDS,
  GET_PROP_SIDEFILTER_COLLECTIONS,
  GET_PROP_SIDEFILTER_LABELS,
  GET_PROP_SIDEFILTER_OPTIONS,
  GET_ROOMS_SIDEFILTER_BRANDS,
  GET_ROOMS_SIDEFILTER_COLLECTIONS,
  GET_ROOMS_SIDEFILTER_LABELS,
  GET_ROOMS_SIDEFILTER_OPTIONS,
  GET_TEXTURES_SIDEFILTER_COLLECTIONS,
  GET_TEXTURES_SIDEFILTER_LABELS,
  GET_TEXTURES_SIDEFILTER_OPTIONS,
  GET_TUTORIAL_VIDEO,
  GET_TUTORIAL_VIDEO_SUB_CATEGORY_OPTION_LIST,
  GET_TUTORIAL_CATEGORY_DETAILS,
  OP_GET_PROP_API,
  PRODUCT_3D_MODEL_UPLOAD_API,
  PRODUCT_3D_MODEL_JOB_API,
  RENDER_PARTIAL_PAYMENT,
  PRODUCT_3D_MODEL_BULK_UPLOAD_API,
  GET_MODEL_TEMPLATE,
  AUTOMATION_RENDER_API,
  AUTOMATION_RENDER_API_360,
  AUTOMATION_RENDER_API_360_TEXTURE,
  OP_GET_PROP_API_V2,
  GET_MATERIAL_SIDEFILTER_COLLECTIONS,
  GET_MATERIAL_SIDEFILTER_BRANDS,
  GET_MATERIAL_SIDEFILTER_LABELS,
  GET_MATERIAL_SIDEFILTER_OPTIONS,
  OP_GET_MATERIAL_API,
  OPTIMIZED_PRODUCT_GET_API_HOMEPAGE,
  OP_GET_TEXTURES_API,
  GET_PROP_SIDEFILTER_COLLECTIONS_ORGID,
  GET_PROP_SIDEFILTER_BRANDS_ORGID,
  GET_PROP_SIDEFILTER_LABELS_ORGID,
  GET_PROP_SIDEFILTER_OPTIONS_ORGID,
  GET_REQUESTS_COUNT_API,
  GET_PDP_PRODUCTS_API,
} from '../config/constant/apiConstant';
import _, { shuffle, uniq } from 'lodash';
/* eslint-disable no-debugger */
import api, { apiErrorHandler } from './axiosHelper';
import { errorToast, errorToastV2, successToast, successToastV2 } from './toastHelper';
import {
  addOrgIdIntoAPIUrl,
  getLocalStorage,
  getPerPageCount,
  objectToFormData,
  objectToSearchParams,
  setLocalStorage,
  uniqueId,
} from './jsHelper';

import { GENERATED_NORMAL_MAP_FILTER_OPTION_ID } from '../config/constant/curatorConstants';
import { MODEL_TYPES } from '../constants/constants';
import { SHORTCUT } from '../components/admin/curator/CuratorShortcuts/curatorShortcuts.config';
import axios from 'axios';
import { dispatcher } from './projectHelper';
import { download } from '../common/DownloadFileController/downloadFile';
import memoize from 'memoizee';
import { setNotificationCount } from '../redux/slicers/activitySlicer';
import { subscriptionActions } from '../redux/slicers/subscriptionSlicer';
import { isV2 } from '../components/Configurator/utils';
import { fetchAllPages } from './apiHelper';
import { selectFilterSearchValue } from '../redux/slicers/filters/filterSlicer';
import { getAppState } from '../redux/store';
import { CURRENT_USER, REFRESH_TOKEN } from '../constants/projectConstants';
import { selectIsCacheUsedInAPI } from '../redux/slicers/appSlicer';

export const API_ROOT_URL = process.env.REACT_APP_API_BASE_URL;

//auth
export const LOGIN_API = '/users/api/v3/login/';
export const GOOGLE_LOGIN_API = '/users/api/v3/login/social/';
export const GOOGLE_LOGIN_API_New = '/users/api/v3/fast-register-social/';
export const CAROUSEL_API = '/users/api/v3/images-carrousel/';
export const REGISTER_API = '/users/api/v3/register/';
export const REGISTER_API_V2 = '/users/api/v3/register-v2/';
export const REGISTER_API_NEW = '/users/api/v3/fast-register/';
export const CONVERT_GUEST_USER_TO_NORMAL_API = '/users/api/v3/convert-demo/';
export const REGISTER_API_NEW_GUEST_USER = '/users/api/v3/demo-register/';
export const VERIFY_OTP_API = '/users/api/v3/verify-email-otp/';
export const RESEND_EMAIL_API = '/users/api/v3/resend-email-for-verification/';
export const FORGOT_API = '/users/api/v3/forgot-password/';
export const PROFESSION_API = '/users/api/v3/profession/';
export const INDUSTRY_API = '/users/api/v3/industry/';
export const PLATFORM_API = '/users/api/v3/usecase/';
export const COMPANY_SIZE = '/users/api/v3/companysize/';
export const TERMS_API = '/tnc/latest/';
export const TERMS_ACCEPT_API = '/tnc/accept/';
export const USER_PREFERENCE_API = '/users/api/v3/user-preferences/';
export const ACCOUNT_STATUS_API = '/users/api/v3/check-account-status/';
export const LINK_VERIFY_API = '/users/api/v3/verify-email-with-link/';
export const CREATE_PASSWORD_API = '/users/api/v3/reset-password-confirmation/';
export const UPDATE_USER_PROFILE_API = '/users/api/v3/user-details/';
export const GET_ACCESS_REFRESH_TOKEN = '/users/api/v3/login/refresh/';
export const GLOBAL_SEARCH_API = '/organization/api/v3/search-api/';
export const COMMON_GLOBAL_TAGS = '/organization/api/v3/top-common-global-tags/';
export const AFTER_REGISTER_API = '/users/api/v3/after-register/';
export const REGISTER_INVITE_API = '/organization/api/v3/register-invite/';
export const LOGOUT_API = '/users/api/v3/logout/';
export const CHANGE_ORG_OWNER = '/users/api/v3/change-owner/';

//curator
export const ROOMS_ON_HOMEPAGE = '/rooms/api/v3/get-rooms-on-homepage/';
export const ROOM_UPDATE = '/rooms/api/v3/room-detail/:roomId/';
export const ROOM_LAYOUT_API = '/rooms/api/v3/layout-detail/';
export const PROPS_API = '/assetbundles/api/v3/products/detail/';
export const PROPS_REPLACE_API = '/assetbundles/api/v3/products/sort/';
export const UPDATE_PROPS_API = '/assetbundles/api/v3/products/detail/:productId';
export const PROP_RENDER_IMAGE_API = '/organization/api/v3/product-renders/';
export const ROOM_DETAILS_API = '/rooms/api/v3/room-detail/';
export const DASHBOARD_GALERY_API = '/rooms/api/v3/popular-rooms-detail/';
export const CREATE_ROOM = '/rooms/api/v3/room-detail/';
export const TEXTURE_DETAILS_API = '/texture/api/v3/texture/detail/v2/';
export const OPTIMIZE_TEXTURE_DETAILS_API = '/texture/api/v3/texture/cache/detail/v2/';
export const TEXTURE_PAGE_DETAILS_API_V2 = '/texture/api/v3/texture-page/texture/detail/v2/';
export const DEFAULT_TEXTURE_DETAILS_API = '/texture/api/v3/texture/lf_default/';
export const GET_SETTING_API = '/users/api/v3/get-user-curator-settings/';
export const EDIT_SETTING_API = '/users/api/v3/user-curator-settings-detail/';
export const SIDE_PANEL_OPTIONS = '/organization/api/v3/side-panel-options/';
export const GET_SIDE_PANEL_OPTIONS = '/organization/api/v3/get-side-panel-options/';
export const EXPORT_PROJECT = '/organization/api/v3/lambda/save-on-zip-file-on-local/';

export const LOA_MAPPED_TEXTURE_API = '/texture/api/v3/get-live-on-app-texture/';

export const ORGANISATION_DETAILS_API = '/organization/api/v3/get-all-organization/';
export const GET_PRODUCTS_API = '/assetbundles/api/v3/get-products/detail/';

//projects
export const GET_PROJECT_API = '/organization/api/v3/projects/details/';
export const GET_RECENT_FILES_API =
  '/organization/api/v3/get-recent-files/org/:org_id/mem/:mem_id/';
export const GET_ROOMS_API = '/rooms/api/v3/room-detail/';
export const GET_PROPS_API = '/assetbundles/api/v3/products/detail/';
export const GET_PROPS_API_PUBLIC = '/assetbundles/api/v3/public-product-details/';
export const GET_PROPS_API_PUBLIC_INFO = '/assetbundles/api/v3/public-product-info/';
export const GET_TEXTURE_API_PUBLIC = '/texture/api/v4/public-texture-details/';
export const GET_MISSING_PROPS_DETAILS = '/assetbundles/api/v3/get-product-details/';
export const PRODUCT_META_INFO_API = '/assetbundles/api/v3/products-meta-info/detail/';
export const PROJECT_UPDATE = '/organization/api/v3/projects/details/:projectId/';
export const PROJECT_UPLOAD = '/organization/api/v3/lambda/project-upload/';
export const CHECK_AVAILABILITY = '/assetbundles/api/v3/check-availability/';

//webexperience

export const WEB_EXPERIENCE_API = '/organization/api/v3/webexperience/';
export const WEB_EXPERIENCE_ROOM_TYPE_API = '/organization/api/v3/webexperience/room-type/';
export const GET_WEB_EXPERIENCE_API = '/organization/api/v3/webexperience/';
export const GET_WEB_EXPERIENCE_PUBLIC_API = '/organization/api/v3/public-webexperience/';
export const WEB_EXPERIENCE_PRODUCT_DETAILS_API =
  '/organization/api/v3/webexperience/product-details/';
export const WEB_EXPERIENCE_TEXTURE_DETAILS_API =
  '/organization/api/v3/webexperience/texture-details/';
export const WEB_EXPERIENCE_PRODUCT_DETAILS_API_PUBLIC =
  '/organization/api/v3/webexperience/public-product-details/';

//teamsPage
export const GET_MEMBERS_API = '/organization/api/v3/members/details/';
export const GET_MEMBERS_API_V4 = '/organization/api/v3/members/details/v4/';

export const MEMBERS_MULTIPLE_API = '/organization/api/v3/members/details/status-bulk-update/';
export const SEND_INVITE_API = '/organization/api/v3/send-invite/';
export const GET_PENDING_LIST = '/organization/api/v3/invitation-pending-list/';
export const DELETE_PENDING_INVITATION = '/organization/api/v3/delete-invitation-pending-list/';
export const CHECK_USER_INVITATION_EXITS =
  '/organization/api/v3/check-invitation-exists/?invitation_token=';

//settings
export const GET_USER_DETAILS = '/users/api/v3/user-details/';
export const CHECK_ORG_NAME = '/organization/api/v3/check_org/';
export const CREATE_ORGANIZATION = '/organization/api/v3/details/';

// free trial
export const GET_DASHBOARD_ORGANIZATION_DETAILS_API =
  '/organization/api/v3/dashboard/organization-details/';

export const PERMISSIONS_API = '/organization/api/v3/permissions/';

// favourite
export const ADD_FAVOURITE_PROJECTS = '/organization/api/v3/my-projects/details/';
export const ADD_FAVOURITE_ROOM = '/rooms/api/v3/room-detail/';

// delete
export const PROJECT_DELETE = '/organization/api/v3/my-projects/details/';
export const PROJECT_MULTI_DELETE = '/organization/api/v3/delete-projects/';
export const ROOM_DELETE = '/organization/api/v3/room-detail/';

// material
// texture
export const GET_MATERIAL = '/organization/api/v3/material/detail/';
export const MATERIAL_API = '/material/api/v3/material/detail/';
export const OPTIMIZED_MATERIAL_API = '/material/api/v3/material/cache/detail/';
export const MATERIAL_TEXTURES_API = '/material/api/v3/get-material-textures/';

// texture
export const GET_TEXTURE = '/organization/api/v3/texture/detail/';
export const TEXTURE_API = '/texture/api/v3/texture/detail/v2/';
// export const TEXTURE_BULK_UPLOAD = '/texture/api/v3/texture/bulk-create/';
export const TEXTURE_BULK_UPLOAD = '/texture/api/v3/texture/bulk-create/v2/';
export const TEXTURE_PATH_UPLOAD = '/texture/api/v3/update-texture-path/';
export const GET_TEXTURE_PRESIGNED_DATA = '/texture/api/v3/texture/presigned-access/';
export const GET_PROP_DATA_USER_FILE_PRESIGNED = '/assetbundles/api/v3/get-prop-data-user-file-presigned/detail/';
export const TEXTURE_UPDATE = '/texture/api/v3/texture/detail/v2/';
export const TEXTURE_BULK_UPDATE = '/texture/api/v3/texture/update/';
export const TEXTURE_BULK_DELETE = '/texture/api/v3/delete-textures/';
export const TEXTURE_BULK_DELETE_ADMIN = '/texture/api/v3/admin/texture/delete/v2/';
export const TEXTURE_CHECK_VERSION = '/texture/api/v3/texture/version_check/';
export const DOWNLOAD_TEXTURE = '/texture/api/v3/lambda/texture/download/';
export const TEXTURE_IS_MAP_CHECK = '/texture/api/v3/texture/is_map_texture_check/';
export const TEXTURE_MAP_DETAIL = '/texture/api/v3/texture/map/detail/';
export const DOWNLOAD_XLSX_TEXTURE = '/texture/api/v3/download-sample-excel/';
export const GET_FILTER_OPTIONS = '/texture/api/v3/get-create-filter-options/';
export const PRODUCT_360_BULK_UPLOAD = '/assetbundles/api/v3/prod-multi-viewer-create/';
export const GET_PRODUCT_360_IMAGES = '/assetbundles/api/v3/prod-multi-viewer/';
export const GET_PRODUCT_360_IMAGES_PUBLIC = '/assetbundles/api/v3/public-prod-multi-viewer/';
export const GET_PRODUCT_RENDERS = '/rendering-system/api/v3/get-products-render-images/';
export const ADD_PRODUCT_RENDER = '/assetbundles/api/v3/prod-room-type/';
export const ADD_PRODUCT_RENDER_PUBLIC = '/assetbundles/api/v3/public-prod-room-type/';
export const SINGLE_DELETE_PRODUCT_IMAGES = '/assetbundles/api/v3/prod-room-type/';
export const MULTIPLE_DELETE_PRODUCT_IMAGES = '/assetbundles/api/v3/prod-room-type-multi-delete/';
export const SILOS_OR_LIFESTYLE_PRODUCT_ORDER_UPDATE = '/assetbundles/api/v3/prod-room-type-order/';
export const GET_PRODUCT_SHARE_DETAILS = '/assetbundles/api/v3/create-product-viewer-public/';
export const GET_TEXTURE_SHARE_DETAILS = '/texture/api/v3/create-texture-viewer-public/';
export const UPDATE_PRODUCT_IMAGE_NAME = '/assetbundles/api/v3/prod-room-type/';
export const CHECK_PACK_PRODUCT = '/assetbundles/api/v3/check-pack-product/';

// texture admin

export const ADMIN_TEXTURE_API = '/assetbundles/api/v3/texture/products/detail/';

// preset camera (curator)
export const PRESET_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/';
export const PRESET_CAMERA_IMPORT = '/organization/api/v3/import_camera_angle/';
// export const GET_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/'
// export const CREATE_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/'
// export const UPDATE_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/'
// export const DELETE_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/'

// project camera (curator)
export const PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';
export const GET_PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';
export const CREATE_PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';
export const UPDATE_PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';
export const DELETE_PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';

// images (curator) - render

// rendering-system/api/v3/images-render-detail/?parent_id=148
export const DOWNLOAD_RENDER = '/rendering-system/api/v3/lambda/download-renders/';
export const CREATE_3D_FILES_ZIP = '/rendering-system/api/v3/get-3d-zip-file/';
export const GET_3D_FILES_ZIP = '/assetbundles/api/v3/download-3d-zip-file/';
export const GET_RENDER_PREVIEW_DATA = '/rendering-system/api/v3/project-render-images/';
export const UPDATE_RENDER_PREVIEW = '/rendering-system/api/v3/project-render-images/';
// rendering-system/api/v3/images-render-detail/?parent_id=148
export const GET_CAMERA_INFO = '/rendering-system/api/v3/images-render-detail/';
export const CREATE_RENDER = '/rendering-system/api/v3/render-detail/';
export const DELETE_RENDER = '/rendering-system/api/v3/images-render-detail/';
export const DOWNLOAD_RENDER_IMAGE = '/rendering-system/api/v3/lambda/download-renders/';
export const DOWNLOAD_OLD_RENDER_PROJECT_ZIP =
  '/rendering-system/api/v3/get-old-zip-file-from-project-render/:renderId';
// export const CREATE_RENDER = '/rendering-system/api/v3/render-detail/'
// export const CREATE_RENDER = '/rendering-system/api/v3/render-detail/'
export const GET_RENDER_BY_PROJ_RENDER_ID =
  '/rendering-system/api/v3/get-render-based-on-project-render-id/';
export const UPLOAD_RENDER_IMAGES = '/rendering-system/api/v3/upload-images/';
export const GLOBAL_RENDERING_INFO = '/rendering-system/api/v3/global-rendering-info/';

export const CREATE_AUTOMATION = '/image_automation/api/v2/create-automation/';

export const RETRY_RENDER = '/rendering-system/api/v3/project-render-images-retry/';
export const MULTIPLE_ARCHIVED_RENDER_RESTORE =
  '/rendering-system/api/v3/restore-multiple-archive-projectrender/';

// render & preview//
export const GET_RENDER_PREVIEW = '/rendering-system/api/v3/project-render-images/';
export const GET_DOWNLOAD_RENDER_IMAGES = '/rendering-system/api/v3/lambda/download-renders/';
export const GET_RENDER_DATA = '/rendering-system/api/v3/get-render/';
// Filters
export const GET_FILTERS = '/users/api/v3/filters/';
export const FILTER_API = '/users/api/v3/filters/';
export const CREATE_FILTER_OPTION = '/users/api/v3/filters/';
export const FILTER_OPTION = '/users/api/v3/filters-option/';
export const GET_FILTERS_OPTIONS = '/users/api/v3/filters-option/';
export const BULK_UPDATE_FILTER_API = '/users/api/v3/bulk-update-filters/';

export const GET_GLOBAL_TAGS = '/organization/api/v3/global-tags/';

// share
export const CREATE_SHARE = '/share/api/v3/sharingmodels/';
export const SHARE_REQUEST_ACCESS = '/share/api/v3/sharing-request-access/';

//Transaction
export const GET_USER_BALANCE = '/images/api/organization-balance/';
export const PAYMENT_INTENT = '/images/api/create-payment-intent/';
export const TRANSACTION_HISTORY_STATUS = '/images/api/organization-transaction-history-status/';
export const TRANSACTION_HISTORY = '/images/api/organization-transaction-history/';
export const TRANSACTION_HISTORY_DOWNLOAD =
  '/images/api/download-organization-transaction-history/';
export const TRANSACTION_HISTORY_EMAIL_LIST = '/images/api/transaction-history-member-list/';
export const CHANGE_PASSWORD = '/users/api/v3/change-password/';
export const RENDERING_PRICE_INFO = '/rendering-system/api/v3/get-rendering-price-info/';

//Notification Settings
export const NOTIFICATION_SETTINGS = '/notifications/settings/';

// Notifications
export const GET_NOTIFICATIONS = '/notifications/';
export const GET_UNREAD_NOTIFICATIONS = '/notifications/unread/';
export const MARK_ALL_AS_READ_NOTIFICATIONS = '/notifications/mark-all-as-read/';
export const MARK_UNREAD_NOTIFICATION = '/notifications/mark-as-unread/';
export const MARK_AS_READ_NOTIFICATION = '/notifications/mark-as-read/';
export const DELETE_NOTIFICATION = '/notifications/delete/';
export const DELETE_ALL_NOTIFICATIONS = '/notifications/delete-all/';
export const READ_SPECIFIC_NOTIFICATION = '/notifications/read-specific/?ids=';
export const MARK_ALL_NOTIFICATION_AS_NEW = '/notifications/mark-all-as-new/';

// collection
export const COLLECTION_DETAILS_API = '/organization/api/v3/collections/details/';
export const ADD_TO_COLLECTIONS = '/organization/api/v3/multiple/collections/models/';
export const COLLECTION_UPDATE = '/organization/api/v3/collections/details/:collectionId/';
export const COLLECTION_DATA_API = '/organization/api/v3/collections/models/';
export const REMOVE_FROM_COLLECTION_API = '/organization/api/v3/delete-collectionitems/';
export const COLLECTION_MULTI_DELETE = '/organization/api/v3/delete-collections/';

// organization
export const GET_MY_ORGANIZATIONS = '/organization/api/v3/my-orgs/';
export const SWITCH_ORG = '/users/api/v3/change-org/';
export const CHECK_MEMBER_PERMISSIONS = '/organization/api/v3/check-member-permisions/';
export const CHECK_MEMBER_PERMISSIONS_CACHED_API =
  '/organization/api/v3/check-member-permisions/v2/';
export const GET_MEMBER_ORG_PERMISSIONS = '/organization/api/v3/get-assigned-permissions/';
export const GET_ONLY_ORG_PERMISSIONS = '/organization/api/v3/get-assigned-org-permissions/';

// trash
export const TRASH_LIST = '/organization/api/v3/trash-list/';
export const RESTORE_ROOM = '/organization/api/v3/restore/rooms/';
export const RESTORE_TEXTURE = '/organization/api/v3/restore/textures/';
export const RESTORE_UPLOADS = '/organization/api/v3/restore/uploads/';
export const RESTORE_PROJECT = '/organization/api/v3/restore/projects/';
export const RESTORE_PROJECT_PREVIEW = '/organization/api/v3/restore/project_previews/';
export const RESTORE_COLLECTION = '/organization/api/v3/restore/collection/';
export const RESTORE_AUTOMATION = '/organization/api/v3/restore/automation/';
export const RESTORE_CONFIGURATOR = '/organization/api/v3/restore/configurator/';
export const RESTORE_IMAGINE_AI = '/organization/api/v3/restore/aiimages/';
export const FOREVER_ROOM_DELETE = '/organization/api/v3/hard-delete/rooms/';
export const FOREVER_TEXTURE_DELETE = '/organization/api/v3/hard-delete/textures/';
export const FOREVER_UPLOADS_DELETE = '/organization/api/v3/hard-delete/uploads/';
export const FOREVER_PROJECT_DELETE = '/organization/api/v3/hard-delete/projects/';
export const FOREVER_PROJECT_PREVIEW_DELETE = '/organization/api/v3/hard-delete/project_previews/';
export const FOREVER_COLLECTION_DELETE = '/organization/api/v3/hard-delete/collection/';
export const FOREVER_AUTOMATION_DELETE = '/organization/api/v3/hard-delete/automation/';
export const FOREVER_CONFIGURATOR_DELETE = '/organization/api/v3/hard-delete/configurator/';
export const FOREVER_IMAGINE_AI_DELETE = '/organization/api/v3/hard-delete/aiimages/';
export const FOREVER_RETAIL_AUTOMATION_DELETE =
  '/organization/api/v3/hard-delete/retail_automation/';
export const EMPTY_TRASH = '/organization/api/v3/hard-delete/empty-trash/';
export const RESTORE_ALL_TRASH = '/organization/api/v3/restore-all/';
export const RESTORE_RETAIL_AUTOMATION = '/organization/api/v3/restore/retail_automation/';
export const FOREVER_MATERIAL_DELETE = '/organization/api/v3/hard-delete/materials/';
export const RESTORE_MATERIAL = '/organization/api/v3/restore/materials/';

// light
export const LIGHT_API = '/organization/api/v3/environment-light-detail/';

export const LOA_MAPPED_HDRI_LIGHT_API = '/organization/api/v3/get-live-on-app-environmentlight/';

// inspiration
export const GET_INSPIRATION = '/organization/api/v3/inspiration/';
// Shared Files
export const GET_SHARED_FILES = '/share/api/v3/sharingmodels/';
export const GET_MEMBERS_LIST_API = '/share/api/v3/all-sharing-member-details/';
export const GET_SHARING_OUTSIDE_MEMBERS_LIST_API =
  '/share/api/v3/all-sharing-outside-member-details/';
export const DELETE_SHARED_MODEL = (id) => `/share/api/v3/sharingmodels/${id}/`;
export const DELETE_SHARED_DETAILS = (id) => `/share/api/v3/sharingdetails/${id}/`;
export const GET_ORG_LIST = '/share/api/v3/search-organization-details/';
export const SHARE_MODEL = '/share/api/v3/sharingmodels/';
export const SHARE_MULTIPLE_MODEL_TYPE = '/share/api/v3/multiple-sharingmodels/';
export const GET_PERMISSION_FOR_SHARE = '/share/api/v3/sharing-owner-permissions/';
export const GET_SHARED_FILES_TO_MEMBER_LIST = '/share/api/v3/sharing-member-details/';
export const GET_SHARED_FILES_TO_ORGANIZATION_LIST =
  '/share/api/v3/sharing-organization-owner-details/';
export const REMOVE_USER_FROM_SHARED_FILE = '/share/api/v3/remove-user-to-sharing/';
export const GET_SHARING_USER_DETAILS = '/share/api/v3/get-sharing-user-details/';

export const GET_SEARCH_MEMBER_DETAIL = '/share/api/v3/search-member-details/';
export const GET_SEARCH_MEMBER_ORG_DETAIL = '/share/api/v3/search-organization-details/';

// support
export const GET_SUPPORT_PIPELINES = '/support/api/v3/get-all-pipeline/';
export const CREATE_TICKET = '/support/api/v3/raise-ticket/';
export const GET_TICKET = '/support/api/v3/raise-ticket/';
export const CREATE_TICKET_MESSAGE = '/support/api/v3/ticket-messages/';
export const TICKET_FEEDBACK = '/support/api/v3/ticket-feedback/';

export const SUPPORT_REQUEST_MISSING_TEMPLATES = '/share/api/v3/support-request-missing-templates/';

// curator
export const GET_SHORTKEY = '/users/api/v3/shortkey/';

// automation
export const DOWNLOAD_AUTOMATION = '/image_automation/api/v2/download-automation-zip/'; //TODO: Need to change this path
export const MULTIPLE_ARCHIVED_AUTOMATION_RESTORE =
  '/image_automation/api/v2/automation-unarchive/'; //TODO: Need to change this path
export const UPDATE_AUTOMATION = '/rendering-system/api/v3/project-render-images/'; //TODO: Need to change this path

export const AUTOMATION_TEMPLATE_FILE_UPLOAD =
  '/image_automation/api/v2/upload-automation-action-file/';

// onboarding - gamified
export const CREATE_GAMIFY_RENDER = '/gamify/api/create-render/';
export const APP_FEEDBACK = '/gamify/api/user-feedback/';
export const TUTORIAL_ROOMS = '/gamify/api/tutorial-room/';
export const SHARE_IMAGE = '/gamify/api/share-image/';
export const TUTORIAL_ROOM_STATE = '/gamify/api/tutorial-room-state/';
export const TEXTURE_FINISHES = '/texture/api/v3/get-tile-finish/';
export const PUBLIC_LINK = '/assetbundles/api/v3/public-link/';
export const PUBLIC_LINK_TEXTURE = '/texture/api/v3/public-link/';
export const PUBLIC_LINK_PUBLIC = '/assetbundles/api/v3/public-ar-link/';
export const PUBLIC_LINK_OPENED = '/assetbundles/api/v3/public-link-opened/';
export const PUBLIC_PRODUCT_LINK = '/assetbundles/api/v3/get-public-link/';
export const PUBLIC_PRODUCT_LINK_DATA = '/assetbundles/api/v3/public-product-link/';
export const PUBLIC_TEXTURE_LINK_DATA = '/texture/api/v3/public-texture-link/';
export const PUBLIC_PRODUCT_VIDEO_LINK_DATA = '/video/api/public-product-link/';
export const PUBLIC_TEXTURE_VIDEO_LINK_DATA = '/video/api/public-texture-link/';
export const PUBLIC_PRODUCT_PAGE_V2_USER_ACCESS =
  '/organization/api/v3/product-page/product-page-access-details/';
export const PRODUCT_PAGE_V2_ACCESS_TYPE_PERMISSION =
  '/organization/api/v3/product-page/product-page-public-access/';
export const PUBLIC_PRODUCT_PAGE_V2_ACCESS_TYPE_PERMISSION =
  '/organization/api/v3/product-page/public-access-details/';
export const GET_SHARED_PRODUCT_PAGE_LIST_VIA_EMAIL_API =
  '/organization/api/v3/product-page/share-to-email-listing/';

// subscription - begins

export const SUBSCRIPTION_FAQS = '/subscription/api/faq/';
export const SUBSCRIPTION_CARD_DETAILS = '/subscription/api/card-details/';
export const SUBSCRIPTION_FEATURES = '/subscription/api/subscription_features/';
export const SUBSCRIPTION_PRICE_FEATURE_PRODUCT =
  '/subscription/api/subscription_price_feature_product/';
export const SUBSCRIPTION_PI_ONE_TIME_PRODUCT =
  '/payment-intent-one-time-product/subscription_webhooks/';
export const SUBSCRIPTION_ADD_ON_PRODUCT = '/subscription/api/get-add-on-products/';
export const SUBSCRIPTION_ADD_ON_PRODUCT_USED_COUNT =
  '/subscription/api/get-add-on-products-used-count';
export const SUBSCRIPTION_PRODUCT_USED_COUNT = '/subscription/api/product-used-count/';
export const SUBSCRIPTION_ALL_PRODUCT_USED_COUNT = '/subscription/api/all-product-used-count/';
export const SUBSCRIPTION_REMOVE_CUSTOMER_PRODUCT = '/subscription/api/remove-customer-product/';
export const SUBSCRIPTION_LINK_EDITOR = '/subscription/api/link-editor/';
export const SUBSCRIPTION_MULTIPLE_LINK_EDITOR = '/subscription/api/link-editor-multiple/';
export const SUBSCRIPTION_LINK_PRODUCT = '/subscription/api/link-product/';
export const SUBSCRIPTION_DOWNGRADE_PRODUCT_COUNT = '/subscription/api/downgrade-product-count/';
export const SUBSCRIPTION_CART_DETAILS = '/subscription/api/cart-details/';

export const SUBSCRIPTION_MAIN_PLANS = '/subscription/api/main_subscription_plans/';

export const SUBSCRIPTION_PRODUCT = '/subscription/api/subscription_product/';
export const SUBSCRIPTION_PRICE = '/subscription/api/subscription_price/';
export const SUBSCRIPTION_CLIENT = '/subscription/api/client_subscription/';
export const SUBSCRIPTION_CLIENT_V2 = '/subscription/api/v2/client_subscription/';
export const SUBSCRIPTION_FEATURE_PRODUCT = '/subscription/api/feature_product/';
export const SUBSCRIPTION_DOWNGRADE_MISSING_FEATURE_LIST =
  '/subscription/api/downgrade-missing-product/';
export const SUBSCRIPTION_BUY_ONE_TIME_ADD_ONS =
  '/subscription/api/payment-intent-one-time-product/';
export const SUBSCRIPTION_PRO_RATA_PRICE = '/subscription/api/upcoming_invoice_amount/';
export const SUBSCRIPTION_PRO_RATA_PRICE_V2 = '/subscription/api/v2/upcoming_invoice_amount/';

export const SUBSCRIPTION_MAIN_PLAN_PRO_RATA_PRICE =
  '/subscription/api/upcoming_invoice_amount_for_main_plan/';
export const SUBSCRIPTION_PURCHASED_ADD_ONS_LIST =
  '/subscription/api/get-add-on-products-usage-and-quantity/';
export const SUBSCRIPTION_PRODUCT_USAGE_HISTORY = '/subscription/api/product-usages/';
export const SUBSCRIPTION_PRODUCT_LIST_CLIENT =
  '/subscription/api/subscription_product_client_side/';
export const SUBSCRIPTION_PRODUCT_VARIANCE_COUNT =
  '/subscription/api/get-variation-variants-count/';
export const SUBSCRIPTION_SETUP_INTENT = '/subscription/api/set-up-intent/';
export const SUBSCRIPTION_CHECK_DOWNGRADE = '/subscription/api/check_downgrade/';

export const SUBSCRIPTION_LINK_PRODUCT_DATA = '/subscription/api/link-product-data/';
export const SUBSCRIPTION_LINK_PRODUCT_CHECK_STATUS =
  '/subscription/api/check-link-product-status/';
export const SUBSCRIPTION_LINK_PRODUCT_CHECK_STATUS_V2 =
  '/subscription/api/check-link-product-status/v2/';
export const SUBSCRIPTION_LINK_TEXTURE_CHECK_STATUS =
  '/subscription/api/check-link-texture-status/';
export const SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS = '/video/api/details/';
export const SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS_ORDER = '/video/api/order/';
export const SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS = '/ai_video/api/details/';
export const SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS = '/product_viewer/api/details/';
export const SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS = '/product_viewer/api/details/'; // TODO: update the API path when we get the API for 3D Viewer
export const SUBSCRIPTION_CONFIGURATOR_LINK_PRODUCT_DETAILS = '/configurator/api/details/';
export const SUBSCRIPTION_CONFIGURATOR_LINK_TEXTURE_DETAILS = '/configurator/api/texture-details/';
export const SUBSCRIPTION_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC = '/video/api/public/details/';
export const SUBSCRIPTION_VIDEO_LINK_TEXTURE_DETAILS_PUBLIC = '/video/api/public/texture-details/';
export const SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC = '/ai_video/api/public/details/';
export const SUBSCRIPTION_AI_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC_V2 =
  '/ai_video/api/public/details/v2/';
export const SUBSCRIPTION_AI_VIDEO_LINK_TEXTURE_DETAILS_PUBLIC =
  '/ai_video/api/public/texture-details/';
export const SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC =
  '/product_viewer/api/public/details/';
export const SUBSCRIPTION_PRODUCT_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC_V2 =
  '/product_viewer/api/v2/public/details/';
export const SUBSCRIPTION_PRODUCT_VIEWER_LINK_TEXTURE_DETAILS_PUBLIC_V2 =
  '/product_viewer/api/v2/public/texture-details/';
export const SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC =
  '/product_viewer/api/public/details/'; // TODO: update the API path when we get the API for 3D Viewer
export const SUBSCRIPTION_THREED_VIEWER_LINK_PRODUCT_DETAILS_PUBLIC_V2 =
  '/product_viewer/api/v2/public/3d-viewer/details/';
export const SUBSCRIPTION_THREED_VIEWER_LINK_TEXTURE_DETAILS_PUBLIC_V2 =
  '/product_viewer/api/v2/public/texture-3d-viewer/details/';
export const SUBSCRIPTION_CONFIGURATOR_LINK_PRODUCT_DETAILS_PUBLIC =
  '/configurator/api/public/details/';
export const SUBSCRIPTION_CONFIGURATOR_LINK_TEXTURE_DETAILS_PUBLIC =
  '/configurator/api/public/texture-details/';
export const VIDEO_PUBLIC_LINK_PRODUCT = '/video/api/public-link/';
export const VIDEO_PUBLIC_LINK_TEXTURE = '/video/api/public-texture-link/';
export const VIDEO_PUBLIC_CREATE_LINK_TEXTURE = '/video/api/create-texture-link/';
export const CANCEL_INVOICE_URL = '/subscription/api/cancel-subscription/';

export const SUBSCRIPTION_GIF_LINK_PRODUCT_DETAILS = '/assetbundles/api/v3/prod-gif-upload/';
export const SUBSCRIPTION_GIF_LINK_PRODUCT_DETAILS_PUBLIC =
  '/assetbundles/api/v3/public-prod-gif-image/';
export const SUBSCRIPTION_IMAGES_LINK_PRODUCT_DETAILS =
  '/assetbundles/api/v3/product-image-upload/';
export const SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS = '/video/api/panning-video/';
export const SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS_ORDER = '/panning-video/api/order/';
export const SUBSCRIPTION_PANNING_VIDEO_LINK_PRODUCT_DETAILS_PUBLIC =
  '/video/api/public/panning-video/';
export const SUBSCRIPTION_CLIENT_UPLOAD_LIMIT =
  '/subscription/api/client_subscription_upload_limit/';

export const SUBSCRIPTION_CONFIGURATOR_DEDUCT = '/configurator/api/v2/deduct/';
export const SUBSCRIPTION_GET_IMAGINE_CREDIT = '/subscription/api/get-imagine-credit/';

export const CREDIT_FORM = '/subscription/api/get-imagine-service-info/';
export const SUBSCRIPTION_IMAGINE_CREDIT_PRODUCT_COUNT_DEDUCT = '/subscription/api/deduct-credit/';

// subscription - end
// Request
export const REQUEST_API = '/request/api/request-details/';
export const REQUEST_3D_UPLOAD_API = '/request/api/request-three-d-file-upload/';
export const REQUEST_GET_IMAGES_API = '/request/api/request-three-d-file/';
export const REQUEST_PARTS_API = '/request/api/request-three-d-part/';
export const REQUEST_TEXTURE_UPLOAD_API = '/request/api/seating-texture-upload/';
export const REQUEST_TEXTURE_GET_API = '/request/api/seating-texture-get/';
export const REQUEST_PRODUCT_CATEGORY_API = '/request/api/product-category/';
export const REQUEST_COMMENT_API = '/request/api/comment/';
export const REQUEST_FEEDBACK_API = '/request/api/request-feedback/';
export const REQUEST_SUBMIT_API = '/request/api/submit-request/';
export const REQUEST_INJECT_API = '/subscription/api/link-model-product/';
export const MATTRESS_BUILDER_SAVE_AND_MODAL_LIMIT_COUNT_DEDUCT_API =
  '/assetbundles/api/v3/product-group-mattress-builder/';

export const HUBSPOT_API = 'https://bc3ifvzhw5llv4nywfuqsdig2m0aarmr.lambda-url.us-east-1.on.aws';
export const HUSBPOT_VISITOR_IDENTIFICATION_API =
  '/users/api/v3/get-hubspot-visitor-identification-token/';

export const SET_PREVIEW_CONFIGURATOR = '/configurator/api/scene-texture-preview/';
export const SET_PREVIEW_CONFIGURATOR_V2 = '/configurator/api/v2/scene-texture-preview/';
export const SET_PREVIEW_RENDER_CONFIGURATOR = '/configurator/api/scene-texture-render/';
export const SET_PREVIEW_RENDER_CONFIGURATOR_V2 = '/configurator/api/v2/scene-texture-render/';

export const SET_PREVIEW_FABRIC_CONFIGURATOR = '/configurator/api/scene-texture-fabric-preview/';
export const GET_PREVIEW_LIST_DATA = '/configurator/api/render-store-list/';
export const GET_PREVIEW_LIST_DATA_V2 = '/configurator/api/v2/render-store-list/';

// Automatic AI Video
export const AUTOMATIC_AI_VIDEO = '/ai_video/api/auto-ai-video/';
export const AUTOMATIC_AI_VIDEO_ORDER = '/ai_video/api/auto-ai-video-order/';
export const AUTOMATIC_AI_VIDEO_PREVIEWS = '/rendering-system/api/v3/auto-aivideo-previews/';
export const AUTOMATIC_AI_VIDEO_RENDER = '/rendering-system/api/v3/auto-aivideo-render-job/';
export const AUTOMATIC_AI_VIDEO_RE_RENDER = '/rendering-system/api/v3/rerender-aivideo-previews/';
export const AUTOMATIC_AI_VIDEO_RE_RENDER_RENDER =
  '/rendering-system/api/v3/rerender-aivideo-final/';
export const AUTOMATIC_AI_VIDEO_CANCEL_RENDER = '/ai_video/api/cancel-auto-ai-video-render/';

// image search api
export const IMAGE_SEARCH_API = '/searchables/api/v3/searchb64/';
// Guest user api
export const CHECK_GUEST_USER_PERMISSION = '/users/api/v3/check-guest-user-permission/';
export const MEASUREMENT_DETAILS = '/rendering-system/api/v3/images-render-measurement-details/';
export const PUBLIC_MEASUREMENT_DETAILS =
  '/rendering-system/api/v3/images-render-measurement-details/public/';
export const PUBLIC_MEASUREMENT_DETAILS_SHARE =
  '/rendering-system/api/v3/images-render-measurement-details/public-share/';
export const UPDATE_MEASUREMENT_STATUS =
  '/rendering-system/api/v3/update-image-measurement-status/';

// props grouping API
export const UPDATE_PROPS_GROUP_ARCHIVE = '/assetbundles/api/v3/products/detail/archive/';
// Texture and model delete and restore API
export const TEXTURE_DELETE_OR_RESTORE_API = '/texture/api/v3/multiple-delete-textures-v2-detail/';
export const MODEL_DELETE_OR_RESTORE_API =
  '/assetbundles/api/v3/multiple-delete-product-v2-detail/';
export const MODEL_DELETE_ADMIN_API = '/assetbundles/api/v3/admin/product/delete/v2/';
export const SIGNUP_CONVERT_USER = '/users/api/v3/convert-demo/';

// userpilot API
export const USERPILOT_API = '/users/api/v3/userpilot/onboard-data/';

// product v2 revamp API
export const PRODUCT_V2_DETAILS_UPDATE =
  '/assetbundles/api/v3/product-page/:productId/products/detail/:productId/';
export const PRODUCT_V2_CATEGORIES = '/assetbundles/api/productpage/';
export const TEXTURE_V2_CATEGORIES = '/texture/api/texturepage/';
export const PRODUCT_V2_CATEGORIES_PUBLIC = '/assetbundles/api/public/productpage/';
export const TEXTURE_V2_CATEGORIES_PUBLIC = '/texture/api/public/texturepage/';
export const PRODUCT_V2_CATEGORIES_BULK_UPDATE = '/assetbundles/api/productpage/:id/bulk-update/';
export const TEXTURE_V2_CATEGORIES_BULK_UPDATE = '/texture/api/texturepage/:id/bulk-update/';
export const PRODUCT_V2_CATEGORIES_IMAGE_CONTENT =
  '/assetbundles/api/v4/product/:id/product-render/';
export const PRODUCT_V2_CATEGORIES_IMAGE_CONTENT_PUBLIC =
  '/assetbundles/api/v4/public-product/product-render/';
export const TEXTURE_V2_CATEGORIES_IMAGE_CONTENT = '/texture/api/v4/texture/:id/texture-render/';
export const TEXTURE_V2_CATEGORIES_IMAGE_CONTENT_PUBLIC =
  '/texture/api/v4/public-texture/texture-render/';
export const PRODUCT_V2_CATEGORIES_IMAGE_CONTENT_UPDATE =
  '/assetbundles/api/v4/product/:id/product-render-bulk-update/';
export const TEXTURE_V2_CATEGORIES_IMAGE_CONTENT_UPDATE =
  '/texture/api/v4/texture/:id/texture-render-bulk-update/';
export const PRODUCT_V2_CATEGORIES_IMAGE_CONTENT_DELETE =
  '/assetbundles/api/v4/product/:id/product-render/:content_id/';
export const TEXTURE_V2_CATEGORIES_IMAGE_CONTENT_DELETE =
  '/texture/api/v4/texture/:id/texture-render/:content_id/';

export const PRODUCT_V2_IMAGES_UPLOAD = '/assetbundles/api/v4/product/:id/product-render-upload/';
export const TEXTURE_V2_IMAGES_UPLOAD = '/texture/api/v4/texture/:id/texture-render-upload/';
export const PRODUCT_V2_IMAGES_MULTI_DELETE =
  '/assetbundles/api/v4/product/:id/product-render-multi-delete/';
export const TEXTURE_V2_IMAGES_MULTI_DELETE =
  '/texture/api/v4/texture/:id/texture-render-multi-delete/';

export const PRODUCT_V2_GIF_UPLOAD = '/assetbundles/api/v4/product/:id/product-gif-upload/';
export const TEXTURE_V2_GIF_UPLOAD = '/texture/api/v4/texture/:id/texture-gif-upload/';
export const PRODUCT_V2_GIF_MULTI_DELETE =
  '/assetbundles/api/v4/product/:id/product-gif-multi-delete/';
export const TEXTURE_V2_GIF_MULTI_DELETE = '/texture/api/v4/texture/:id/texture-gif-multi-delete/';

export const PRODUCT_V2_VIDEO_UPLOAD_URL = '/video/api/client/details/';
export const PRODUCT_V2_PANNING_VIDEO_UPLOAD_URL = '/video/api/client/panning-video/';
export const PRODUCT_V2_AI_VIDEO_UPLOAD_URL = '/ai_video/api/client/ai-video/';

export const PRODUCT_V2_CATEGORIES_GIF_CONTENT = '/assetbundles/api/v4/product/:id/product-gif/';
export const PRODUCT_V2_CATEGORIES_GIF_CONTENT_PUBLIC =
  '/assetbundles/api/v4/public-product/product-gif/';
export const TEXTURE_V2_CATEGORIES_GIF_CONTENT = '/texture/api/v4/texture/:id/texture-gif/';
export const TEXTURE_V2_CATEGORIES_GIF_CONTENT_PUBLIC =
  '/texture/api/v4/public-texture/texture-gif/';
export const PRODUCT_V2_CATEGORIES_GIF_CONTENT_UPDATE =
  '/assetbundles/api/v4/product/:id/product-gif-bulk-update/';
export const TEXTURE_V2_CATEGORIES_GIF_CONTENT_UPDATE =
  '/texture/api/v4/texture/:id/texture-gif-bulk-update/';
export const PRODUCT_V2_CATEGORIES_GIF_CONTENT_DELETE =
  '/assetbundles/api/v4/product/:id/product-render/:content_id/';
export const TEXTURE_V2_CATEGORIES_GIF_CONTENT_DELETE =
  '/texture/api/v4/texture/:id/texture-render/:content_id/';

export const PRODUCT_V2_CATEGORIES_VIDEO_CONTENT =
  '/assetbundles/api/v4/product/:id/product-video/';
export const PRODUCT_V2_CATEGORIES_VIDEO_CONTENT_PUBLIC =
  '/assetbundles/api/v4/public-product/product-video/';
export const TEXTURE_V2_CATEGORIES_VIDEO_CONTENT = '/texture/api/v4/texture/:id/texture-video/';
export const TEXTURE_V2_CATEGORIES_VIDEO_CONTENT_PUBLIC =
  '/texture/api/v4/public-texture/texture-video/';
export const PRODUCT_V2_CATEGORIES_VIDEO_CONTENT_UPDATE =
  '/assetbundles/api/v4/product/:id/product-video-bulk-update/';
export const TEXTURE_V2_CATEGORIES_VIDEO_CONTENT_UPDATE =
  '/texture/api/v4/texture/:id/texture-video-bulk-update/';
export const PRODUCT_V2_CATEGORIES_VIDEO_CONTENT_DELETE =
  '/assetbundles/api/v4/product/:id/product-video/:content_id/';
export const TEXTURE_V2_CATEGORIES_VIDEO_CONTENT_DELETE =
  '/texture/api/v4/texture/:id/texture-video/:content_id/';
export const PRODUCT_V2_VIDEO_MULTI_DELETE =
  '/assetbundles/api/v4/product/:id/product-video-multi-delete/';
export const TEXTURE_V2_VIDEO_MULTI_DELETE =
  '/texture/api/v4/texture/:id/texture-video-multi-delete/';

export const PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT =
  '/assetbundles/api/v4/product/:id/product-configurator/';
export const PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT_PUBLIC =
  '/assetbundles/api/v4/public-product/product-configurator/';
export const TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT =
  '/texture/api/v4/texture/:id/texture-configurator/';
export const TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT_PUBLIC =
  '/texture/api/v4/public-texture/texture-configurator/';
export const PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT_UPDATE =
  '/assetbundles/api/v4/product/:id/product-configurator-bulk-update/';
export const TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT_UPDATE =
  '/texture/api/v4/texture/:id/texture-configurator-bulk-update/';
export const PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT_DELETE =
  '/assetbundles/api/v4/product/:id/product-configurator/:content_id/';
export const TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT_DELETE =
  '/texture/api/v4/texture/:id/texture-configurator/:content_id/';
export const PRODUCT_V2_CONFIGURATOR_MULTI_DELETE =
  '/assetbundles/api/v4/product/:id/product-configurator-multi-delete/';
export const TEXTURE_V2_CONFIGURATOR_MULTI_DELETE =
  '/texture/api/v4/texture/:id/texture-configurator-multi-delete/';

export const PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT =
  '/assetbundles/api/v4/product/:id/product-360-viewer/';
export const PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT_PUBLIC =
  '/assetbundles/api/v4/public-product/product-360-viewer/';
export const TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT =
  '/texture/api/v4/texture/:id/texture-360-viewer/';
export const TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT_PUBLIC =
  '/texture/api/v4/public-texture/texture-360-viewer/';
export const PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT_UPDATE =
  '/assetbundles/api/v4/product/:id/product-360-viewer-bulk-update/';
export const TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT_UPDATE =
  '/texture/api/v4/texture/:id/texture-360-viewer-bulk-update/';
export const PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT_DELETE =
  '/assetbundles/api/v4/product/:id/product-360-viewer/:content_id/';
export const TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT_DELETE =
  '/texture/api/v4/texture/:id/texture-360-viewer/:content_id/';
export const PRODUCT_V2_360_VIEWER_MULTI_DELETE =
  '/assetbundles/api/v4/product/:id/product-360-viewer-multi-delete/';
export const TEXTURE_V2_360_VIEWER_MULTI_DELETE =
  '/texture/api/v4/texture/:id/texture-360-viewer-multi-delete/';

export const PRODUCT_V2_GENERATE_STATUS =
  '/assetbundles/api/v4/product/:id/product-generate-status-update/:id/';

export const TEXTURE_V2_GENERATE_STATUS =
  '/texture/api/v4/texture/:id/texture-generate-status-update/:id/';

export const PRODUCT_V2_DOWNLOAD_ZIP = '/assetbundles/api/v3/generate-content-zip/';
export const TEXTURE_V2_DOWNLOAD_ZIP = '/assetbundles/api/v3/generate-texture-content-zip/';
// captcha verify API
export const CAPTCHA_VALIDATION_API = '/users/api/v3/captcha-validation/';
export const CAPTCHA_V2_VALIDATION_API = '/users/api/v3/captcha-validation-v2/';

// onboard new user request
export const GET_ORG_REQUEST_LIST = '/organization/api/v3/get-organization-to-request/';
export const GET_ORG_SENT_REQUEST_LIST = '/organization/api/v3/organization-join-requests/';
export const GET_ALL_USER_ORG_REQUEST_LIST = '/organization/api/v3/all-user-based-organization/';
export const GET_ORG_REQUEST_STATUS = '/organization/api/v3/get-organization-join-request-status/';

export const SEND_ORG_REQUEST = '/organization/api/v3/send-organization-join-request/';
export const JOIN_ORG_REQUEST = '/organization/api/v3/organization-join-request-action/';
export const PRODUCT_BUILDER_RENDER_IMAGES =
  '/rendering-system/api/v3/get-product-builder-render-images/';

// Homepage
export const HOME_GET_PROP = '/assetbundles/api/v3/get-product-page-details/';
export const HOME_GET_TEXTURE = '/texture/api/v3/get-texture-page-v2-detail/';

export const CHECK_MATTRESS_AVAILIBILITY = '/subscription/api/v2/check-mattress-availability/';
export const ADD_CONFIGURATOR_LINK = '/configurator/api/client/add-product-data-v2/';
export const UPDATE_TEXTURE_CONFIGURATOR_LINK =
  '/texture/api/v4/texture/:textureid/texture-configurator/:id/';
export const UPDATE_PRODUCT_CONFIGURATOR_LINK =
  '/assetbundles/api/v4/product/:productid/product-configurator/:id/';

// API key get API
export const GET_API_KEY_API = '/users/api/v3/public/token/';
export const ALLOW_TEXTURE_TO_ALL = '/texture/api/v3/allow-texture-to-all/';

// Public / Secret API Key
export const GET_API_KEYS_API = '/users/api/v3/public/api-keys/';
export const CREATE_API_KEY_API = '/users/api/v3/public/api-key/';

// App Data API
export const APP_DATA_API = '/users/api/v3/app-data/';

// Scopes API
export const GET_SCOPES_API = '/users/api/v3/scopes/';

// Sync API
export const SALSIFY_SYNC_PRODUCT_IDS_API = '/assetbundles/api/salsify/sync-product-ids/';
export const SALSIFY_SYNC_ASSETS_API = '/assetbundles/api/salsify/sync-assets/';

// Salsify API
export const SALSIFY_ORG_DETAILS_API = '/organization/api/v3/salsify-org-details/';
export const SALSIFY_VERIFY_CONNECTION_API = '/organization/api/v3/salsify/verify-connection/';
export const SALSIFY_UPLOAD_ASSETS_API = '/assetbundles/api/v3/upload-assets-to-salsify/';

// Raindrop API
export const CREATE_RAINDROP_API = '/users/api/v3/raindrop/create-product-page/';
export const UPDATE_RAINDROP_API = '/users/api/v3/raindrop/update-product-page/';
export const SAVE_MATERIAL_PRESET = '/material/api/v3/material-save-detail/';
export const CREATE_MATERIAL_JOB = '/material/api/v3/material-job-detail/';
export const MULTIPLE_MATERIAL_DELETE = '/material/api/v3/multiple-material-delete/';
export const PRODUCT_SETUP_CRUD_API = '/assetbundles/api/v4/product-linked-data/';

// Page Viewed API
export const PAGE_VIEWED_EMAIL = '/users/api/v3/page-viewed-email/';

// Product page access permission
export const ADD_PERMISSION_ACCESS = '/organization/api/v3/product-page-access/permission/';
export const GET_SHARED_MEMBER_LIST = '/organization/api/v3/product-page-access/member-details/';
export const ASSIGN_SHARED_MEMBER_ACCESS_PERMISSION =
  '/organization/api/v3/product-page-access/assign-external-member/';

// product page analytics
export const PRODUCT_PAGE_VIEWED =
  '/assetbundles/api/v4/product-page-dashboard/public-products-views/';
export const PRODUCT_PAGE_DOWNLOADS =
  '/assetbundles/api/v4/product-page-dashboard/public-products-downloads/';
export const PRODUCT_PAGE_SHARE =
  '/assetbundles/api/v4/product-page-dashboard/public-products-shared/';
export const PRODUCT_PAGE_ENGAGEMENTS =
  '/assetbundles/api/v4/product-page-dashboard/public-products-engagements/';

// Render images
export const UPDATE_RENDER_IMAGE_CONFIG =
  '/rendering-system/api/v3/update-render-image-config/:id/';
  export const UPDATE_BULK_RENDER_IMAGE_CONFIG =
  '/rendering-system/api/v3/update-render-image-config/bulk/';

export const GET_PDP_PRODUCTS_VARIANTS_API = '/assetbundles/api/v3/get-pdp-products-variants/detail/';

export const getDataList = async (apiCallback) => {
  let response = await apiCallback();
  return response;
};

export function apiPatch(
  URL,
  data,
  label = null,
  successMessage = null,
  errorMessage = null,
  isFormData = true,
  showMessage = true,
  callErrorHandler = true
) {
  let formData = data;
  if (isFormData) {
    formData = objectToFormData(data);
  }

  return api()
    .root(API_ROOT_URL)
    .patch(URL)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        if (showMessage) {
          errorToast(errorMessage);
        }
      } else if (callErrorHandler && error) {
        apiErrorHandler(error, label);
      }
      return error;
    })
    .send();
}

export function apiDelete(URL, label = null, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .delete(URL)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      } else if (error) {
        apiErrorHandler(error, label);
      }
      return error;
    })
    .send();
}

export function apiMultiDelete(
  URL,
  formData,
  label = null,
  successMessage = null,
  errorMessage = null
) {
  return api()
    .root(API_ROOT_URL)
    .delete(URL)
    .data(formData)
    .requestConfig({
      messages: {
        400: errorMessage,
      },
    })
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error, { status }) => {
      if (status === 400) return;

      if (errorMessage) {
        errorToast(errorMessage);
      }
      throw error;
    })
    .accessDenied403((err) => {
      // console.log("err: ", err)
      throw err;
    })
    .send();
}

function apiMultiRestore(URL, formData, label = null, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .patch(URL)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, label);
    })
    .send();
}

function apiMultiPost(URL, formData, label = null, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .post(URL)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, label);
    })
    .send();
}

export function apiPut(URL, formData, label = null, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .put(URL)
    .data(formData)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, label);
    })
    .send();
}

export function apiGet(URL, label = null, successMessage = null, errorMessage = null, hideToast) {
  return api()
    .root(API_ROOT_URL)
    .get(URL)
    .requestConfig({
      messages: {
        400: errorMessage,
        hideTost: label === 'hideToast' || hideToast,
      },
    })
    .success((data) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
    })
    .send();
}

function apiGetBlob(URL, label = null, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .getBlob(URL)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, label);
    })
    .send();
}

export const apiGetBlobV2 = (url, fileName, { auth } = {}) => {
  return download({
    fileUrl: `${API_ROOT_URL}${url}`,
    fileName,
    auth,
  });
};

function apiPostBlob(URL, payload, label = null, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .postBlob(URL, payload)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, label);
    })
    .send();
}

export function apiPostV2(
  url,
  { data, isFormData = true, successMessage, errorMessage, successDescription, showMessage = true }
) {
  let formData = data;
  const isPayloadFormData = formData instanceof FormData;
  if (isFormData && !isPayloadFormData) {
    formData = objectToFormData(data);
  }

  return api()
    .root(API_ROOT_URL)
    .post(url)
    .data(formData)
    .success((data) => {
      if (successMessage) {
        successToastV2(successMessage, successDescription);
      }

      return data;
    })
    .error((error, errorDetails) => {
      // 500 error message toast is already handled
      if (!error.status && showMessage) {
        if (error?.message) {
          let keys = Object.keys(error.message);
          if (keys?.length) {
            const message = error?.message?.[keys[0]]?.[0];
            if (message) {
              errorToast(message);
            }
          }
        }
      } else if (errorDetails?.status !== 500 && errorMessage) {
        errorToastV2(errorMessage);
      } else {
        return error;
      }

      return error;
    })
    .authFail401((res) => {});
}

export function apiDeleteV2(
  url,
  { successMessage, errorMessage, successDescription, showErrorToast = true } = {}
) {
  return api()
    .root(API_ROOT_URL)
    .delete(url)
    .success((data) => {
      if (successMessage) {
        successToastV2(successMessage, successDescription);
      }

      return data;
    })
    .error((error, errorDetails) => {
      // 500 error message toast is already handled
      if (!error.status) {
        if (error?.data) {
          let keys = Object.keys(error.data);
          if (keys?.length) {
            const message = error?.data?.[keys[0]]?.message;
            if (message && showErrorToast) {
              errorToast(message);
            }
          }
        }
      } else if (errorDetails?.status !== 500 && errorMessage) {
        errorToastV2(errorMessage);
      } else {
        return error;
      }
    })
    .authFail401((res) => {});
}

export function apiPost(
  URL,
  payload,
  label = null,
  successMessage = null,
  errorMessage = null,
  isFormData = true,
  callback,
  successDescription
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (isFormData && !isPayloadFormData) {
    formData = objectToFormData(payload);
  }
  return api()
    .root(API_ROOT_URL)
    .post(URL)
    .data(formData)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage, successDescription);
      }
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      // apiErrorHandler(error, label);
      if (callback) {
        callback(error);
      }
      return error;
    })
    .authFail401((res) => {})
    .send();
}

window.apiPost = apiPost;
window.apiPatch = apiPatch;

// commenting because require some testing
// .send((...res) => {
//   const message = res[0].data?.message;
//   errorToast(typeof(message) === "string" ? message : message?.detail);
// });

export function apiFilterLabels(query = null, successMessage = null, errorMessage = null) {
  const URL = query !== null ? `${GET_FILTERS}?${query}` : GET_FILTERS;
  return apiGet(URL, 'apiFilterLabels', successMessage, errorMessage);
}

export function apiFilterOptions(query = null, successMessage = null, errorMessage = null) {
  const URL = query !== null ? `${GET_FILTERS_OPTIONS}?${query}` : GET_FILTERS;
  return apiGet(URL, 'apiFilterOptions', successMessage, errorMessage);
}

export function apiBulkUpdateFilter({ filters }) {
  const payload = new FormData();
  filters.forEach((filter) => {
    payload.append('id', filter.id);
    payload.append('order', filter.order);
  });

  return apiPatch(BULK_UPDATE_FILTER_API, payload, apiBulkUpdateFilter, null, null, false);
}

export function apiTeamMembers(payload, search) {
  const searchParams = objectToSearchParams(payload);
  const API_URL = `${GET_MEMBERS_API}?${searchParams}&search=${search || ''}`;
  return apiGet(API_URL, 'apiTeamMembers');
}

export const apiEditTeamMember = async (
  id,
  payload,
  successMessage = 'Member details updated successfully',
  errorMessage = null //'There was an error while updating details'
) => {
  return await apiPatch(
    `${GET_MEMBERS_API}${id}/`,
    payload,
    'apiEditTeamMember',
    successMessage,
    errorMessage,
    false
  );
};

export const apiUpdateStatusMultipleMember = async (
  payload,
  successMessage = 'Members are updated successfully.',
  errorMessage = null //'There was an error while updating details'
) => {
  return await apiPost(
    MEMBERS_MULTIPLE_API,
    payload,
    'apiUpdateStatusMultipleMember',
    successMessage,
    errorMessage,
    false
  );
};

export const apiSendInvite = async (payload, successMessage = null) => {
  let errorResponse = null;

  const result = await api()
    .root(API_ROOT_URL)
    .post(SEND_INVITE_API)
    .data(payload)
    .requestConfig({ messages: { hideTost: true } })
    .success((data) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return data;
    })
    .anyError((error) => {
      const errorCode = error?.response?.status;
      const errorMessage =
        error?.response?.data?.message || 'Something went wrong. Please try again.';

      if (errorCode === 429) {
        errorToast(errorMessage);
      }

      errorResponse = {
        status: false,
        message: errorMessage,
        errorCode,
      };
    })
    .send();

  return result ?? errorResponse;
};

export const apiDeleteInvite = async (
  id,
  successMessage = 'Invitation deleted successfully',
  errorMessage = 'something went wrong'
) => {
  return await apiDelete(
    `${DELETE_PENDING_INVITATION}${id}/`,
    'apiDeleteInvite',
    successMessage,
    errorMessage
  );
};

export function apiCheckUserInvitationExistence(query, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .get(`${CHECK_USER_INVITATION_EXITS}${query}`)
    .badRequest400(() => {})
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiGetPendingInviteTeamMember(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${GET_PENDING_LIST}?${query}`,
    'apiGetPendingInviteTeamMember',
    successMessage,
    errorMessage
  );
}

export async function apiGetPermissionsList(params) {
  return await apiGet(PERMISSIONS_API + `?${params}`);
}

// export function apiGetTeamMembers(search, userFilter, page = 1) {
//   let API_URL = GET_MEMBERS_API + `?${userFilter}=true&page=${page}`;
//   API_URL = API_URL + `&search=${search}`;
//   return apiGet(API_URL, 'apiTeamMembers');
// }
export function apiGetTeamMembers({ page, isMyOrg, search, perPage }) {
  const query = objectToSearchParams({ page, is_my_org: isMyOrg, search, per_page: perPage });
  return apiGet(`${GET_MEMBERS_API}?${query}`);
}

export function apiGetTeamMembersV4({ page, isMyOrg, search, perPage }) {
  const query = objectToSearchParams({ page, is_my_org: isMyOrg, search, per_page: perPage });
  return apiGet(`${GET_MEMBERS_API_V4}?${query}`);
}

export function apiToUpdateAccess({ id, name, configuratorName, accessType }) {
  // const query = objectToSearchParams({ id, configuratorId, accessType });
  successToast(`Configurator access changed to ${accessType} for ${name}[${id}].`);
  // return apiPost(`${GET_MEMBERS_API}?${query}`);
}

export function apiGetTeamMembersNew(query, successMessage = null, errorMessage = null) {
  return apiGet(`${GET_MEMBERS_API}?${query}`, 'apiGetTeamMembers', successMessage, errorMessage);
}

export async function apiGetGlobalTags({
  search = '',
  page = 1,
  perPage = 20,
  sort = 'name',
} = {}) {
  return await apiGet(
    `${GET_GLOBAL_TAGS}?search=${search}&page=${page}&per_page=${perPage}&sort=${sort}`
  );
}

export function apiCreateGlobalTag({ name }) {
  const payload = new FormData();
  payload.append('name', name);
  return apiPost(GET_GLOBAL_TAGS, payload, 'apiCreateGlobalTag');
}

export async function apiGetOrganisationList({
  search = '',
  page = 1,
  perPage = 20,
  sort = 'name',
  is_test_organization = false,
} = {}) {
  return await apiGet(
    `${ORGANISATION_DETAILS_API}?search=${search}&page=${page}&per_page=${perPage}&sort=${sort}${
      is_test_organization ? `&is_test_organization=true` : ''
    }`
  );
}

export function apiEditProject(
  id,
  payload,
  successMessage = 'Project updated successfully.',
  errorMessage = 'There was an issue updating this project.'
) {
  return apiPatch(
    PROJECT_UPDATE.replace(':projectId', id),
    payload,
    'apiEditProject',
    successMessage,
    errorMessage
  );
}

export function apiEditProjectV2({
  id,
  payload,
  successMessage = 'Project updated successfully.',
  errorMessage = 'There was an issue updating this project.',
}) {
  return apiPatch(
    PROJECT_UPDATE.replace(':projectId', id),
    payload,
    'apiEditProject',
    successMessage,
    errorMessage
  );
}

export function apiEditRenderPreview(
  id,
  payload,
  successMessage = 'Render/Preview updated successfully.',
  errorMessage = 'There was an issue updating this Render/Preview.',
  query = ''
) {
  // const param = id.includes('?') ? id : `${id}/`;

  return apiPatch(
    `${UPDATE_RENDER_PREVIEW}${id}/${query}`,
    payload,
    'apiEditRenderPreview',
    successMessage,
    errorMessage
  );
}

export function apiRetryRenderPreview(
  id,
  payload = {},
  successMessage = 'Render/Preview sent successfully.',
  errorMessage = 'There was an issue in retrying this Render/Preview.'
) {
  return apiPatch(
    `${RETRY_RENDER}${id}/`,
    payload,
    'apiRetryRenderPreview',
    successMessage,
    errorMessage
  );
}

export function apiRestoreMutipleArchivedRenders(payload, successMessage, errorMessage) {
  return api()
    .root(API_ROOT_URL)
    .patch(MULTIPLE_ARCHIVED_RENDER_RESTORE)
    .data(payload)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiRestoreMutipleArchivedRenders');
    })
    .send();
}

export function apiEditCollection(
  id,
  payload,
  successMessage = 'Collection updated successfully.',
  errorMessage = null
) {
  return apiPatch(
    COLLECTION_UPDATE.replace(':collectionId', id),
    payload,
    'apiEditCollection',
    successMessage,
    errorMessage
  );
}

export function apiEditRoom(
  id,
  payload,
  successMessage = 'Room updated successfully.',
  errorMessage = 'There was an issue updating this room.',
  isFormData = true
) {
  return apiPatch(
    ROOM_UPDATE.replace(':roomId', id),
    payload,
    'apiEditRoom',
    successMessage,
    errorMessage,
    isFormData
  );
}

export function apiEditProduct(
  id,
  payload,
  successMessage = 'Item updated successfully.',
  errorMessage = 'There was an issue updating this item.'
) {
  return apiPatch(
    UPDATE_PROPS_API.replace(':productId', `${id}/`),
    payload,
    'apiEditRoom',
    successMessage,
    errorMessage
  );
}

export function apiEditProductV2({
  id,
  name,
  sku_id,
  price,
  description,
  dimensions,
  filteroptions,
  live_links,
  tags,
  is_roof_prop,
  gtin,
}) {
  // const payload = { name, sku_id, description, price, dimensions, filteroptions, tags };
  // const formData = objectToFormData(payload, { ignoreUndefined: true, separateArrayItems: true });

  const payload = {
    id,
    name,
    sku_id,
    price,
    description,
    dimensions,
    filteroptions,
    live_links,
    tags,
    is_roof_prop,
    gtin,
  };

  return apiPatch(
    UPDATE_PROPS_API.replace(':productId', `${id}/`),
    payload,
    'apiEditProductV2',
    null,
    null
  );
}

export function apiEditProductV3({
  id,
  name,
  sku_id,
  price,
  description,
  dim_x,
  dim_y,
  dim_z,
  filteroptions,
  live_links,
  tags,
  is_guest_user = false,
}) {
  const payload = {
    // id,
    name,
    sku_id,
    price,
    description,
    dim_x,
    dim_y,
    dim_z,
    filteroptions,
    live_links,
    ...(is_guest_user ? { is_guest_user: true } : {}),
    // tags,
  };

  return apiPatch(
    PRODUCT_V2_DETAILS_UPDATE.replaceAll(':productId', id),
    payload,
    'apiEditProductV3',
    null,
    null
  );
}

export function apiToggleFavorite(id, is_favourite, path) {
  let payload = {
    is_favourite: is_favourite,
  };
  let functionCallback;
  switch (path) {
    case MODULE_TYPES.PROJECT:
    case MODULE_TYPES.PROJECTS:
      functionCallback = apiEditProject;
      break;
    case MODULE_TYPES.TEMPLATE:
    case MODULE_TYPES.TEMPLATES:
    case MODULE_TYPES.ROOM:
    case MODULE_TYPES.ROOMS:
      functionCallback = apiEditRoom;
      break;
    case MODULE_TYPES.PROP:
    case MODULE_TYPES.PROPS:
    case MODULE_TYPES.PRODUCT:
    case MODULE_TYPES.PRODUCTS:
      functionCallback = apiEditProduct;
      break;
    case MODULE_TYPES.COLLECTION:
    case MODULE_TYPES.COLLECTIONS:
      functionCallback = apiEditCollection;
      break;
    case MODULE_TYPES.PROJECT_RENDER:
    case MODULE_TYPES.RENDER:
    case MODULE_TYPES.RENDERS:
    case MODULE_TYPES.RENDER_DETAIL:
    case MODULE_TYPES.RENDER_PREVIEW:
      functionCallback = apiEditRenderPreview;
      break;
    case MODULE_TYPES.MODEL:
    case MODULE_TYPES.MODELS:
    case MODULE_TYPES.THREEDMODEL:
    case MODULE_TYPES.THREEDMODELS:
      functionCallback = apiEditProduct;
      break;
    case MODULE_TYPES.TEXTURE:
    case MODULE_TYPES.TEXTURES:
    case MODULE_TYPES.UPLOAD:
    case MODULE_TYPES.UPLOADS:
      functionCallback = apiEditTexture;
      break;

    case 'inspirations':
      functionCallback = apiEditInspiration;
      break;

    default:
      break;
  }
  if (_.isFunction(functionCallback)) {
    return functionCallback(id, payload, null, null);
  }
}

export async function apiCreateCollection(payload, successMessage = null, errorMessage = null) {
  return apiPost(
    COLLECTION_DETAILS_API,
    payload,
    'apiCreateCollection',
    successMessage,
    errorMessage,
    true,
    ({ status, message }) => {
      if (status) return;
      const errorKeys = Object.keys(message);
      const key = errorKeys[0];
      if (key) {
        errorToast(message[key][0]);
      }
    }
  );
}

export function apiAddToCollection(formData, successMessage = null, errorMessage = null) {
  return apiMultiPost(
    ADD_TO_COLLECTIONS,
    formData,
    'apiAddToCollection',
    successMessage,
    errorMessage
  );
}

export function apiGetRoomV2({ id }) {
  return apiGet(`${GET_ROOMS_API}${id}/`, 'apiGetRoomV2');
}

export function apiGetRooms(query, successMessage = null, errorMessage = null) {
  return apiGet(`${GET_ROOMS_API}?${query}`, 'apiGetRooms', successMessage, errorMessage);
}

export function apiGetRoomsOnHomepage(params = '') {
  return apiGet(`${ROOMS_ON_HOMEPAGE}?${params}`, 'apiGetRoomsOnHomepage');
}

// export function apiSaveRooms(
//   id,
//   successMessage = null,
//   errorMessage = null
//   ) {
//   return apiGet(`${GET_ROOMS_API}?${query}`, 'apiSaveRooms', successMessage, errorMessage);
// }

export function apiGetCollectionItems(id, query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${COLLECTION_DATA_API}${id}/?${query}`,
    'apiGetCollectionItems',
    successMessage,
    errorMessage
  );
}

export function apiGetCollectionDetail({ id, successMessage = null, errorMessage = null }) {
  return apiGet(
    `${COLLECTION_DETAILS_API}${id}/`,
    'apiGetCollectionDetail',
    successMessage,
    errorMessage
  );
}

export function apiGetCollections(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${COLLECTION_DETAILS_API}${query ? `?${query}` : ''}`,
    'apiGetCollections',
    successMessage,
    errorMessage
  );
}

// home - inspiration
export function apiGetInspiration(query, successMessage = null, errorMessage = null) {
  if (query !== null && query !== undefined && query !== '') {
    query = `?${query}`;
  } else {
    query = '';
  }
  return apiGet(`${GET_INSPIRATION}${query}`, 'apiGetInspiration', successMessage, errorMessage);
}

export function apiEditInspiration(id, payload, successMessage = null, errorMessage = null) {
  return apiPatch(
    `${GET_INSPIRATION}${id}/`,
    payload,
    'apiEditInspiration',
    successMessage,
    errorMessage
  );
}

// may remove this one altogether in favor of getProjectsApiV2
export function apiGetProjects(query, successMessage = null, errorMessage = null) {
  if (query !== null && query !== undefined && query !== '') {
    query = `?${query}`;
  } else {
    query = '';
  }
  return apiGet(`${GET_PROJECT_API}${query}`, 'apiGetProjects', successMessage, errorMessage);
}

export function apiGetProject({ id, is_autosave, successMessage, errorMessage }) {
  let query = '';
  if (typeof is_autosave !== 'undefined') {
    query += `is_autosave=${is_autosave}`;
  }

  return apiGet(`${GET_PROJECT_API}${id}/?${query}`, 'apiGetProject', successMessage, errorMessage);
}

export function apiDeleteProjects(
  payload,
  successMessage = 'The files are successfully deleted',
  errorMessage = 'There was an error deleting these projects.'
) {
  return apiMultiDelete(
    PROJECT_MULTI_DELETE,
    payload,
    'apiDeleteProjects',
    successMessage,
    errorMessage
  );
}

export function apiDeleteCollections(
  payload,
  successMessage = 'These collections have been successfully deleted',
  errorMessage = 'There was an error deleting these collections.'
) {
  return apiMultiDelete(
    COLLECTION_MULTI_DELETE,
    payload,
    'apiDeleteCollections',
    successMessage,
    errorMessage
  );
}

export function apiRemoveFromCollections(
  payload,
  successMessage = 'Items have been successfully removed from collection',
  errorMessage = 'There was an error removing items.'
) {
  return apiMultiDelete(
    REMOVE_FROM_COLLECTION_API,
    payload,
    'apiRemoveFromCollections',
    successMessage,
    errorMessage
  );
}

export function apiGetMaterials(query, successMessage = null, errorMessage = null) {
  return apiGet(`${MATERIAL_API}?${query}`, 'apiGetMaterials', successMessage, errorMessage);
}

export function apiGetOptimizeMaterialList(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${OPTIMIZED_MATERIAL_API}?${query}`,
    'apiGetMaterials',
    successMessage,
    errorMessage
  );
}

export function apiGetMaterialsV2({ query = '', page }) {
  if (page) {
    query = query ? `${query}&page=${page}` : `page=${page}`;
  }
  return apiGet(`${MATERIAL_API}?${query}`, 'apiGetMaterials');
}

export function apiGetMaterialTextures(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${MATERIAL_TEXTURES_API}?${query}`,
    'apiGetMaterialTextures',
    successMessage,
    errorMessage
  );
}

export const apiCheckTexture = ({ textureId, version }) => {
  let query = `texture_id=${textureId}`;

  if (version) {
    query += `&texture_ver=${version}`;
  }

  return api()
    .root(API_ROOT_URL)
    .get(`${TEXTURE_CHECK_VERSION}?${query}`)
    .success((data) => {
      return data;
    })
    .notFound404(() => {})
    .send();
};

export const apiTextureIsMapCheck = ({ textureId }) => {
  const payload = new FormData();
  payload.append('is_map', true);
  payload.append('filteroptions', GENERATED_NORMAL_MAP_FILTER_OPTION_ID);
  payload.append('original_texture_id', textureId);

  return api()
    .root(API_ROOT_URL)
    .post(TEXTURE_IS_MAP_CHECK)
    .requestConfig({
      messages: {
        400: '',
        hideTost: true,
      },
    })
    .data(payload)
    .success((data) => {
      return data;
    })
    .notFound404(() => {})
    .send();
};

export const apiUploadTextureMap = ({
  name,
  project,
  originalTextureId,
  filterOptions,
  file,
  width,
  height,
}) => {
  const payload = new FormData();
  payload.append('is_map', true);
  payload.append('name', name);
  payload.append('original_texture_id', originalTextureId);
  payload.append('filteroptions', filterOptions);
  payload.append('low_texture_file', file);
  payload.append('width', width);
  payload.append('height', height);

  if (project) {
    payload.append('project', project);
  }
  return apiPost(TEXTURE_MAP_DETAIL, payload, 'apiUploadTextureMap', null, null, false);
};

export const apiUploadTexture = (payload) => {
  return apiPost(TEXTURE_DETAILS_API, payload, 'apiUploadTexture');
};

export const apiGetDefaultTexture = ({ name }) => {
  return apiGet(`${DEFAULT_TEXTURE_DETAILS_API}?name=${name}`, 'apiGetDefaultTexture');
};

export const apiAddDefaultTexture = ({ name, file }) => {
  const payload = objectToFormData({
    name,
    texture_file: file,
  });
  return apiPost(DEFAULT_TEXTURE_DETAILS_API, payload, 'apiAddDefaultTexture');
};

export function apiRestoreRenders(
  id,
  payload,
  successMessage = 'These renders/previews have been successfully restored',
  errorMessage = 'There was an error restoring these renders/previews.'
) {
  return apiMultiRestore(
    `${UPDATE_RENDER_PREVIEW}${id}/?is_archived=true`,
    payload,
    'apiRestoreRenders',
    successMessage,
    errorMessage
  );
}

export function apiArchiveRenders({
  idList,
  onDeleteFailed,
  showSuccessMessage = true,
  // errorMessage = 'There was an error archiving these renders.'
}) {
  const payload = new FormData();
  idList.forEach((id) => {
    payload.append('id', id);
  });

  return (
    api()
      .root(API_ROOT_URL)
      .delete(UPDATE_RENDER_PREVIEW)
      .data(payload)
      .success(() => {
        showSuccessMessage && successToast('These renders have been successfully archived');
      })
      // .error((error, { status, ...rest }) => {
      //     errorToast(errorMessage);
      // })
      .send((errResponse, errStatus, response) => {
        if (response?.data?.data) {
          const deleteFailedItems = Object.entries(response?.data?.data)
            .filter(([id, { archived, deleted }]) => {
              return !archived && !deleted;
            })
            .map(([id, { archived, deleted }]) => ({
              id,
              archived,
              deleted,
            }));
          // debugger;
          if (deleteFailedItems.length) {
            onDeleteFailed(deleteFailedItems);
          }
        }
      })
  );
}

export function apiArchiveRender({ id, params = '' }) {
  return apiDelete(`${UPDATE_RENDER_PREVIEW}${id}/${params}`, 'apiArchiveRender');
}

export function apiGetShortkeyConfiguration() {
  return new Promise((resolve) => {
    let resolved = false;
    let is404 = false;

    api()
      .root(API_ROOT_URL)
      .get(GET_SHORTKEY)
      .success((data) => {
        resolve(data?.data);
      })
      .error((error) => {
        apiErrorHandler(error);
      })
      .notFound404(async () => {
        // create it if it's not found
        is404 = true;
        // const mockData = {
        //   [SHORTCUT.OPEN_PROJECT]: {
        //     keys: ['Ctrl', 'M'],
        //   },
        //   [SHORTCUT.UNDO]: {
        //     keys: ['Shift', 'Z'],
        //   },
        //   [SHORTCUT.REDO]: {
        //     keys: ['Ctrl', 'Z'],
        //   }
        // }
        const result = await apiCreateShortkeyConfiguration({});

        resolve(result?.data);
      })
      .send()
      .finally(() => {
        if (!resolved && !is404) {
          resolve();
        }
      });
  });
}

export function apiCreateShortkeyConfiguration(shortkeysObject) {
  return apiPost(
    GET_SHORTKEY,
    {
      data: JSON.stringify(shortkeysObject),
    },
    'apiCreateShortkeyConfiguration',
    null,
    null
  );
}

export function apiUpdateShortkeyConfiguration({ shortkeysObject }) {
  return apiPatch(
    GET_SHORTKEY,
    { data: JSON.stringify(shortkeysObject) },
    'apiUpdateShortkeyConfiguration'
  );
}

export function apiDeleteShortkeyConfiguration() {
  return apiDelete(GET_SHORTKEY, 'apiDeleteShortkeyConfiguration');
}

export function apiGetRoomDetails(paramsObj, successMessage = null, errorMessage = null) {
  const params = objectToSearchParams(paramsObj);
  return apiGet(`${ROOM_DETAILS_API}?${params}`, 'apiGetRoomDetails', successMessage, errorMessage);
}

export function apiGetTemplateGalary(paramsObj, successMessage = null, errorMessage = null) {
  const params = objectToSearchParams(paramsObj);
  return apiGet(
    `${DASHBOARD_GALERY_API}?${params}`,
    'apiGetRoomDetails',
    successMessage,
    errorMessage
  );
}

export function apiGetCarouselImages(paramsObj, successMessage = null, errorMessage = null) {
  const params = objectToSearchParams(paramsObj);
  return apiGet(`${CAROUSEL_API}?${params}`, 'apiGetCarouselImages', successMessage, errorMessage);
}

export function apiGetPreviewAndMainRenders(params, successMessage = null, errorMessage = null) {
  return apiGet(
    `${GET_RENDER_PREVIEW_DATA}?${params}`,
    'apiGetPreviewAndMainRenders',
    successMessage,
    errorMessage
  );
}

export function apiGetPreviewAndMainRender(
  id,
  successMessage = null,
  errorMessage = null,
  param = ''
) {
  return apiGet(
    `${GET_RENDER_PREVIEW_DATA}${id}/${param}`,
    'apiGetPreviewAndMainRender',
    successMessage,
    errorMessage
  );
}

export function apiGetPresetCameraAngle(roomId) {
  return apiGet(`${PRESET_CAMERA_ANGLE}?room_id=${roomId}`);
}

export function apiGetProjectRoomCameraAngle(query = null) {
  query = query !== null ? `?${query}` : '';
  return apiGet(`${PROJECT_CAMERA_ANGLE}${query}`);
}

export function apiGetDownloadRendersImages(query, includePasses, pass) {
  query += includePasses ? `&is_color_pass=${includePasses}` : '';
  // if (includePasses) {
  //   query += '&is_color_pass=true';
  // }
  return apiGetBlob(`${DOWNLOAD_RENDER}?${query}`);
}

export function apiGetDownloadRendersImagesV2({ ids, fileName, is_separate = false }) {
  const query = `ids=${ids.join(',')}&is_separate=${is_separate}`;
  return apiGet(`${DOWNLOAD_RENDER}?${query}`)
    .then((r) => {
      if (r && r.status && r.data) {
        return download({
          fileUrl: r.data.zip_file,
          fileName,
          auth: false,
        });
      }
    })
    .catch((error) => errorToast(error.message));
}

export function apiDownloadOldRenderProjectZipFile({ renderId }) {
  return apiGet(DOWNLOAD_OLD_RENDER_PROJECT_ZIP.replace(':renderId', renderId));
}

export function apiGetAcceptTermsAndConditions() {
  return apiGet(TERMS_ACCEPT_API);
}

export function apiGetVerifyEmailLink(token) {
  return apiGet(`${LINK_VERIFY_API}${token}`);
}

export function apiPostRegisterInvite(
  payload,
  token,
  isFormData = true,
  successMessage = null,
  errorMessage = null,
  callback = () => {}
) {
  return apiPost(
    `${REGISTER_INVITE_API}${token}/`,
    payload,
    'apiPostRegisterInvite',
    successMessage,
    errorMessage,
    isFormData,
    callback
  );
}

export function apiGetProductMetaInfo({ id }) {
  return apiGet(`${PRODUCT_META_INFO_API}?id=${id}`, 'apiGetProductMetaInfo');
}

export function apiGetProps(params, successMessage = null, errorMessage = null) {
  return apiGet(`${GET_PROPS_API}?${params}`, 'apiGetProps', successMessage, errorMessage);
}

export function apiGetPropsV2({ search = '', page = 1, brands = [], query = '' }) {
  return apiGet(
    `${GET_PROPS_API}?search=${search}&page=${page}&brands=${brands.join(',')}&${query}`,
    'apiGetPropsV2'
  );
}

export function apiGetProp(id, successMessage = null, errorMessage = null) {
  return apiGet(`${GET_PROPS_API}${id}/`, 'apiGetProp', successMessage, errorMessage);
}

export function apiGetPropOptimized(id, params) {
  let url = `${OP_GET_PROP_API}${id}/`;
  if (params) url += `?${params}`;

  return apiGet(url);
}

export function apiGetPropOptimizedV2(id, params, hideToast) {
  let url = `${OP_GET_PROP_API_V2}${id}/`;
  if (params) url += `?${params}`;

  return apiGet(url, hideToast);
}

export const apiGetAllProps = async (arr = [], page = 1, params = null) => {
  let query = arr.map((a) => `id=${a}`).join('&');
  if (params) query += `&${params}`;
  return await api()
    .root(API_ROOT_URL)
    .get(`${GET_PRODUCTS_API}?${query}&per_page=20&page=${page}`)
    .send();
};

export const apiGetPropsDetail = async (id) => {
  return await api().root(API_ROOT_URL).get(`${GET_PRODUCTS_API}${id}/`).send();
};

export function apiGetTextureOptimized(id, params) {
  let url = `${TEXTURE_DETAILS_API}${id}/`;

  if (params) url += `?${params}`;
  return apiGet(url);
}

export function apiGetTextureOptimizedV2(id, params, hideToast) {
  let url = `${TEXTURE_PAGE_DETAILS_API_V2}${id}/`;

  if (params) url += `?${params}`;
  return apiGet(url, hideToast);
}

export function apiGetPropPublic(id, successMessage = null, errorMessage = null) {
  // return apiGet(`${GET_PROPS_API_PUBLIC}?unicode=${id?.id || id}`, 'apiGetPropPublic', successMessage, errorMessage);
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_PROPS_API_PUBLIC}?unicode=${id?.id || id}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      return error;
    })
    .send();
}
// The SDK public page product API (apiGetPropPublic) is failing.
// @Abhishek has provided a new API, so replace the old API with this one.
export function apiGetPropPublicInfo(id, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_PROPS_API_PUBLIC_INFO}?unicode=${id?.id || id}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      return error;
    })
    .send();
}

export function apiGetTexturePublic(id, successMessage = null, errorMessage = null) {
  // return apiGet(`${GET_PROPS_API_PUBLIC}?unicode=${id?.id || id}`, 'apiGetPropPublic', successMessage, errorMessage);
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_TEXTURE_API_PUBLIC}?unicode=${id?.id || id}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      return error;
    })
    .send();
}

export function apiGetPropV2({ id }) {
  return apiGet(`${GET_PROPS_API}${id}/`, 'apiGetPropV2');
}

export function apiPostUpload3DModel(formData) {
  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_3D_MODEL_UPLOAD_API)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .badRequest400(() => {})
    .send();
}

export function apiBulkUpload3DModel(formData, onNetworkError) {
  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_3D_MODEL_BULK_UPLOAD_API)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .badRequest400(() => {})
    .networkError(onNetworkError, () => {})
    .send();
}

export function apiBulkDeleteModels(formData) {
  return api()
    .root(API_ROOT_URL)
    .delete(PRODUCT_3D_MODEL_BULK_UPLOAD_API)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .badRequest400(() => {})
    .send();
}

export function apiDeleteUpload3DModel(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${PRODUCT_3D_MODEL_UPLOAD_API}${id}/`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .badRequest400(() => {})
    .notFound404(() => {})
    .send();
}

export function apiPost3DModelJob(formData, { silent = false } = {}) {
  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_3D_MODEL_JOB_API)
    .data(formData)
    .requestConfig({ messages: { hideTost: silent } })
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function sendRenderToApi(formData) {
  return api()
    .root(API_ROOT_URL)
    .post(AUTOMATION_RENDER_API)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function getModelTemplateData({ query }) {
  return apiGet(
    `${GET_MODEL_TEMPLATE}?${query}`,
    'apiGetModelTemplate',
    null,
    'Unable to get model template'
  );
}

export function getMissingPropsDetails({ idList }) {
  const query = idList.map((id) => `id=${id}`).join('&');
  return apiGet(
    `${GET_MISSING_PROPS_DETAILS}?${query}`,
    'apiGetMissingPropsDetails',
    null,
    'Unable to get missing props details'
  );
}

export function apiCheckResourceAvailability({
  materialIdList,
  textureIdList,
  hdriIdList,
  roomIdList,
  oldRoomIdList,
  oldPropIdList,
  oldMaterialIdList,
}) {
  let query = '';
  if (materialIdList?.length) {
    query += '&';
    query += uniq(materialIdList)
      .map((id) => `material=${id}`)
      .join('&');
  }

  if (textureIdList?.length) {
    query += '&';
    query += uniq(textureIdList)
      .map((id) => `texture=${id}`)
      .join('&');
  }

  if (roomIdList?.length) {
    query += '&';
    query += uniq(roomIdList)
      .map((id) => `room=${id}`)
      .join('&');
  }

  if (oldRoomIdList?.length) {
    query += '&';
    query += uniq(oldRoomIdList)
      .map((id) => `old_room_id=${id}`)
      .join('&');
  }

  if (hdriIdList?.length) {
    query += '&';
    query += uniq(hdriIdList)
      .map((id) => `hdri=${id}`)
      .join('&');
  }

  if (oldPropIdList?.length) {
    query += '&';
    query += uniq(oldPropIdList)
      .map((id) => `old_product_id=${id}`)
      .join('&');
  }

  if (oldMaterialIdList?.length) {
    query += '&';
    query += uniq(oldMaterialIdList)
      .map((id) => `old_material_id=${id}`)
      .join('&');
  }

  return apiGet(
    `${CHECK_AVAILABILITY}?${query}`,
    'apiCheckResourceAvailability',
    null
    // 'Unable to get missing details'
  );
}

export function apiGetProductWebExperience({ productId }) {
  return apiGet(`${GET_WEB_EXPERIENCE_API}?product=${productId}`, 'apiGetProductWebExperience');
}

export function apiGetWebExperienceList() {
  return apiGet(`${GET_WEB_EXPERIENCE_API}`, 'apiGetWebExperienceList');
}

export function apiGetWebExperience({ id }) {
  return apiGet(`${GET_WEB_EXPERIENCE_API}${id}/`, 'apiGetWebExperience');
}

export function apiCreateWebExperience({
  productId,
  organizationId,
  renders,
  score,
  is_publish,
  successMessage = 'Web experience created',
}) {
  const formData = new FormData();
  formData.append('product', productId);
  formData.append('organization', organizationId);
  formData.append('score', score);
  formData.append('is_publish', is_publish);
  renders.forEach((render) => formData.append('renders', JSON.stringify(render)));

  return apiPost(
    WEB_EXPERIENCE_API,
    formData,
    'apiCreateWebExperience',
    successMessage,
    'Unable to create web experience'
  );
}

export function apiUpdateWebExperience({
  id,
  productId,
  organizationId,
  renders,
  score,
  is_public,
  is_publish,
  successMessage,
}) {
  const formData = objectToFormData(
    {
      product: productId,
      organization: organizationId,
      score,
      is_public,
      is_publish,
      ...(renders && { renders: renders.map((render) => JSON.stringify(render)) }),
    },
    {
      separateArrayItems: true,
      ignoreUndefined: true,
    }
  );

  return apiPatch(
    `${WEB_EXPERIENCE_API}${id}/`,
    formData,
    'apiUpdateWebExperience',
    successMessage,
    'Unable to update web experience',
    false
  );
}

export function apiGetWebExperienceRoomType() {
  return apiGet(WEB_EXPERIENCE_ROOM_TYPE_API, 'apiGetWebExperienceRoomType');
}

export function apiGetWebExperiencePublic({ id }) {
  return apiGet(`${GET_WEB_EXPERIENCE_PUBLIC_API}${id}/`, 'apiGetWebExperiencePublic');
}

export function apiGetWebExperienceProductDetails({ id }) {
  return apiGet(`${WEB_EXPERIENCE_PRODUCT_DETAILS_API}${id}/`, 'apiGetWebExperienceProductDetails');
}

export function apiGetPropDetails({ id }) {
  return apiGet(`${OP_GET_PROP_API}${id}/`, 'apiGetPropDetails');
}

export function apiGetWebExperienceTextureDetails({ id }) {
  return apiGet(`${WEB_EXPERIENCE_TEXTURE_DETAILS_API}${id}/`, 'apiGetWebExperienceTextureDetails');
}

export function apiGetWebExperienceProductDetailsPublic({ id }) {
  return apiGet(
    `${WEB_EXPERIENCE_PRODUCT_DETAILS_API_PUBLIC}?unicode=${id}`,
    'apiGetWebExperienceProductDetailsPublic'
  );
}

export function apiGetPdpProducts({ id }) {
  return apiGet(`${GET_PDP_PRODUCTS_API}?product=${id}`, 'apiGetPdpProducts');
}

export function apiUpdateWebExperienceProductDetails({
  id,
  name,
  sku_id,
  price,
  description,
  dimensions,
  filteroptions,
  live_links,
  tags,
  is_roof_prop,
  gtin,
}) {
  const payload = {
    name,
    sku_id,
    description,
    price,
    dimensions,
    filteroptions,
    live_links,
    tags,
    is_roof_prop,
    gtin,
  };
  const formData = objectToFormData(payload, { ignoreUndefined: true, separateArrayItems: true });

  return apiPatch(
    `${WEB_EXPERIENCE_PRODUCT_DETAILS_API}${id}/`,
    formData,
    'apiGetWebExperienceProductDetails',
    null,
    null,
    false
  );
}

export const apiGetPropRenderImageList = async ({
  props,
  roomType,
  orgId,
  page = 1,
  perPage = 20,
}) => {
  const params = {
    // main_render__main_render__props: props,
    // main_render__type: roomType,
    product: props,
    project_type: roomType,
    project_organization: orgId,
    page,
    per_page: perPage,
    sort: '-created_at',
  };
  const paramsStr = objectToSearchParams(params);
  // const result = await apiGet(
  //   `/rendering-system/api/v3/project-render-images/?${paramsStr}`,
  //   'apiGetPropRenderImageList'
  // );

  const result = await apiGet(
    `/organization/api/v3/product-renders/?${paramsStr}`,
    'apiGetPropRenderImageList'
  );

  // if (!result?.results) return;

  return result;

  // let imageList = result.results.reduce((images, render) => {
  //   images.push(...render.images);
  //   return images;
  // }, []);

  // const randomOrderImageList = shuffle(imageList);
  // const maxIndex = Math.random() > 0.5 ? Math.floor(Math.random() * imageList.length) : 1;
  // imageList = randomOrderImageList.slice(0, maxIndex);

  // imageList = imageList.map((item) => ({
  //   ...item,
  //   roomType,
  // }));

  // return {
  //   results: imageList,
  //   total_pages: 1,
  //   count: imageList.length,
  //   current_page_number: 1,
  //   next_link: null,
  //   previous_link: null,
  // };
};

// TODO: remove it when api is fixed
export const apiMock1 = async ({ props, roomType, orgId, page = 1, perPage = 10 }) => {
  const params = {
    // project__props: props,
    product: props,
    // project__project_type: roomType,
    room_type: roomType,
    project__owner_organization: orgId,
    page,
    per_page: perPage,
  };
  const paramsStr = objectToSearchParams(params);
  return await apiGet(
    `/rendering-system/api/v3/project-render-images/?${paramsStr}`,
    'apiGetPropRenderImageList'
  );
};

export function apiGetRenderImage({ id }) {
  return apiGet(`${id}/`, 'apiGetRenderImage');
}

// handling google login and manual login differently because server error happens when email is not verified rather than handling the error
export function apiPostGoogleLogin(
  payload,
  isFormData = false,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    GOOGLE_LOGIN_API,
    payload,
    'apiPostGoogleLogin',
    successMessage,
    errorMessage,
    isFormData
  );
}

// handling google login and manual login differently because server error happens when email is not verified rather than handling the error
export async function apiPostGoogleLoginNew(
  payload,
  isFormData = false,
  successMessage = null,
  errorMessage = null
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (isFormData && !isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return await api()
    .root(API_ROOT_URL)
    .post(GOOGLE_LOGIN_API_New)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .badRequest400(() => {})
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiPostLogin(
  payload,
  isFormData = false,
  successMessage = null,
  errorMessage = null
) {
  let formData = payload;
  try {
    return api()
      .root(API_ROOT_URL)
      .post(LOGIN_API)
      .data(formData)
      .success((data) => {
        // if (successMessage) {
        //   successToast(successMessage);
        // }
        return data;
      })
      .error((error) => {
        console.error('error: ', errorMessage);
        if (errorMessage) {
          errorToast(errorMessage);
        }
        // apiErrorHandler(error, null);
        throw error;
      })
      .badRequest400(() => {})
      .authFail401((res) => {
        console.error('authFail401 res: ', res);
        apiErrorHandler(res, null);
      })
      .send();
  } catch (error) {
    console.error('error: ', error);
    throw error;
  }
}

export function apiPostLogout(successMessage = null, errorMessage = null) {
  return apiPost(
    LOGOUT_API,
    { refresh: getLocalStorage(REFRESH_TOKEN) },
    'apiPostLogout',
    successMessage,
    errorMessage,
    false
  );
}

export function apiPostRegister(
  payload,
  isFormData = true,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    REGISTER_API,
    payload,
    'apiPostRegister',
    successMessage,
    errorMessage,
    isFormData
  );
}

export function apiPostRegisterV2(
  payload,
  isFormData = true,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    REGISTER_API_V2,
    payload,
    'apiPostRegisterV2',
    successMessage,
    errorMessage,
    isFormData
  );
}

export async function apiPostRegisterNew(
  payload,
  isFormData = true,
  successMessage = null,
  errorMessage = null
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (isFormData && !isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return await api()
    .root(API_ROOT_URL)
    .post(REGISTER_API_NEW)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .badRequest400((error) => {
      throw error;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiPostConvertGuestUserToNormal(
  payload,
  isFormData = true,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    CONVERT_GUEST_USER_TO_NORMAL_API,
    payload,
    'apiPostRegister',
    successMessage,
    errorMessage,
    isFormData
  );
}

export function apiPostRegisterGuestUser(
  payload,
  isFormData = true,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    REGISTER_API_NEW_GUEST_USER,
    'apiPostRegisterGuest',
    successMessage,
    errorMessage,
    isFormData
  );
}

export function apiPostVerifyOtp(
  payload,
  isFormData = true,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    VERIFY_OTP_API,
    payload,
    'apiPostVerifyOtp',
    successMessage,
    errorMessage,
    isFormData
  );
}

// export const LinkVerifyApi = () => (dispatch) => {
//   api().root(API_ROOT_URL).get(LINK_VERIFY_API).success(({status, data, message})=>{
//       setLocalStorage(AUTH_TOKEN, data.access)
//       setLocalStorage(REFRESH_TOKEN, data.refresh)
//       if(status){
//           navigate(CUSTOMIZE_EXPERIENCE)
//           successToast(message)
//       }
//   }).error(()=>{

//   }).send()
// }

export function apiPostResendOtpEmail(formData, successMessage = null, errorMessage = null) {
  try {
    return api()
      .root(API_ROOT_URL)
      .post(RESEND_EMAIL_API)
      .data(formData)
      .success((data) => {
        return data;
      })
      .error((error) => {
        throw error;
      })
      .send();
  } catch (error) {
    console.error('error: ', error);
    throw error;
  }
}

export function apiPostForgotPassword(
  payload,
  isFormData = true,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    FORGOT_API,
    payload,
    'apiPostForgotPassword',
    successMessage,
    errorMessage,
    isFormData
  );
}

export function apiPostResetPassword(
  payload,
  token,
  isFormData = true,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    CREATE_PASSWORD_API + token + '/',
    payload,
    'apiPostForgotPassword',
    successMessage,
    errorMessage,
    isFormData
  );
}

export function apiGetTNCLatest(params, successMessage = null, errorMessage = null) {
  // const params = objectToSearchParams(paramsObj);
  return apiGet(TERMS_API, 'apiGetTNCLatest', successMessage, errorMessage);
}

export function apiPatchUpdateUserProfile(payload, successMessage = null, errorMessage = null) {
  return apiPatch(
    UPDATE_USER_PROFILE_API,
    payload,
    'apiPatchUpdateUserProfile',
    successMessage,
    errorMessage
  );
}

export function apiPatchAfterRegister(payload, successMessage = null, errorMessage = null) {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (_.isArray(value)) {
      value.forEach((element) => formData.append(key, element));
    } else {
      formData.append(key, value);
    }
  });

  return api()
    .root(API_ROOT_URL)
    .patch(AFTER_REGISTER_API)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiPatchAfterRegister');
    })
    .badRequest400(() => {})
    .send();
}

export function apiGetOrganizationBalance(successMessage = null, errorMessage = null) {
  return apiGet(GET_USER_BALANCE, 'apiGetOrganizationBalance', successMessage, errorMessage);
}

export function apiGetRenderingPriceInfo(successMessage = null, errorMessage = null) {
  return apiGet(RENDERING_PRICE_INFO, 'apiGetRenderingPriceInfo', successMessage, errorMessage);
}

export function apiGetTransactionHistoryStatus(successMessage = null, errorMessage = null) {
  return apiGet(
    TRANSACTION_HISTORY_STATUS,
    'apiGetTransactionHistoryStatus',
    successMessage,
    errorMessage
  );
}

export function apiGetTransactionHistory(successMessage = null, errorMessage = null) {
  return apiGet(TRANSACTION_HISTORY, 'apiGetTransactionHistory', successMessage, errorMessage);
}

export function apiDownloadTransactionHistory(
  { is_new, trans_type, created_at__gte, created_at__lte, created_by_email },
  successMessage = null,
  errorMessage = null
) {
  const query = objectToSearchParams({
    is_new,
    trans_type,
    created_at__gte,
    created_at__lte,
    created_by_email,
  });
  return apiGet(
    `${TRANSACTION_HISTORY_DOWNLOAD}?${query}`,
    'apiDownloadTransactionHistory',
    successMessage,
    errorMessage
  );
}

export function apiPostPartialPaymentApi(renderId, successMessage = null, errorMessage = null) {
  return apiGet(
    RENDER_PARTIAL_PAYMENT + `?render_id=${renderId}`,
    'apiPostRenderPartialPaymentApi',
    successMessage,
    errorMessage,
    false
  );
}

export function apiPostMultiPaymentIntentApi(
  amount,
  paymentType,
  renderId,
  isRenderAmountSufficient,
  availableBalance,
  isFormData = false,
  successMessage = null,
  errorMessage = null
) {
  let url = `?amount=${amount}&render_id=${renderId}&payment_method_types=${paymentType}`;
  if (!isRenderAmountSufficient && availableBalance > 0) {
    url = `${url}&partial_stripe_payment=true&partial_credit_amount=${availableBalance}`;
  }
  return apiPost(
    PAYMENT_INTENT + url,
    {},
    'apiPostPaymentIntentApi',
    successMessage,
    errorMessage,
    false
  );
}

export function apiPostPaymentIntentApi(
  amount,
  paymentType,
  isFormData = false,
  successMessage = null,
  errorMessage = null
) {
  return apiPost(
    PAYMENT_INTENT + `?amount=${amount}&payment_method_types=${paymentType}`,
    {},
    'apiPostPaymentIntentApi',
    successMessage,
    errorMessage,
    false
  );

  // return api()
  //   .root(API_ROOT_URL)
  //   .post(PAYMENT_INTENT + `?amount=${amount}&payment_method_types=${paymentType}`)
  //   .success((data) => {
  //     if (successMessage) {
  //       successToast(successMessage);
  //     }
  //     return data;
  //   })
  //   .error((error) => {
  //     if (errorMessage) {
  //       errorToast(errorMessage);
  //     }
  //     apiErrorHandler(error, 'apiPostPaymentIntent');
  //     return error;
  //   })
  //   .send();
}

export function apiGetIndustryPreferences(
  selectedIndustries,
  successMessage = null,
  errorMessage = null
) {
  return apiGet(
    USER_PREFERENCE_API + `?id=${selectedIndustries.toString()}`,
    'apiGetIndustryPreferences',
    successMessage,
    errorMessage
  );
}

export function apiGetHdriLight({ id }) {
  return api()
    .root(API_ROOT_URL)
    .get(`${LIGHT_API}${id}/`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      apiErrorHandler(error);
    })
    .notFound404(() => {})
    .send();
}

export function apiGetLOAMappedHdri(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${LOA_MAPPED_HDRI_LIGHT_API}?${query}`,
    'apiGetLOAMappedHdri',
    successMessage,
    errorMessage
  );
}

export function apiGetHdriList({ ids, page, _queryArr = [] }) {
  const queryArr = [..._queryArr];

  if (ids) {
    queryArr.push(ids.map((id) => `id=${id}`).join('&'));
  }

  if (page) {
    queryArr.push(`page=${page}`);
  }

  let query = queryArr.join('&');

  return api()
    .root(API_ROOT_URL)
    .get(`${LIGHT_API}?${query}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      apiErrorHandler(error);
    })
    .notFound404(() => {})
    .send();
}

export function apiCreateProjectsZip({
  files,
  type = API_UPLOAD_TYPE.NORMAL,
  access_token = 'it does not work without token :( waiting for backend update',
}) {
  const payload = new FormData();
  payload.append('upload_type', type);
  payload.append('access_token', access_token);

  if (type === API_UPLOAD_TYPE.GOOGLE) {
    files.forEach((file) => {
      payload.append('filename', file.name);
      payload.append('file_id', file.id);
    });
  } else if (type === API_UPLOAD_TYPE.DROP_BOX) {
    files.forEach((file) => {
      payload.append('filename', file.link);
      payload.append('file_id', file.id);
    });
  } else {
    files.forEach(({ file, uuid }) => {
      payload.append('filename', file.name);
      payload.append('uuid', uuid);
    });
  }

  return apiPost('/organization/api/v3/projects/zip/bulk-create/', payload, 'apiCreateProjectsZip');
}

export function apiUpdateProjectZip({ id, status }) {
  const payload = { status };
  return apiPatch(
    `/organization/api/v3/projects/zip/details/${id}/`,
    payload,
    'apiUpdateProjectZip'
  );
}

export async function getProjectsApiV2(params, successMessage = null, errorMessage = null) {
  const searchParams = objectToSearchParams(params);
  const API_URL = `${GET_PROJECT_API}?${searchParams}`;
  const requestId = uniqueId();

  // need to replace this concept so no overloading the server
  // but do it with axios transaction handling instead of reducer
  // dispatch(myProjectsActions.fetchMyProjectsListStart({ requestId }))

  let results = await getDataList(
    apiGet(API_URL, 'getProjectsApiV2', successMessage, errorMessage)
  );
  return results;
}

export const parseBasePathname = (location) => {
  // /rooms/room-templates returns ['', 'rooms', 'room-templates']
  // value should return 'rooms'
  return _.find(location?.pathname.split('/'), (str) => str && str.length > 0);
};

export const parseProductTypePathname = (location) => {
  // /products/3dmodel returns ['', 'products', '3dmodel']
  // value should return '3dmodel'
  return _.chain(location?.pathname.split('/'))
    .filter((str) => str && str.length > 0)
    .last()
    .value();
};
export const createListApiRequest =
  ({ url, onStart, onSuccess, onError, startAction, successAction, errorAction }) =>
  ({ search, sort = '-created_at', perPage, page, ...rest } = {}) =>
  (dispatch) => {
    const searchParams = objectToSearchParams({
      search,
      sort,
      per_page: perPage,
      page,
      ...rest,
    });
    const API_URL = `${url}?${searchParams}`;

    onStart?.(dispatch);
    startAction && dispatch(startAction());

    api()
      .root(API_ROOT_URL)
      .get(API_URL)
      .success((data) => {
        onSuccess?.({
          data,
          dispatch,
          args: {
            search,
            sort,
            perPage,
            page,
          },
        });

        successAction &&
          dispatch(
            successAction({
              page,
              data,
            })
          );
      })
      .error((error) => {
        // TODO: add logger
        console.error(error);
        onError?.(error, dispatch);
        errorAction && dispatch(errorAction(error));
      })
      .send();
  };

export function apiGetIndustries({ is_default = null, search = '', page = 1, ids } = {}) {
  let query = `search=${search}&page=${page}`;

  if (ids) {
    query += `&id=${ids.join(',')}`;
  }

  if (is_default !== undefined && is_default !== null) {
    query += `&is_default=${is_default}`;
  }

  return apiGet(`${INDUSTRY_API}?${query}`);
}

export function apiCreateIndustry({ name }) {
  return apiPost(INDUSTRY_API, { name }, 'apiCreateIndustry');
}

export function apiGetPlatforms(params) {
  let query = '';
  if (params?.is_default !== undefined && params?.is_default !== null) {
    query = `is_default=${params?.is_default}`;
  }

  return apiGet(`${PLATFORM_API}?${query}`);
}

export function apiGetProfessions() {
  return apiGet(`${PROFESSION_API}?per_page=50`);
}

export function apiCreateProfession({ name }) {
  return apiPost(PROFESSION_API, { name }, 'apiCreateProfession');
}

export function apiCreatePlatform({ name }) {
  return apiPost(`${PLATFORM_API}`, { name }, 'apiCreatePlatform');
}

export function apiGetIndustriesPreferences(selectedIndustries) {
  return apiGet(`${USER_PREFERENCE_API}?id=${selectedIndustries.toString()}`);
}

export function apiGetUserDetails() {
  console.warn('getting user detail');
  return apiGet(GET_USER_DETAILS);
}

export function apiUpdateUserDetails(formData) {
  return api()
    .root(API_ROOT_URL)
    .patch(GET_USER_DETAILS)
    .data(formData)
    .success((res) => {
      return res;
    })
    .error((error) => {
      // apiErrorHandler(error);
      throw error;
    })
    .badRequest400((error) => {
      console.log('error', error);
    })
    .send();
}

export function apiGetCompanySize(successMessage = null, errorMessage = null) {
  return apiGet(COMPANY_SIZE, 'apiGetCompanySize', successMessage, errorMessage);
}

export function apiNotificationSettings() {
  return apiGet(NOTIFICATION_SETTINGS);
}

export function apiUpdateNotificationSettings(formData) {
  return api()
    .root(API_ROOT_URL)
    .put(NOTIFICATION_SETTINGS)
    .data(formData)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
    })
    .send();
}

export function apiChangeOrganizationOwner(formData) {
  return api()
    .root(API_ROOT_URL)
    .patch(CHANGE_ORG_OWNER)
    .data(formData)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
    })
    .send();
}

export function apiUpdateOrganization(formData) {
  return api()
    .root(API_ROOT_URL)
    .patch(CREATE_ORGANIZATION)
    .data(formData)
    .success((res) => {
      return res;
    })
    .error((error) => {
      // apiErrorHandler(error);
      throw error;
    })
    .badRequest400((error) => {
      console.log('error', error);
    })
    .send();
}

export function apiGetOrganizationDetails() {
  return apiGet(CREATE_ORGANIZATION);
}

// Returns free trial status for the current organization:
// is_free_trial_given, free_trial_days, free_trial_end_date
export function apiGetDashboardOrganizationDetails() {
  return apiGet(GET_DASHBOARD_ORGANIZATION_DETAILS_API);
}

export function apiGetMembers({ search = '' }) {
  return apiGet(`${GET_MEMBERS_API}?${search}`);
}
export function apiGetPermissions() {
  return apiGet(`${PERMISSIONS_API}?per_page=10000`);
}

export function apiChangePassword(formData) {
  return api()
    .root(API_ROOT_URL)
    .put(CHANGE_PASSWORD)
    .data(formData)
    .success((res) => {
      if (res && res.success) {
        successToast(
          'Your password has been updated. Feel free to change them anytime',
          'Correctly saved'
        );
      }
      return res;
    })
    .error((error) => {
      Object.values(error).forEach((value) => {
        value.forEach((error) => errorToast(error));
      });
    })
    .badRequest400((error) => {
      console.log('error', error);
    })
    .send();
}

export function apiGetRenderBasedOnProjectRenderId(projectRenderId) {
  return apiGet(`${GET_RENDER_BY_PROJ_RENDER_ID}?project_render_id=${projectRenderId}`);
}

export function apiGetAllMyOrgs({ page, perPage }) {
  const query = objectToSearchParams({
    page,
    per_page: perPage,
  });
  return apiGet(`${GET_MY_ORGANIZATIONS}?${query}`);
}

export function apiSwitchOrg(orgId) {
  return apiPost(`${SWITCH_ORG}?org=${orgId}`, null, '', null, null, false);
}

export function apiCreateOrganization(name, createdBy, countryName = '') {
  return apiPost(
    CREATE_ORGANIZATION,
    { name: name, created_by: createdBy, office_country: countryName },
    '',
    null,
    null,
    true
  );
}

// notifications panel
export function apiGetNotifications(URL, query = null) {
  const finalUrl = query === null ? URL : URL + query;

  return api()
    .root(API_ROOT_URL)
    .get(finalUrl)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiGetAllNotifications(query = null) {
  return apiGetNotifications(GET_NOTIFICATIONS, query);
}
export function apiReadNewNotifications(query = null) {
  return api()
    .root(API_ROOT_URL)
    .patch(MARK_ALL_NOTIFICATION_AS_NEW)
    .success((res) => {})
    .error((error) => {
      apiErrorHandler(error);
    })
    .send();
}
export function apiGetNewNotifications(query = null) {
  apiGetNotifications(`${GET_NOTIFICATIONS}?is_new=true`).then((response) => {
    dispatcher(setNotificationCount(response?.count));
  });
}
export function apiGetReadSpecificNotifications(query = null) {
  return apiGetNotifications(READ_SPECIFIC_NOTIFICATION, query);
}

export function apiMarkAsReadNotification(query = null) {
  return api()
    .root(API_ROOT_URL)
    .put(`${MARK_AS_READ_NOTIFICATION}${query}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMarkAllAsReadNotifications() {
  return api()
    .root(API_ROOT_URL)
    .put(MARK_ALL_AS_READ_NOTIFICATIONS)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiDeleteNotification(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${DELETE_NOTIFICATION}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiDeleteAllNotifications() {
  return api()
    .root(API_ROOT_URL)
    .delete(DELETE_ALL_NOTIFICATIONS)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiGetNotification({ id }) {
  return apiGet(`${GET_NOTIFICATIONS}${id}/`, 'apiGetNotification');
}

export async function apiGetSharedFiles(page, filter = '', sort = '', sharedTo, selectedMember) {
  const response = await apiGet(
    GET_SHARED_FILES +
      `?page=${page}&per_page=${getPerPageCount()}&sort=${sort}&type=${filter}&${sharedTo}&shared_by=${selectedMember.join(
        ','
      )}`
  );
  return response;
}

export function apiShareRequestAccess({ product, material, texture, hdri, is_curator = false }) {
  let payload = { product, material, texture, hdri, is_curator };
  Object.keys(payload).forEach((key) => {
    if (payload[key] === undefined) {
      delete payload[key];
    }
  });
  return apiPost(SHARE_REQUEST_ACCESS, payload, 'apiShareRequestAccess', null, null, true);
}

export function apiGetSharingOutsideMembersListV2({ page, isMyOrg, search, perPage }) {
  const query = objectToSearchParams({ page, is_my_org: isMyOrg, search, per_page: perPage });
  return apiGet(`${GET_SHARING_OUTSIDE_MEMBERS_LIST_API}?${query}`);
}

export function apiGetMembersListV2({ page, isMyOrg, search, perPage }) {
  const query = objectToSearchParams({ page, is_my_org: isMyOrg, search, per_page: perPage });
  return apiGet(`${GET_MEMBERS_LIST_API}?${query}`);
}

export async function apiGetMembersList(page, is_my_org, search) {
  const response = await apiGet(
    GET_MEMBERS_LIST_API + `?page=${page}&is_my_org=${is_my_org}&search=${search}`
  );
  return response;
}
export async function apiGetSearchMembersList(page, search) {
  const response = await apiGet(GET_SEARCH_MEMBER_DETAIL + `?page=${page}&search=${search}`);
  return response;
}
export async function apiGetSearchOrgMembersList(page, search) {
  const response = await apiGet(GET_SEARCH_MEMBER_ORG_DETAIL + `?page=${page}&search=${search}`);
  return response;
}

export function apiDeleteSharedModel(formData, successMsg, errorMsg) {
  let data = {};
  formData.forEach((value, key) => {
    data[key] = value;
  });
  console.log('formData', formData);
  const response = apiMultiDelete(
    DELETE_SHARED_MODEL(data?.id),
    null,
    'Delete',
    successMsg,
    errorMsg
  );
  console.log('delete', response);
  return response;
}

export function apiDeleteSharedDetails(id, successMsg, errorMsg) {
  console.log('deleted', id);
  const response = apiDelete(DELETE_SHARED_DETAILS(id.get('id')), 'Delete', successMsg, errorMsg);
  console.log('delete', response);
  return response;
}
// trash - listing
export function apiGetTrashList(query, label = null, successMessage = null, errorMessage = null) {
  if (query !== '') {
    query = `?${query}`;
  }
  return api()
    .root(API_ROOT_URL)
    .get(`${TRASH_LIST}${query}`)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      } else {
        errorToast(error);
      }
      apiErrorHandler(error, label);
    })
    .send();
}

// trash - restore
export function apiTrashRestoreRoom(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_ROOM}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashRestoreTexture(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_TEXTURE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashRestoreUploads(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_UPLOADS}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashRestoreProject(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_PROJECT}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashRestoreProjectPreview(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_PROJECT_PREVIEW}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashRestoreCollection(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_COLLECTION}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashRestoreAutomation(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_AUTOMATION}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiTrashRestoreConfigurator(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_CONFIGURATOR}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiTrashRestoreImagineAI(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_IMAGINE_AI}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiTrashRestoreRetailAutomation(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_RETAIL_AUTOMATION}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiTrashRestoreMaterial(id) {
  return api()
    .root(API_ROOT_URL)
    .post(`${RESTORE_MATERIAL}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

// trash - delete
export function apiTrashForeverRoomDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_ROOM_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashForeverTextureDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_TEXTURE_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashForeverUploadsDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_UPLOADS_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashForeverProjectDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_PROJECT_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashForeverProjectPreviewDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_PROJECT_PREVIEW_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashForeverCollectionDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_COLLECTION_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export function apiTrashForeverAutomationDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_AUTOMATION_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiTrashForeverConfiguratorDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_CONFIGURATOR_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiTrashForeverImagineAIDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_IMAGINE_AI_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiTrashForeverRetailAutomationDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_RETAIL_AUTOMATION_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiTrashForeverMaterialDelete(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${FOREVER_MATERIAL_DELETE}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

// trash - empty
export function apiTrashRestoreAll() {
  return api()
    .root(API_ROOT_URL)
    .post(RESTORE_ALL_TRASH)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      throw error;
    })
    .send();
}

export function apiTrashEmpty() {
  return api()
    .root(API_ROOT_URL)
    .delete(EMPTY_TRASH)
    .success((res) => {
      return res;
    })
    .error((error) => {
      return error;
    })
    .send();
}

export function apiCreateRender(payload) {
  return apiPost(CREATE_RENDER, payload, '', null, null, true);
}

export function apiUploadRenderImages(formData) {
  return api()
    .root(API_ROOT_URL)
    .post(UPLOAD_RENDER_IMAGES)
    .data(formData)
    .success((data) => {
      successToast('Image upload successful');
    })
    .error((error) => {
      errorToast('Error uploading images');
      apiErrorHandler(error, 'apiUploadRenderImages');
      return error;
    })
    .send();
}

export function apiCreateAutomation(payload) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (!isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return api()
    .root(API_ROOT_URL)
    .post(CREATE_AUTOMATION)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiRemoveWatermark(id) {
  return apiGet(GET_MEMBERS_API + id);
}

export function apiGetMemberDetails(id) {
  return apiGet(`${GET_MEMBERS_API}${id}/`);
}

export const apiGetOrganization = async (page, per_page, search) => {
  const response = await apiGet(
    GET_ORG_LIST + `?page=${page}&per_page=${per_page}&search=${search}`
  );
  return response;
};

export const apiShareModel = async (formData, callback) => {
  try {
    const response = await api()
      .root(API_ROOT_URL)
      .post(SHARE_MODEL)
      .data(formData)
      .success((data) => {
        successToast('Your file has been shared sucessfully');
        callback(data);
      })
      .error((error) => {
        callback(error);
      })
      .authFail401((res) => {})
      .send();

    return response;
  } catch (e) {
    console.log('asdasd', e);
  }
};

export const apiShareMultipleModelType = async (formData, callback) => {
  try {
    const response = await api()
      .root(API_ROOT_URL)
      .post(SHARE_MULTIPLE_MODEL_TYPE)
      .data(formData)
      .success((data) => {
        successToast('Your file has been shared sucessfully');
        callback?.(data);
      })
      .error((error) => {
        callback?.(error);
      })
      .authFail401((res) => {})
      .send();

    return response;
  } catch (e) {
    console.log('asdasd', e);
  }
};

export const apiGetPermissionForShare = async (payload) => {
  return await apiPost(
    GET_PERMISSION_FOR_SHARE,
    payload,
    'Permission',
    'Request sent successfully',
    'Not able to sent request',
    false,
    () => {},
    ''
  );
};

export function apiGetTextureList({ query, page, successMessage = null, errorMessage = null }) {
  if (page) {
    query = query ? `${query}&page=${page}` : `page=${page}`;
  }

  return apiGet(
    `${TEXTURE_DETAILS_API}?${query && `&${query}`}`,
    'apiGetTextureList',
    successMessage,
    errorMessage
  );
}

export function apiGetOptimizeTextureList({
  query,
  page,
  successMessage = null,
  errorMessage = null,
}) {
  if (page) {
    query = query ? `${query}&page=${page}` : `page=${page}`;
  }

  return apiGet(
    `${OPTIMIZE_TEXTURE_DETAILS_API}?${query && `&${query}`}`,
    'apiGetTextureList',
    successMessage,
    errorMessage
  );
}

export function apiGetTextures(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${TEXTURE_DETAILS_API}?is_map=false${query && `&${query}`}`,
    'apiGetTextures',
    successMessage,
    errorMessage
  );
}

export function apiGetLOAMappedTextures(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${LOA_MAPPED_TEXTURE_API}?${query}`,
    'apiGetLOAMappedTextures',
    successMessage,
    errorMessage
  );
}

export function apiGetUploads(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${TEXTURE_DETAILS_API}?is_map=true${query && `&${query}`}`,
    'apiGetUploads',
    successMessage,
    errorMessage
  );
}

export function apiGetTexture({ id, successMessage = null, errorMessage = null }) {
  return apiGet(`${TEXTURE_DETAILS_API}${id}/`, 'apiGetTexture', successMessage, errorMessage);
}

export function apiGetDownloadTextures({ ids, fileName, infoMessage }) {
  const query = `ids[]=${ids.join(',')}`;
  // return apiGetBlobV2(`${DOWNLOAD_TEXTURE}?${query}`, fileName, { auth: true });
  return apiGet(`${DOWNLOAD_TEXTURE}?${query}`)
    .then((r) => {
      if (r && r.status && r.data) {
        return download({
          fileUrl: r.data.zip_file,
          fileName,
          auth: false,
          infoMessage,
        });
      }
    })
    .catch((error) => errorToast(error.message));
}

export function apiGetTextureProducts(successMessage = null, errorMessage = null) {
  return apiGet(
    `/assetbundles/api/v3/texture/products/detail/`,
    'apiGetTextureProducts',
    successMessage,
    errorMessage
  );
}

export function apiEditTexture(
  id,
  payload,
  params,
  successMessage = 'Texture updated successfully',
  errorMessage = 'There was an issue updating the texture'
) {
  const formData = objectToFormData(payload);
  let url = `${TEXTURE_UPDATE}${id}/`;

  if (params) url += `?${params}`;
  return api()
    .root(API_ROOT_URL)
    .patch(url)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      errorToast(error?.message || errorMessage);
    })
    .badRequest400(() => {})
    .send();
}

export function apiGetMaterial({ id, successMessage = null, errorMessage = null }) {
  return apiGet(`${OP_GET_MATERIAL_API}${id}/`, 'apiGetTexture', successMessage, errorMessage);
}

export function apiEditMaterial(
  id,
  payload,
  params,
  successMessage = 'Material updated successfully',
  errorMessage = 'There was an issue updating the material'
) {
  let url = `${OP_GET_MATERIAL_API}${id}/`;

  if (params) url += `?${params}`;
  return api()
    .root(API_ROOT_URL)
    .patch(url)
    .data(payload)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      errorToast(error?.message || errorMessage);
    })
    .badRequest400(() => {})
    .send();
}

export function apiEditTextureV2({
  id,
  name,
  sku_id,
  description,
  width,
  height,
  filteroptions,
  rotation,
  live_links,
  is_guest_user = false,
  successMessage = null, // 'Texture updated successfully',
  errorMessage = 'There was an issue updating the texture',
}) {
  const payload = {
    name,
    sku_id,
    description,
    width,
    height,
    filteroptions,
    rotation,
    live_links,
  };

  const params = is_guest_user ? '?is_guest_user=true' : '';

  const formData = objectToFormData(payload);
  return api()
    .root(API_ROOT_URL)
    .patch(`${TEXTURE_UPDATE}${id}/${params}`)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      const message = error?.message?.description?.[0] || error?.message || errorMessage;
      if (typeof message === 'string') errorToast(message);
    })
    .badRequest400(() => {})
    .send();
}

export function apiBulkUploadTextures(
  payload,
  successMessage = 'Your texture has been created successfully',
  errorMessage = 'There was an issue uploading the textures.',
  isFormData = true,
  callback
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (isFormData && !isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return api()
    .root(API_ROOT_URL)
    .post(TEXTURE_BULK_UPLOAD)
    .data(formData)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage);
      }
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .badRequest400(() => {})
    .send();
}

export function textureUploadPathAPI(
  payload,
  successMessage = null,
  errorMessage = null,
  isFormData = null,
  callback
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (isFormData && !isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return api()
    .root(API_ROOT_URL)
    .post(TEXTURE_PATH_UPLOAD)
    .data(formData)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage);
      }
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .badRequest400(() => {})
    .send();
}

export function apiBulkUploadProducts(
  payload,
  successMessage = '',
  successDescription = '',
  errorMessage = 'There was an issue uploading the product 360 view images'
) {
  return apiPost(
    PRODUCT_360_BULK_UPLOAD,
    payload,
    null,
    successMessage,
    errorMessage,
    false,
    () => {},
    successDescription
  );
}

export function GetProductRenders(payload) {
  const query = objectToSearchParams(payload);
  const URL = `${GET_PRODUCT_RENDERS}?${query}`;
  return apiGet(URL);
}

export function apiGetProductRendersById(payload) {
  const query = objectToSearchParams(payload);
  const URL = `${ADD_PRODUCT_RENDER}?${query}`;
  return apiGet(URL);
}

export function apiGetProductRendersByIdPublic(payload) {
  const query = objectToSearchParams(payload);
  const URL = `${ADD_PRODUCT_RENDER_PUBLIC}?${query}`;
  return apiGet(URL);
}

export function apiCheckIsPackProductViaId(id = null) {
  if (!id) return null;
  const URL = `${CHECK_PACK_PRODUCT}?product=${id}`;
  return apiGet(URL);
}

export function apiAddProductRendersIntoProduct(payload) {
  const URL = `${ADD_PRODUCT_RENDER}`;
  return apiPost(URL, payload, null, null, null, false);
}

export function apiUpdateProductImageOrder(payload) {
  return apiPut(SILOS_OR_LIFESTYLE_PRODUCT_ORDER_UPDATE, payload, null, null, null);
}

export function apiGetProduct360UploadImages(productId) {
  const URL = `${GET_PRODUCT_360_IMAGES}?product=${productId}&per_page=100&page=1`;
  return apiGet(URL);
}

export function apiGetProduct360UploadImagesPublic(productId) {
  const URL = `${GET_PRODUCT_360_IMAGES_PUBLIC}?unicode=${productId}&per_page=100&page=1`;
  return apiGet(URL);
}

export function GetProductShareStatus(productId) {
  const URL = `${GET_PRODUCT_SHARE_DETAILS}?product=${productId}`;
  return apiGet(URL);
}

export function MakeProductPublicShare(payload) {
  const URL = `${GET_PRODUCT_SHARE_DETAILS}`;
  return apiPost(URL, payload, null, null, null, false);
}

export function UpdateProductPublicShare(payload) {
  const URL = `${GET_PRODUCT_SHARE_DETAILS}`;
  return apiPatch(URL, payload, null, null, null, false);
}

export function GetTextureShareStatus(textureId) {
  const URL = `${GET_TEXTURE_SHARE_DETAILS}?texture=${textureId}`;
  return apiGet(URL);
}

export function MakeTexturePublicShare(payload) {
  const URL = `${GET_TEXTURE_SHARE_DETAILS}`;
  return apiPost(URL, payload, null, null, null, false);
}

export function UpdateTexturePublicShare(payload) {
  const URL = `${GET_TEXTURE_SHARE_DETAILS}`;
  return apiPatch(URL, payload, null, null, null, false);
}

export function apiUpdateProductImageName(id, payload) {
  const URL = `${UPDATE_PRODUCT_IMAGE_NAME}${id}/`;
  return apiPatch(URL, payload, null, null, null, false);
}

export const apiDeleteProductImages = async (id) => {
  const URL = `${SINGLE_DELETE_PRODUCT_IMAGES}`;
  let data = null;
  await api()
    .root(API_ROOT_URL)
    .delete(`${URL}${id}/`)
    .success((res) => {
      data = res;
      return res;
    })
    .error((error) => {
      apiErrorHandler(error, '');
    })
    .send();
  return data;
};

export const DeleteProductAll360Images = async (productId) => {
  const URL = `${GET_PRODUCT_360_IMAGES}`;
  const paylaod = {
    product: productId,
  };
  let data = null;
  await api()
    .root(API_ROOT_URL)
    .delete(URL)
    .data(paylaod)
    .success((res) => {
      data = res;
      return res;
    })
    .error((error) => {
      apiErrorHandler(error, '');
    })
    .send();
  return data;
};

export const apiDeleteMultipleProductImages = async (payload) => {
  const URL = `${MULTIPLE_DELETE_PRODUCT_IMAGES}`;
  let data = null;
  await api()
    .root(API_ROOT_URL)
    .delete(URL)
    .data(payload)
    .success((res) => {
      data = res;
      return res;
    })
    .error((error) => {
      apiErrorHandler(error, '');
    })
    .send();
  return data;
};

export function apiGetProductGifsById(payload) {
  const query = objectToSearchParams(payload);
  const URL = `${SUBSCRIPTION_GIF_LINK_PRODUCT_DETAILS}?${query}`;
  return apiGet(URL);
}

export function apiGetProductGifsByIdPublic(payload) {
  const query = objectToSearchParams(payload);
  const URL = `${SUBSCRIPTION_GIF_LINK_PRODUCT_DETAILS_PUBLIC}?${query}`;
  return apiGet(URL);
}

export function apiUploadProductGifs(payload) {
  const query = objectToSearchParams(payload);
  const URL = `${SUBSCRIPTION_GIF_LINK_PRODUCT_DETAILS}?${query}`;
  return apiPost(URL, payload);
}

export function apiUpdateProductGifs(id, payload) {
  const URL = `${SUBSCRIPTION_GIF_LINK_PRODUCT_DETAILS}${id}/`;
  return apiPatch(URL, payload, null, null, null, false);
}

export async function apiDeleteProductGifs(id) {
  const URL = `${SUBSCRIPTION_GIF_LINK_PRODUCT_DETAILS}${id}/`;
  try {
    const r = await apiDelete(URL);
    return true;
  } catch (e) {
    return false;
  }
}

export function apiUploadProductImages(payload) {
  const query = objectToSearchParams(payload);
  const URL = `${SUBSCRIPTION_IMAGES_LINK_PRODUCT_DETAILS}?${query}`;
  return apiPost(URL, payload);
}

/**
 * Fresh presigned data for an existing product image, so its file and thumbnail
 * can be replaced in place. The keys name the replacements, since an edited
 * image is not always in the format the original was stored in.
 *
 * Both are put under a timestamped folder so every save lands on a new S3 key.
 * Rewriting the old key would hand back the same URLs, and the browser would go
 * on serving the pictures it already had - the card would never look updated.
 */
export function apiUpdateProductImageUpload(id, { productId, imageKey, thumbnailKey }) {
  // `_cat` with a fresh value each call -> bypass the API cache, so the
  // presigned data is always newly issued rather than served from a read.
  const query = objectToSearchParams({ product: productId, _cat: Date.now() });
  const URL = `${SUBSCRIPTION_IMAGES_LINK_PRODUCT_DETAILS}${id}/?${query}`;
  return apiPatch(URL, {
    image_file_url_key: Date.now() + '/' + imageKey,
    thumbnail_file_url_key: Date.now() + '/' + thumbnailKey,
  });
}

export function callGetFilterOptionsId(
  payload,
  successMessage = 'Get Filter Options Id',
  successDescription = '',
  errorMessage = 'Something went wrong'
) {
  return apiPost(
    GET_FILTER_OPTIONS,
    payload,
    'callGetFilterOptionsId',
    successMessage,
    errorMessage,
    false,
    () => {},
    successDescription
  );
}

export async function apiPostImageOnPresignedData(file, presigned_data, onUploadProgress) {
  const formData = new FormData();
  Object.entries(presigned_data.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });

  formData.append('file', file);
  return await axios.post(presigned_data.url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
}

export async function cancellableApiPostImageOnPresignedData(
  file,
  presigned_data,
  onUploadProgress,
  signal
) {
  const formData = new FormData();
  Object.entries(presigned_data.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });

  formData.append('file', file);

  try {
    return await axios.post(presigned_data.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
      signal,
    });
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('Upload cancelled');
    } else {
      throw error;
    }
  }
}

export async function apiGetImagePresignedData(textureIds = []) {
  const params = textureIds.map((a) => `texture_id=${a}`).join('&');
  const URL = `${GET_TEXTURE_PRESIGNED_DATA}?${params}`;

  return apiGet(URL);
}

export async function apiGetImagePresignedDataBySkuID(textureIds = []) {
  const params = textureIds.map((a) => `sku_id=${a}`).join('&');
  const URL = `${GET_TEXTURE_PRESIGNED_DATA}?${params}`;
  return apiGet(URL);
}

export async function apiGetPropDataUserFilePresigned(productId, { silent = false, noCache = false } = {}) {
  // `_cat` with a fresh value each call -> bypass the API cache.
  const url = `${GET_PROP_DATA_USER_FILE_PRESIGNED}${productId}/${noCache ? `?_cat=${Date.now()}` : ''}`;
  return apiGet(url, null, null, null, silent);
}

export function apiBulkEditTextures(
  payload,
  successMessage = null,
  errorMessage = null,
  isFormData = true,
  callback,
  successDescription
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (isFormData && !isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return api()
    .root(API_ROOT_URL)
    .post(TEXTURE_BULK_UPDATE)
    .data(formData)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage, successDescription);
      }
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .badRequest400((error) => {
      throw error;
    })
    .send();
}

export function apiBulkDeleteTextures(
  payload,
  successMessage = null,
  errorMessage = null,
  isFormData = true,
  callback,
  successDescription
) {
  return api()
    .root(API_ROOT_URL)
    .post(TEXTURE_BULK_DELETE)
    .data(payload)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage, successDescription);
      }
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .badRequest400((error) => {
      throw error;
    })
    .send();
}

export const apiBulkDeleteTexturesAdmin = async (
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiMultiDelete(
    TEXTURE_BULK_DELETE_ADMIN,
    payload,
    'apiBulkDeleteTexturesAdmin',
    successMessage,
    errorMessage
  );
};

// Filters API start
export function apiGetFilters(
  { type, perPage = 20, page = 1 } = {},
  successMessage = null,
  errorMessage = null
) {
  let query = `per_page=${perPage}&page=${page}`;
  if (type) {
    query += `&type=${type}`;
  }
  return apiGet(`${GET_FILTERS}?${query}`, 'apiGetFilters', successMessage, errorMessage);
}

export function apiCreateFilterAndOption(
  payload,
  successMessage = null,
  errorMessage = 'There was a problem while creating option'
) {
  return apiPost(
    CREATE_FILTER_OPTION,
    payload,
    'apiCreateFilterAndOption',
    successMessage,
    errorMessage,
    false
  );
}

export const apiDeleteFilter = ({ id }) => {
  return apiDelete(
    `${CREATE_FILTER_OPTION}${id}/`,
    'apiDeleteFilter',
    'Filter was deleted successfully',
    'Error happened while deleting the filter'
  );
};

export const apiUpdateFilter = ({
  id,
  label_name,
  order,
  successMessage = 'Filter updated successfully',
  errorMessage = 'Error happened while updating the filter',
}) => {
  const data = {
    ...(label_name && { label_name }),
    ...(order && { order }),
  };
  return apiPatch(
    `${CREATE_FILTER_OPTION}${id}/`,
    data,
    'apiUpdateFilter',
    successMessage,
    errorMessage,
    true
  );
};

export const apiUpdateFilterOption = ({ id, name }) => {
  const data = { name };
  return apiPatch(
    `${FILTER_OPTION}${id}/`,
    data,
    'apiUpdateFilterOption',
    'Filter option updated successfully',
    'Error happened while updating filter option',
    true
  );
};

export const apiDeleteFilterOption = ({ id }) => {
  return apiDelete(
    `${FILTER_OPTION}${id}/`,
    'apiDeleteFilterOption',
    'Filter option delete successfully',
    'Error happened while deleting filter option'
  );
};

export function apiCreateFilterOption({ filterId, options }) {
  // options: string[]
  const data = { options };

  return apiPatch(
    `${FILTER_API}${filterId}/`,
    data,
    'apiCreateFilterOption',
    'Filter option created successfully',
    'Error happened while creating filter option',
    true
  );
}
// Filters API end
export function apiGetDownloadProjectData(query) {
  return apiGetBlob(`${PROJECT_UPLOAD}?${query}&is_generate=true`);
}

export async function apiGetDownloadProject(payload) {
  return apiPost(PROJECT_UPLOAD, payload, '', '', '', false);
}

export const downloadFile = ({ fileUrl }) => {
  // this one is temporary until we prepare download progress component

  return new Promise((resolve, reject) => {
    var x = new XMLHttpRequest();
    x.open('GET', fileUrl, true);
    x.responseType = 'blob';
    x.onload = function (e) {
      resolve(e.target.response);
    };
    x.send();
  });
};

export const getSharedFileToMemberList = async (model_type, model_id) => {
  return await apiGet(
    GET_SHARED_FILES_TO_MEMBER_LIST + `?model_type=${model_type}&model_id=${model_id}`
  );
};

export const getSharedFileToOrganizationList = async (model_type, model_id) => {
  return await apiGet(
    GET_SHARED_FILES_TO_ORGANIZATION_LIST + `?model_type=${model_type}&model_id=${model_id}`
  );
};

export const removeUserFromSharedFile = async (formData) => {
  return await apiMultiDelete(REMOVE_USER_FROM_SHARED_FILE, formData);
};

export const getSharingUserDetailsList = ({
  page,
  shared_model_id,
  shared_to,
  shared_to_org,
  shared_by,
  perPage,
}) => {
  const query = objectToSearchParams({
    page,
    shared_model_id,
    shared_to,
    shared_to_org,
    shared_by,
    per_page: perPage,
  });
  return apiGet(`${GET_SHARING_USER_DETAILS}?${query}`);
};

const PERMISSION_CHECK_CACHE = {};
export function apiCheckMemberPermissions(permission_name) {
  const prevResult = PERMISSION_CHECK_CACHE[permission_name];
  const tenMinutes = 1 * ONE_SECOND; //const tenMinutes = 10 * ONE_MINUTE;

  if (prevResult && Date.now() - prevResult.timestamp < tenMinutes) {
    return prevResult.data;
  }

  const payload = new FormData();
  payload.append('permission_name', permission_name);
  try {
    return api()
      .root(API_ROOT_URL)
      .post(CHECK_MEMBER_PERMISSIONS)
      .data(payload)
      .success((data) => {
        PERMISSION_CHECK_CACHE[permission_name] = { data, timestamp: Date.now() };
        return data;
      })
      .error((error) => {
        throw error;
      })
      .accessDenied403((res) => {
        console.error('accessDenied403 res: ', res);
      })
      .send();
  } catch (error) {
    console.error('error: ', error);
    throw error;
  }
  // return apiPost(CHECK_MEMBER_PERMISSIONS, payload);
}

export function apiGetMemberOrganizationPermissions() {
  return apiGet(`${GET_MEMBER_ORG_PERMISSIONS}?per_page=100`);
}
export const cachedApiGetMemberOrganizationPermissions = memoize(
  apiGetMemberOrganizationPermissions,
  { maxAge: ONE_SECOND }
);

export function apiGetOnlyOrganizationPermissions() {
  return apiGet(`${GET_ONLY_ORG_PERMISSIONS}?per_page=100`);
}
export const cachedApiGetOnlyOrganizationPermissions = memoize(apiGetOnlyOrganizationPermissions, {
  maxAge: ONE_SECOND,
});

// Support module APIs start

export const apiSupportRequestMissingTempaltes = ({ templateName }) => {
  const payload = new FormData();
  payload.append('template_name', templateName);

  return apiPost(
    SUPPORT_REQUEST_MISSING_TEMPLATES,
    payload,
    'apiSupportRequestMissingTempaltes',
    'Request for missing template has been sent successfully',
    'Error happened while sendng request to for missing template'
  );
};
SUPPORT_REQUEST_MISSING_TEMPLATES;

export const apiGetSupportPipelines = () => {
  return apiGet(GET_SUPPORT_PIPELINES, 'apiGetSupportPipelines', null, null);
};

export const apiPostCreateTicket = (data) => {
  console.log('here....');
  return apiPost(CREATE_TICKET, data, 'apiPostCreateTicket', null, null, false);
};

export const apiGetTicket = (id) => {
  return apiGet(GET_TICKET + id + '/', 'apiGetTicket', null, null);
};

export const apiGetTicketMessages = (id, page) => {
  return apiGet(
    `/support/api/v3/ticket-messages/?ticket=${id}&page=${page}&per_page=20`,
    'apiGetTicketMessages',
    null,
    null
  );
};

export const apiPostCreateTicketMessage = (data) => {
  return apiPost(CREATE_TICKET_MESSAGE, data, 'apiPostCreateTicketMessage', null, null, false);
};

export const apiPostTicketFeedback = (data) => {
  return apiPost(TICKET_FEEDBACK, data, 'apiPostTicketFeedback', null, null, false);
};

// Support module APIs end

// get common global tags
export const apiGetCommonGlobalTags = ({ model, tags, page, perPage }) => {
  const params = objectToSearchParams({
    model,
    tags,
    page,
    per_page: perPage,
  });

  return apiGet(`${COMMON_GLOBAL_TAGS}?${params}`, 'apiGetCommonGlobalTags', null, null);
};

// Automation

export async function apiGetAutomationList(createdBy = '') {
  // return apiGet(`${GET_AUTOMATION_API}${_id}/`);
  let params = '?';
  if (createdBy) {
    params += `created_by=${createdBy}&`;
  }
  params += `per_page=1&page=1&sort=-created_at`;

  return api()
    .root(API_ROOT_URL)
    .get(`${GET_AUTOMATION_API}${params}`)
    .success((data) => {
      dispatcher(subscriptionActions.setAutomationsData(data?.results?.length > 0));
      return data;
    })
    .error((error) => {
      dispatcher(subscriptionActions.setAutomationsData(false));
      // throw error;
    })
    .send();
}

export async function apiGetAutomation(_id) {
  return apiGet(`${GET_AUTOMATION_API}${_id}/`);
}

export async function apiGetAutomationExcels(_id) {
  return apiGet(`${GET_AUTOMATION_EXCELS_API}${_id}/`);
}

export async function apiGetDownloadAutomation(payload) {
  return apiPost(DOWNLOAD_AUTOMATION, payload, '', '', '', false);
}

export function apiRestoreMutipleArchivedAutomation(payload) {
  return api()
    .root(API_ROOT_URL)
    .patch(MULTIPLE_ARCHIVED_AUTOMATION_RESTORE)
    .data(payload)
    .success((res) => {
      if (res?.message) {
        successToast(res?.message);
      }
      return res;
    })
    .error((error) => {
      if (error?.message) {
        errorToast(error?.message);
      }
      apiErrorHandler(error, 'apiRestoreMutipleArchivedAutomation');
    })
    .send();
}

export function apiArchiveAutomation({ idList, onDeleteFailed }) {
  const payload = new FormData();
  idList.forEach((id) => {
    payload.append('id', id);
  });

  return api().root(API_ROOT_URL).delete(GET_AUTOMATION_API).data(payload).send();
  // .send((errResponse, errStatus, response) => {
  //   if (response?.data?.data) {
  //     // need to change this logic for automation
  //     const deleteFailedItems = Object.entries(response?.data?.data)
  //       .filter(([id, { archived, deleted }]) => {
  //         return !archived && !deleted;
  //       })
  //       .map(([id, { archived, deleted }]) => ({
  //         id,
  //         archived,
  //         deleted,
  //       }));
  //     if (deleteFailedItems.length) {
  //       onDeleteFailed(deleteFailedItems);
  //     }
  //   }
  // });
}

export function apiDeleteAutomation(_id) {
  const payload = new FormData();
  payload.append('id', _id);

  return apiMultiDelete(GET_AUTOMATION_API, payload, '', '');
}

export function apiEditAutomation(
  id,
  payload,
  successMessage = 'Automation updated successfully.',
  errorMessage = 'There was an issue updating this automation.',
  query = ''
) {
  // const param = id.includes('?') ? id : `${id}/`;

  return apiPatch(
    `${UPDATE_AUTOMATION}${id}/${query}`,
    payload,
    'apiEditAutomation',
    successMessage,
    errorMessage
  );
}

export function apiEnableTemplateRender(
  payload,
  successMessage = 'Template Sent For Render.',
  errorMessage = 'There was an issue with this template.',
  query = '',
  callback
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (!isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return api()
    .root(API_ROOT_URL)
    .post(ENABLE_AUTOMATION_RENDER_API)
    .data(formData)
    .success((data) => {
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .authFail401((res) => {})
    .send();
}
export function apiCreateTemplatePreview(
  payload,
  successMessage = 'Template Sent For Preview.',
  errorMessage = 'There was an issue with this template.',
  query = '',
  callback
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (!isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return api()
    .root(API_ROOT_URL)
    .post(CREATE_AUTOMATION_PREVIEW_API)
    .data(formData)
    .success((data) => {
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .authFail401((res) => {})
    .send();
}

export function apiDeleteTemplate(
  payload,
  automationId,
  successMessage = 'Template deleted successfully.',
  errorMessage = 'There was an issue deleting this template.',
  query = '',
  callback
) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${GET_AUTOMATION_DETAIl_API}${automationId}/`)
    .data(payload)
    .badRequest400(() => {})
    .success((res) => {
      return res;
    })
    .error((error) => {
      if (callback) {
        callback(error?.data);
      }
      return error;
    })
    .send();
}

export function apiUploadAutomationTemplateFile(
  payload,
  successMessage = 'Correctly saved',
  successDescription = 'File uploaded successfully',
  errorMessage = 'There was an issue uploading the file',
  callback
) {
  let formData = payload;
  const isPayloadFormData = formData instanceof FormData;
  if (!isPayloadFormData) {
    formData = objectToFormData(payload);
  }

  return api()
    .root(API_ROOT_URL)
    .post(AUTOMATION_TEMPLATE_FILE_UPLOAD)
    .data(formData)
    .success((data) => {
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .authFail401((res) => {})
    .send();
}

// onboarding - gamified

export function apiGetTutorialRooms() {
  return apiGet(TUTORIAL_ROOMS, 'apiGetTutorialRooms', null, null);
}
export function apiGetAppFeedback() {
  return apiGet(APP_FEEDBACK, 'apiGetAppFeedback', null, null);
}
export function apiSubmitAppFeedback(payload, callback) {
  const formData = objectToFormData(payload);
  return api()
    .root(API_ROOT_URL)
    .post(APP_FEEDBACK)
    .data(formData)
    .success((data) => {
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .send();
}

export function apiGetConfiguratorPreview({ status, page, perPage }) {
  const query = objectToSearchParams({ status, page, per_page: perPage });

  const response = [
    {
      id: 1,
      title: 'file name 1',
      type: 'interactive',
      status: 'done',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 2,
      title: 'file name 2',
      type: 'static',
      status: 'done',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 3,
      title: 'file name 3',
      type: 'interactive',
      status: 'processing',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 4,
      title: 'file name 4',
      type: 'static',
      status: 'done',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 5,
      title: 'file name 5',
      type: 'static',
      status: 'processing',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 6,
      title: 'file name 6',
      type: 'static',
      status: 'done',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 7,
      title: 'file name 7',
      type: 'interactive',
      status: 'processing',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 8,
      title: 'file name 8',
      type: 'static',
      status: 'done',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 9,
      title: 'file name 9',
      type: 'interactive',
      status: 'processing',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 10,
      title: 'file name 10',
      type: 'static',
      status: 'done',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 11,
      title: 'file name 11',
      type: 'interactive',
      status: 'processing',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 12,
      title: 'file name 12',
      type: 'static',
      status: 'done',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
    {
      id: 13,
      title: 'file name 13',
      type: 'interactive',
      status: 'processing',
      created_at: '2023-01-10T11:14:46.191513+05:30',
    },
  ].filter((a) => a.status === status.toLowerCase());

  return {
    loading: false,
    list: response,
  };

  // return apiGet(`${GET_MEMBERS_API}?${query}`);
}

export const apiCreateConfiguratorPreview = (data) => {
  return apiPost(
    isV2() ? SET_PREVIEW_CONFIGURATOR_V2 : SET_PREVIEW_CONFIGURATOR,
    data,
    'apiSetPreviewConfigurator',
    null,
    null,
    false
  );
};

export const apiShareImage = async (payload, successMessage = null, errorMessage = null) => {
  return await api()
    .root(API_ROOT_URL)
    .post(SHARE_IMAGE)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

export async function apiCreateGamifyRender(formData, callback) {
  return await api()
    .root(API_ROOT_URL)
    .post(CREATE_GAMIFY_RENDER)
    .data(formData)
    .success((data) => {
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .send();
}

export const apiGetTutorialRoomState = (id = null) => {
  let URL = TUTORIAL_ROOM_STATE;
  if (id) {
    URL = `${TUTORIAL_ROOM_STATE}${id}/`;
  }
  return apiGet(URL, 'apiGetTutorialRoomState', null, null);
};

export const apiCreateTutorialRoomState = async (
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPost(
    TUTORIAL_ROOM_STATE,
    payload,
    'apiCreateTutorialRoomState',
    successMessage,
    errorMessage,
    false
  );
};

export const apiUpdateTutorialRoomState = (
  id,
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return apiPatch(
    `${TUTORIAL_ROOM_STATE}${id}/`,
    payload,
    'apiUpdateTutorialRoomState',
    successMessage,
    errorMessage,
    false
  );
};

export const apiDeleteTutorialRoomState = async (
  id,
  successMessage = null,
  errorMessage = null
) => {
  return await apiDelete(
    `${TUTORIAL_ROOM_STATE}${id}/`,
    'apiDeleteTutorialRoomState',
    successMessage,
    errorMessage
  );
};

export const apiGetAllFinishes = (id = null) => {
  let URL = TEXTURE_FINISHES;
  return apiGet(URL, 'apiGetFinishes', null, null);
};

export const apiCreateConfiguratorFabricPreview = (data) => {
  return apiPost(
    SET_PREVIEW_FABRIC_CONFIGURATOR,
    data,
    'apiSetPreviewFabricConfigurator',
    null,
    null,
    false
  );
};

export async function apiGetPreviewListing(
  params,
  successMessage = null,
  errorMessage = null,
  v2 = false
) {
  const result = await fetchAllPages((page) => {
    const url = `${isV2() || v2 ? GET_PREVIEW_LIST_DATA_V2 : GET_PREVIEW_LIST_DATA}?${params}`;
    const paginatedUrl = `${url}&page=${page}`;
    return apiGet(paginatedUrl, 'apiGetPreviewListing', successMessage, errorMessage);
  });
  return result;
}

export function apiDeleteRenderRequest(payload, successMessage = null, errorMessage = null) {
  return apiMultiDelete(
    `${isV2() ? GET_PREVIEW_LIST_DATA_V2 : GET_PREVIEW_LIST_DATA}`,
    payload,
    'apiDeleteConfiguratorRenders',
    successMessage,
    errorMessage
  );
}

export const apiCreateConfiguratorRender = (data) => {
  return apiPost(
    isV2() ? SET_PREVIEW_RENDER_CONFIGURATOR_V2 : SET_PREVIEW_RENDER_CONFIGURATOR,
    data,
    'apiSetPreviewRenderConfigurator',
    null,
    null,
    false
  );
};
// Request

// Request
export const apiCreateRequest = async (payload, successMessage = null, errorMessage = null) => {
  return await apiPost(
    REQUEST_API,
    payload,
    'apiCreateRequest',
    successMessage,
    errorMessage,
    false
  );
};

export const apiGetAllRequests = async () => {
  return await fetchAllPages((page) => {
    return api()
      .root(API_ROOT_URL)
      .get(`${REQUEST_API}?page${page}&per_page=20`)
      .success((data) => {
        return data;
      })
      .error((error) => {
        throw error;
      })
      .send();
  });
};

export const apiGetRequest = async (id) => {
  let URL = REQUEST_API;
  if (id) {
    URL = `${REQUEST_API}${id}/`;
  }
  return apiGet(URL, 'apiGetRequest', null, null);
};

export const apiDeleteRequest = async (id) => {
  let URL = REQUEST_API;
  if (id) {
    URL = `${REQUEST_API}${id}/`;
  }
  return apiDelete(URL, 'apiDeleteRequest', null, null);
};

export const apiUpdateRequest = async (id, payload, successMessage = null, errorMessage = null) => {
  return await apiPatch(
    `${REQUEST_API}${id}/`,
    payload,
    'apiUpdateRequest',
    successMessage,
    errorMessage,
    false
  );
};

export const apiDeleteRequestFile = async (id) => {
  return await apiDelete(
    `${REQUEST_3D_UPLOAD_API}${id}/`,
    'apiDeleteRequestFile',
    null,
    null,
    false
  );
};

export const apiUploadRequestFiles = async (
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPost(
    REQUEST_3D_UPLOAD_API,
    payload,
    'apiUploadRequestFiles',
    successMessage,
    errorMessage,
    false
  );
};

export const apiGetRequestFiles = async (params) => {
  return await apiGet(
    `${REQUEST_3D_UPLOAD_API}?${params}`,
    'apiGetRequestFiles',
    null,
    null,
    false
  );
};

export const apiUpdateRequestFiles = async (
  id,
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPatch(
    `${REQUEST_GET_IMAGES_API}${id}/`,
    payload,
    'apiUpdateRequestFiles',
    successMessage,
    errorMessage,
    false
  );
};

export const apiGetRequestImages = async (params) => {
  return await apiGet(
    `${REQUEST_GET_IMAGES_API}?${params}`,
    'apiGetRequestFiles',
    null,
    null,
    false
  );
};

export const apiUploadRequestTexture = async (
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPost(
    REQUEST_TEXTURE_UPLOAD_API,
    payload,
    'apiUploadRequestTexture',
    successMessage,
    errorMessage,
    false
  );
};

export const apiDeleteRequestTexture = async (id, successMessage = null, errorMessage = null) => {
  return await apiDelete(
    `${REQUEST_TEXTURE_UPLOAD_API}${id}`,
    'apiUploadRequestTexture',
    successMessage,
    errorMessage,
    false
  );
};

export const apiUpdateRequestTexture = async (
  id,
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPatch(
    `${REQUEST_TEXTURE_UPLOAD_API}${id}/`,
    payload,
    'apiUpdateRequestTexture',
    successMessage,
    errorMessage,
    false
  );
};

export const apiUploadRequestParts = async (
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPost(
    REQUEST_PARTS_API,
    payload,
    'apiUploadRequestParts',
    successMessage,
    errorMessage,
    false
  );
};

export const apiGetRequestParts = async (params, successMessage = null, errorMessage = null) => {
  return await apiGet(
    `${REQUEST_PARTS_API}${params}`,
    'apiGetRequestParts',
    successMessage,
    errorMessage,
    false
  );
};

export const apiDeleteRequestParts = async (
  id,
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiMultiDelete(
    `${REQUEST_GET_IMAGES_API}${id}/`,
    payload,
    'apiDeleteRequestParts',
    successMessage,
    errorMessage,
    false
  );
};

export const apiUpdateRequestPart = async (
  id,
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPatch(
    `${REQUEST_PARTS_API}${id}/`,
    payload,
    'apiUpdateRequestPart',
    successMessage,
    errorMessage,
    false
  );
};

export const apiDeleteRequestPart = async (id, successMessage = null, errorMessage = null) => {
  return await apiDelete(
    `${REQUEST_PARTS_API}${id}/`,
    'apiUpdateRequestPart',
    successMessage,
    errorMessage,
    false
  );
};

export const apiGetRequestTexture = async (_id) => {
  return await apiGet(
    `${REQUEST_TEXTURE_GET_API}${_id}`,
    'apiGetRequestTexture',
    null,
    null,
    false
  );
};

export const apiGetRequestProductCategoreis = async (params) => {
  return await apiGet(
    `${REQUEST_PRODUCT_CATEGORY_API}?${params}`,
    'apiGetRequestProductCategoreis',
    null,
    null,
    false
  );
};

export const apiPostRequestComment = async (
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPost(
    REQUEST_COMMENT_API,
    payload,
    'apiUploadRequestParts',
    successMessage,
    errorMessage,
    false
  );
};

export const apiPostRequestFeedback = async (
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPost(
    REQUEST_FEEDBACK_API,
    payload,
    'apiPostRequestFeedback',
    successMessage,
    errorMessage,
    false
  );
};

export const apiSubmitRequest = async (
  _id,
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPost(
    `${REQUEST_SUBMIT_API}${_id}/`,
    payload,
    'apiSubmitRequest',
    successMessage,
    errorMessage,
    false
  );
};

export const apiInjectRequest = async (
  payload,
  successMessage = null,
  errorMessage = null,
  callback = null
) => {
  return await apiPost(
    `${REQUEST_INJECT_API}`,
    payload,
    'apiSubmitRequest',
    successMessage,
    errorMessage,
    false,
    callback
  );
};

export const apiUpdateRequestComment = async (
  _id,
  payload,
  successMessage = null,
  errorMessage = null
) => {
  return await apiPatch(
    `${REQUEST_COMMENT_API}${_id}/`,
    payload,
    'apiUpdateRequestComment',
    successMessage,
    errorMessage,
    false
  );
};

export const apiGetRequestComments = async (params) => {
  return await apiGet(
    `${REQUEST_COMMENT_API}?${params}`,
    'apiGetRequestProductCategoreis',
    null,
    null,
    false
  );
};

export async function apiGetPublicProductLinkData(id) {
  return api()
    .root(API_ROOT_URL)
    .get(`${PUBLIC_PRODUCT_LINK_DATA}${id}/`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}

export async function apiGetPublicTextureLinkData(id) {
  return api()
    .root(API_ROOT_URL)
    .get(`${PUBLIC_TEXTURE_LINK_DATA}${id}/`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}

export async function apiCheckUserHaveProductPageV2Access(params) {
  return api()
    .root(API_ROOT_URL)
    .get(`${PUBLIC_PRODUCT_PAGE_V2_USER_ACCESS}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}

export async function apiGetProductPageWhoCanAccessType(params) {
  return api()
    .root(API_ROOT_URL)
    .get(`${PRODUCT_PAGE_V2_ACCESS_TYPE_PERMISSION}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}

export async function apiGetSharedProductPageListVieEmail(params) {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_SHARED_PRODUCT_PAGE_LIST_VIA_EMAIL_API}${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}
export async function apiGetPublicProductPageWhoCanAccessType(params) {
  return api()
    .root(API_ROOT_URL)
    .get(`${PUBLIC_PRODUCT_PAGE_V2_ACCESS_TYPE_PERMISSION}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}

export async function apiAddWhoCanAccessTypeValue(payload) {
  return api()
    .root(API_ROOT_URL)
    .post(`${PRODUCT_PAGE_V2_ACCESS_TYPE_PERMISSION}`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}

export async function apiUpdateWhoCanAccessTypeValue({ id, data }) {
  return apiPatch(`${PRODUCT_PAGE_V2_ACCESS_TYPE_PERMISSION}${id}/`, data, '', '', '', false);
}

export async function apiGetPublicProductVideoLinkData(id) {
  return api()
    .root(API_ROOT_URL)
    .get(`${PUBLIC_PRODUCT_VIDEO_LINK_DATA}${id}/`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}

export async function apiGetPublicTextureVideoLinkData(id) {
  return api()
    .root(API_ROOT_URL)
    .get(`${PUBLIC_TEXTURE_VIDEO_LINK_DATA}${id}/`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
      throw error;
    })
    .send();
}

export async function apiGetPublicUUID(params) {
  return apiGet(`${PUBLIC_LINK}${params}`);
}

export async function apiGetPublicUUIDTexture(params) {
  return apiGet(`${PUBLIC_LINK_TEXTURE}${params}`);
}

export async function apiGetPublicUUIDPublic(params) {
  return apiGet(`${PUBLIC_LINK_PUBLIC}${params}`);
}

export async function apiDeletePublicUUID(_uuid) {
  return apiDelete(`${PUBLIC_LINK}${_uuid}`);
}

export async function apiCreatePublicUUID(payload) {
  return apiPost(PUBLIC_LINK, payload, '', '', '', false);
}

export async function apiCreatePublicUUIDTexture(payload) {
  return apiPost(PUBLIC_LINK_TEXTURE, payload, '', '', '', false);
}

export async function apiUpdatePublicUUIDPublic(unicode, payload) {
  return apiPatch(`${PUBLIC_LINK}${unicode}/`, payload, '', '', '', false);
}

export async function apiUpdatePublicUUIDTexture(unicode, payload) {
  return apiPatch(`${PUBLIC_LINK_TEXTURE}${unicode}/`, payload, '', '', '', false);
}

export async function apiCreatePublicUUIDPublic(payload) {
  return apiPost(PUBLIC_LINK_PUBLIC, payload, '', '', '', false);
}

// Fire-and-forget PATCH that flips PublicModel.is_opened → true. Endpoint is
// unauthenticated and returns raw JSON (no {status, data, message} envelope),
// so we bypass the wrapped api() helper. Wrapped in try/catch — the viewer
// must never break because a tracking ping failed.
export async function apiMarkPublicLinkOpened(uniqueCode) {
  if (!uniqueCode) return;
  try {
    await fetch(`${API_ROOT_URL}${PUBLIC_LINK_OPENED}${uniqueCode}/`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ is_opened: true }),
      keepalive: true,
    });
  } catch (_) {
    // best-effort tracking
  }
}

export async function apiGetPublicProductData(token) {
  const filterToken = token?.includes('/') ? token : `${token}/`;
  return apiGet(`${PUBLIC_PRODUCT_LINK}${filterToken}`);
}

export function getRecentFilesHomePage(params) {
  const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
  const url = GET_RECENT_FILES_API?.replace(':org_id', currentUser?.id)?.replace(
    ':mem_id',
    currentUser?.organization
  );
  const searchParams = objectToSearchParams(params);
  return apiGet(`${url}?${searchParams}`);
}

export function getRecentFileHomePage(id) {
  const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
  const url = GET_RECENT_FILES_API?.replace(':org_id', currentUser?.id)?.replace(
    ':mem_id',
    currentUser?.organization
  );
  return apiGet(`${url}/${id}/`);
}

// Automatic AI Video

export const createAutomaticAIVideo = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(AUTOMATIC_AI_VIDEO)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const getAutomaticAIVideo = (params) => {
  return api()
    .root(API_ROOT_URL)
    .get(`${AUTOMATIC_AI_VIDEO}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const updateAutomaticAIVideo = ({ id, payload }) => {
  return api()
    .root(API_ROOT_URL)
    .patch(`${AUTOMATIC_AI_VIDEO}${id}/`)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const updateAutomaticAIVideoOrder = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .patch(AUTOMATIC_AI_VIDEO_ORDER)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const createAutomaticAIVideoPreview = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(AUTOMATIC_AI_VIDEO_PREVIEWS)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const createAutomaticAIVideoRender = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(AUTOMATIC_AI_VIDEO_RENDER)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const reRenderAutomaticAIVideo = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(AUTOMATIC_AI_VIDEO_RE_RENDER)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const reRenderAutomaticAIVideoRender = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(AUTOMATIC_AI_VIDEO_RE_RENDER_RENDER)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

export const cancelAIVideoRender = (payload) => {
  return api()
    .root(API_ROOT_URL)
    .post(AUTOMATIC_AI_VIDEO_CANCEL_RENDER)
    .data(payload)
    .success((data) => {
      return data;
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};

// guest user permission
export function apiCheckGuestUserPermission() {
  return api()
    .root(API_ROOT_URL)
    .get(CHECK_GUEST_USER_PERMISSION)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

// image search post
export function apiPostImageSearch({
  params,
  formData,
  successMessage = null,
  errorMessage = null,
}) {
  return api()
    .root(API_ROOT_URL)
    .post(`${IMAGE_SEARCH_API}?${params}`)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

// Collect 3d files
export function apiPostCollect3DFilesRequestAPI({ formData }) {
  return api()
    .root(API_ROOT_URL)
    .post(CREATE_3D_FILES_ZIP)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiPatchCollect3DFilesRequestAPI({ id, formData }) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${CREATE_3D_FILES_ZIP}${id}/`)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiGetCollect3DFilesRequestAPI(params) {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_3D_FILES_ZIP}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      return error;
    })
    .send();
}

// Optimize Images - Filter APIs
export const getImagesSidefilterCollections = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_IMAGES_SIDEFILTER_COLLECTIONS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

export const getImagesSidefilterBrands = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_IMAGES_SIDEFILTER_BRANDS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getImagesSidefilterProps = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_IMAGES_SIDEFILTER_PROPS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getImagesSidefilterLabels = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_IMAGES_SIDEFILTER_LABELS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getImagesSidefilterOptions = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_IMAGES_SIDEFILTER_OPTIONS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

// Optimize Projects - Filter APIs
export const getProjectsSidefilterCollections = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_PROJECTS_SIDEFILTER_COLLECTIONS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getProjectsSidefilterBrands = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_PROJECTS_SIDEFILTER_BRANDS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getProjectsSidefilterProps = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_PROJECTS_SIDEFILTER_PROPS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getProjectsSidefilterLabels = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_PROJECTS_SIDEFILTER_LABELS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getProjectsSidefilterOptions = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_PROJECTS_SIDEFILTER_OPTIONS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

// Optimize Prop & My Prop - Filter APIs
export const getPropSidefilterCollections = (params = '') => {
  // const url = GET_PROP_SIDEFILTER_COLLECTIONS;
  const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
  const url = GET_PROP_SIDEFILTER_COLLECTIONS_ORGID.replace(':orgId', currentUser?.organization);
  return api()
    .root(API_ROOT_URL)
    .get(`${url}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getPropSidefilterBrands = (params = '') => {
  // const url = GET_PROP_SIDEFILTER_BRANDS;
  const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
  const url = GET_PROP_SIDEFILTER_BRANDS_ORGID.replace(':orgId', currentUser?.organization);
  return api()
    .root(API_ROOT_URL)
    .get(`${url}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getPropSidefilterProps = (params = '') => {
  return [];
};
export const getPropSidefilterLabels = (params = '') => {
  // const url = GET_PROP_SIDEFILTER_LABELS;
  const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
  const url = GET_PROP_SIDEFILTER_LABELS_ORGID.replace(':orgId', currentUser?.organization);
  return api()
    .root(API_ROOT_URL)
    .get(`${url}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getPropSidefilterOptions = (params = '') => {
  // const url = GET_PROP_SIDEFILTER_OPTIONS;
  const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
  const url = GET_PROP_SIDEFILTER_OPTIONS_ORGID.replace(':orgId', currentUser?.organization);
  return api()
    .root(API_ROOT_URL)
    .get(`${url}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

// Optimize Templates & My Rooms - Filter APIs
export const getRoomsSidefilterCollections = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_ROOMS_SIDEFILTER_COLLECTIONS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getRoomsSidefilterBrands = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_ROOMS_SIDEFILTER_BRANDS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getRoomsSidefilterProps = (params = '') => {
  return [];
};
export const getRoomsSidefilterLabels = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_ROOMS_SIDEFILTER_LABELS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getRoomsSidefilterOptions = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_ROOMS_SIDEFILTER_OPTIONS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

// Optimize Textures & Custom maps - Filter APIs
export const getTexturesSidefilterCollections = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_TEXTURES_SIDEFILTER_COLLECTIONS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

export const getTexturesSidefilterBrands = (params = '') => {
  return [];
};
export const getTexturesSidefilterProps = (params = '') => {
  return [];
};
export const getTexturesSidefilterLabels = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_TEXTURES_SIDEFILTER_LABELS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getTexturesSidefilterOptions = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${addOrgIdIntoAPIUrl(GET_TEXTURES_SIDEFILTER_OPTIONS)}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

// Optimize Materials - Filter APIs
export const getMaterialSidefilterCollections = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_MATERIAL_SIDEFILTER_COLLECTIONS}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getMaterialSidefilterBrands = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(
      `${GET_MATERIAL_SIDEFILTER_BRANDS}?${params.replace('is_map=false&is_guest_user=false&', '')}`
    )
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getMaterialSidefilterProps = (params = '') => {
  return [];
};
export const getMaterialSidefilterLabels = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_MATERIAL_SIDEFILTER_LABELS}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};
export const getMaterialSidefilterOptions = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_MATERIAL_SIDEFILTER_OPTIONS}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

// 'getSidefilters' - this function get the filters based on the filter type & model type.
export const getSidefilters = ({ params = '', type = '', modelType = '' }) => {
  if (!type || !modelType) return [];
  let fun = null;

  if (modelType === MODEL_TYPES.PROJECTS) {
    if (type === 'collections') {
      fun = getProjectsSidefilterCollections;
    } else if (type === 'brands') {
      fun = getProjectsSidefilterBrands;
    } else if (type === 'props') {
      fun = getProjectsSidefilterProps;
    } else if (type === 'filterLabels') {
      fun = getProjectsSidefilterLabels;
    } else if (type === 'filterOptions') {
      fun = getProjectsSidefilterOptions;
    }
  } else if (modelType === MODEL_TYPES.PROJECTRENDER) {
    if (type === 'collections') {
      fun = getImagesSidefilterCollections;
    } else if (type === 'brands') {
      fun = getImagesSidefilterBrands;
    } else if (type === 'props') {
      fun = getImagesSidefilterProps;
    } else if (type === 'filterLabels') {
      fun = getImagesSidefilterLabels;
    } else if (type === 'filterOptions') {
      fun = getImagesSidefilterOptions;
    }
  } else if (modelType === MODEL_TYPES.PRODUCT || modelType === MODEL_TYPES.THREEDMODELS) {
    if (type === 'collections') {
      fun = getPropSidefilterCollections;
    } else if (type === 'brands') {
      fun = getPropSidefilterBrands;
    } else if (type === 'props') {
      fun = getPropSidefilterProps;
    } else if (type === 'filterLabels') {
      fun = getPropSidefilterLabels;
    } else if (type === 'filterOptions') {
      fun = getPropSidefilterOptions;
    }
  } else if (modelType === MODEL_TYPES.TEMPLATES || modelType === MODEL_TYPES.ROOM) {
    if (type === 'collections') {
      fun = getRoomsSidefilterCollections;
    } else if (type === 'brands') {
      fun = getRoomsSidefilterBrands;
    } else if (type === 'props') {
      fun = getRoomsSidefilterProps;
    } else if (type === 'filterLabels') {
      fun = getRoomsSidefilterLabels;
    } else if (type === 'filterOptions') {
      fun = getRoomsSidefilterOptions;
    }
  } else if (modelType === MODEL_TYPES.TEXTURE || modelType === MODEL_TYPES.UPLOADS) {
    if (type === 'collections') {
      fun = getTexturesSidefilterCollections;
    } else if (type === 'brands') {
      fun = getTexturesSidefilterBrands;
    } else if (type === 'props') {
      fun = getTexturesSidefilterProps;
    } else if (type === 'filterLabels') {
      fun = getTexturesSidefilterLabels;
    } else if (type === 'filterOptions') {
      fun = getTexturesSidefilterOptions;
    }
  } else if (modelType === MODEL_TYPES.MATERIAL) {
    if (type === 'collections') {
      fun = getMaterialSidefilterCollections;
    } else if (type === 'brands') {
      fun = getMaterialSidefilterBrands;
    } else if (type === 'props') {
      fun = getMaterialSidefilterProps;
    } else if (type === 'filterLabels') {
      fun = getMaterialSidefilterLabels;
    } else if (type === 'filterOptions') {
      fun = getMaterialSidefilterOptions;
    }
  }

  // getting 20 data at once for filters
  const filterSearchValue = selectFilterSearchValue(getAppState());
  let _params = new URLSearchParams(params);
  _params.set('per_page', '20');
  if (filterSearchValue && type !== 'filterLabels') {
    // Here, we are not passing the search in the filterLabels api as if we do so then we are not able to search in the filter options which is dependent on the filterLabels
    _params.set('search', filterSearchValue);
  }
  _params = _params.toString();
  return fun?.(_params);
};

export const getTutorialVideo = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_TUTORIAL_VIDEO}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

export const getTutorialSubCategoryFilterOptionList = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_TUTORIAL_VIDEO_SUB_CATEGORY_OPTION_LIST}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

export const getTutorialCategoryDetails = (params = '') => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_TUTORIAL_CATEGORY_DETAILS}?${params}`)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
};

// Measurement Lines Images section apis
export function apiGetImageMeasurementData(
  id,
  successMessage = null,
  errorMessage = null,
  param = ''
) {
  return apiGet(
    `${MEASUREMENT_DETAILS}?render_image=${id}`,
    'apiGetImageMeasurementData',
    successMessage,
    errorMessage
  );
}

export function apiGetPublicImageMeasurementData(
  id,
  successMessage = null,
  errorMessage = null,
  param = ''
) {
  return apiGet(
    `${PUBLIC_MEASUREMENT_DETAILS}?render_image=${id}`,
    'apiGetPublicImageMeasurementData',
    successMessage,
    errorMessage
  );
}

export function apiPatchPublicImageMeasurementData(
  id,
  payload,
  successMessage = null,
  errorMessage = null
) {
  const formData = objectToFormData(payload);

  return apiPatch(
    `${PUBLIC_MEASUREMENT_DETAILS}${id}/`,
    formData,
    'apiPatchPublicImageMeasurementData',
    successMessage,
    'Unable to upload dimensionshot image',
    false
  );
}

export function apiGetPublicImageMeasurementDataShare(
  id,
  successMessage = null,
  errorMessage = null,
  param = ''
) {
  return apiGet(
    `${PUBLIC_MEASUREMENT_DETAILS_SHARE}?render_image=${id}`,
    'apiGetPublicImageMeasurementData',
    successMessage,
    errorMessage
  );
}

export async function apiPostImageMeasurementData(
  payload,
  successMessage = null,
  errorMessage = null
) {
  return await apiPost(
    MEASUREMENT_DETAILS,
    payload,
    'apiPostImageMeasurementData',
    successMessage,
    errorMessage,
    false
  );
}

export const apiPatchImageMeasurementData = async (
  id,
  payload,
  successMessage = 'Data updated successfully',
  errorMessage = null //'There was an error while updating details'
) => {
  return await apiPatch(
    `${MEASUREMENT_DETAILS}${id}/`,
    payload,
    'apiPatchImageMeasurementData',
    successMessage,
    errorMessage,
    false
  );
};

export function apiGetToggleImageMeasure(
  id,
  successMessage = null,
  errorMessage = null,
  param = ''
) {
  return apiGet(
    `${GET_CAMERA_INFO}${id}/`,
    'apiGetToggleImageMeasure',
    successMessage,
    errorMessage
  );
}

export const apiPatchToggleImageMeasure = async (
  id,
  payload,
  successMessage = null,
  errorMessage = null //'There was an error while updating details'
) => {
  return await apiPatch(
    `${UPDATE_MEASUREMENT_STATUS}${id}/`,
    payload,
    'apiPatchToggleImageMeasure',
    successMessage,
    errorMessage,
    false
  );
};
// props group archive and restore API
export function apiArchivePropsGroup(id, payload, successMessage = null, errorMessage = null) {
  return apiPatch(
    `${UPDATE_PROPS_GROUP_ARCHIVE}${id}/`,
    payload,
    '',
    successMessage,
    errorMessage,
    true
  );
}
// Assign packs to organization

export async function apiTextureDeleteAndRestore(
  payload,
  successMessage = null,
  errorMessage = null
) {
  return await apiPost(
    TEXTURE_DELETE_OR_RESTORE_API,
    payload,
    'apiPostTextureDeleteAndRestore',
    successMessage,
    errorMessage,
    false
  );
}

export async function apiModelDeleteAndRestore(
  payload,
  successMessage = null,
  errorMessage = null
) {
  return await apiPost(
    MODEL_DELETE_OR_RESTORE_API,
    payload,
    'apiPostModelDelete',
    successMessage,
    errorMessage,
    false
  );
}

export const apiModelAdminDelete = async (payload, successMessage = null, errorMessage = null) => {
  return await apiMultiDelete(
    MODEL_DELETE_ADMIN_API,
    payload,
    'apiModelAdminDelete',
    successMessage,
    errorMessage
  );
};

export async function apiConvertGuestUser(payload, successMessage = null, errorMessage = null) {
  return await apiPost(
    SIGNUP_CONVERT_USER,
    payload,
    'apiPostConvertUser',
    successMessage,
    errorMessage,
    false
  );
}

// userpilot apis
export function apiGetUserpilotSteps({
  param = '',
  successMessage = null,
  errorMessage = null,
} = {}) {
  return apiGet(`${USERPILOT_API}${param}`, 'apiGetUserpilotSteps', successMessage, errorMessage);
}

export function apiPostUserpilotSteps({ formData }) {
  return api()
    .root(API_ROOT_URL)
    .post(USERPILOT_API)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiUpdateUserpilotStep({
  id,
  formData,
  successMessage = null,
  errorMessage = null,
}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${USERPILOT_API}${id}/`)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiPatchAfterRegister');
    })
    .send();
}

export const apiDeleteUserpilotStep = async ({
  id,
  successMessage = '',
  errorMessage = 'something went wrong',
}) => {
  return await apiDelete(
    `${USERPILOT_API}${id}/`,
    'apiDeleteUserpilotStep',
    successMessage,
    errorMessage
  );
};

// product v2 revamp API
export function apiGetProductCategories({
  id,
  params = '',
  successMessage = null,
  errorMessage = null,
} = {}) {
  return apiGet(
    `${PRODUCT_V2_CATEGORIES}${id}/${params}`,
    'apiGetProductCategories',
    successMessage,
    errorMessage,
    true
  );
}

export function apiGetTextureCategories({
  id,
  params = '',
  successMessage = null,
  errorMessage = null,
} = {}) {
  return apiGet(
    `${TEXTURE_V2_CATEGORIES}${id}/${params}`,
    'apiGetTextureCategories',
    successMessage,
    errorMessage,
    true
  );
}

export function apiGetProductCategoriesPublic({
  id,
  params = '',
  successMessage = null,
  errorMessage = null,
} = {}) {
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_PUBLIC}${id}/${params}`,
    'apiGetProductCategories',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoriesPublic({
  id,
  params = '',
  successMessage = null,
  errorMessage = null,
} = {}) {
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_PUBLIC}${id}/${params}`,
    'apiGetTextureCategories',
    successMessage,
    errorMessage
  );
}

export function apiUpdateProductCategories({
  id,
  data,
  successMessage = null,
  errorMessage = null,
}) {
  return api()
    .root(API_ROOT_URL)
    .patch(PRODUCT_V2_CATEGORIES_BULK_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateProductCategories');
    })
    .send();
}

export function apiUpdateTextureCategories({
  id,
  data,
  successMessage = null,
  errorMessage = null,
}) {
  return api()
    .root(API_ROOT_URL)
    .patch(TEXTURE_V2_CATEGORIES_BULK_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateTextureCategories');
    })
    .send();
}

export function apiGetProductCategoryImages({
  id,
  contentId,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_IMAGE_CONTENT.replace(':id', id)}${
      contentId ? `${contentId}/` : ''
    }?${_params}`,
    'apiGetProductCategoryImages',
    successMessage,
    errorMessage
  );
}

export function apiGetProductCategoryImagesPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_IMAGE_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetProductCategoryImages',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoryImages({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_IMAGE_CONTENT.replace(':id', id)}?${_params}`,
    'apiGetTextureCategoryImages',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoryImagesPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_IMAGE_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetTextureCategoryImages',
    successMessage,
    errorMessage
  );
}

export function apiUpdateNameProductCategoryImages({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${PRODUCT_V2_CATEGORIES_IMAGE_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameProductCategoryImages');
    })
    .send();
}

export function apiUpdateNameTextureCategoryImages({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${TEXTURE_V2_CATEGORIES_IMAGE_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameTextureCategoryImages');
    })
    .send();
}

export function apiUploadProductImagesV2({
  id,
  data,
  isGIF,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .post((isGIF ? PRODUCT_V2_GIF_UPLOAD : PRODUCT_V2_IMAGES_UPLOAD).replace(':id', id))
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiUploadTextureImagesV2({
  id,
  data,
  isGIF,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .post((isGIF ? TEXTURE_V2_GIF_UPLOAD : TEXTURE_V2_IMAGES_UPLOAD).replace(':id', id))
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiPostProductCategoryImages({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  const formData = objectToFormData(data);
  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_V2_CATEGORIES_IMAGE_CONTENT.replace(':id', id))
    .data(formData)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}
export async function apiPostCaptchaValidation(formData) {
  return await api()
    .root(API_ROOT_URL)
    .post(CAPTCHA_VALIDATION_API)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      return error;
    })
    .send();
}

export function apiPostTextureCategoryImages({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  const formData = objectToFormData(data);
  return api()
    .root(API_ROOT_URL)
    .post(TEXTURE_V2_CATEGORIES_IMAGE_CONTENT.replace(':id', id))
    .data(formData)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export async function apiPostCaptchaV2Validation(formData) {
  return await api()
    .root(API_ROOT_URL)
    .post(CAPTCHA_V2_VALIDATION_API)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      return error;
    })
    .send();
}

export function apiUpdateProductCategoryImages({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(PRODUCT_V2_CATEGORIES_IMAGE_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateProductCategoryImages');
    })
    .send();
}

export function apiUpdateTextureCategoryImages({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(TEXTURE_V2_CATEGORIES_IMAGE_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateTextureCategoryImages');
    })
    .send();
}
// onboard new user apis
export function apiGetOrgRequestList({
  param = '',
  successMessage = null,
  errorMessage = null,
} = {}) {
  return apiGet(
    `${GET_ORG_REQUEST_LIST}${param}`,
    'apiGetOrgRequestList',
    successMessage,
    errorMessage
  );
}

export function apiGetOrgRequestStatus({
  param = '',
  successMessage = null,
  errorMessage = null,
} = {}) {
  return apiGet(
    `${GET_ORG_REQUEST_STATUS}${param}`,
    'apiGetOrgRequestStatus',
    successMessage,
    errorMessage
  );
}

export function apiGetOrgSentRequestList(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${GET_ORG_SENT_REQUEST_LIST}?${query}`,
    'apiGetOrgSentRequestList',
    successMessage,
    errorMessage
  );
}

export function apiGetAllUserOrgSentRequestList(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${GET_ALL_USER_ORG_REQUEST_LIST}?${query}`,
    'apiGetAllUserOrgSentRequestList',
    successMessage,
    errorMessage
  );
}

export function apiPostJoinOrgRequest(paylaod) {
  return api()
    .root(API_ROOT_URL)
    .post(SEND_ORG_REQUEST)
    .data(paylaod)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiDeleteProductCategoryImages({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      PRODUCT_V2_CATEGORIES_IMAGE_CONTENT_DELETE.replace(':id', id).replace(
        ':content_id',
        content_id
      )
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiDeleteTextureCategoryImages({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      TEXTURE_V2_CATEGORIES_IMAGE_CONTENT_DELETE.replace(':id', id).replace(
        ':content_id',
        content_id
      )
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDeleteProductImagesAndGif({ id, data, isGIF = false }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      (isGIF ? PRODUCT_V2_GIF_MULTI_DELETE : PRODUCT_V2_IMAGES_MULTI_DELETE).replace(':id', id)
    )
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDeleteTextureImagesAndGif({ id, data, isGIF = false }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      (isGIF ? TEXTURE_V2_GIF_MULTI_DELETE : TEXTURE_V2_IMAGES_MULTI_DELETE).replace(':id', id)
    )
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function sendRenderToApi360Model(formData, uploadedTextureId = null) {
  return api()
    .root(API_ROOT_URL)
    .post(uploadedTextureId ? AUTOMATION_RENDER_API_360_TEXTURE : AUTOMATION_RENDER_API_360)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}
export function apiPostAcceptOrDeniedJoinOrgRequest(formData) {
  return api()
    .root(API_ROOT_URL)
    .post(JOIN_ORG_REQUEST)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiPostProductVideos({
  url,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  const formData = objectToFormData(data);
  return api()
    .root(API_ROOT_URL)
    .post(url)
    .data(formData)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiPatchProductVideo({
  id,
  url,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  const formData = objectToFormData(data);
  return api()
    .root(API_ROOT_URL)
    .patch(`${url}${id}/`)
    .data(formData)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiDeleteProductVideos({ url, successMessage = null, errorMessage = null } = {}) {
  return api()
    .root(API_ROOT_URL)
    .delete(url)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiGetProductCategoryGif({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_GIF_CONTENT.replace(':id', id)}?${_params}`,
    'apiGetProductCategoryGif',
    successMessage,
    errorMessage
  );
}

export function apiGetProductCategoryGifPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_GIF_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetProductCategoryGif',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoryGif({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_GIF_CONTENT.replace(':id', id)}?${_params}`,
    'apiGetTextureCategoryGif',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoryGifPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_GIF_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetTextureCategoryGif',
    successMessage,
    errorMessage
  );
}

export function apiUpdateNameProductCategoryGif({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${PRODUCT_V2_CATEGORIES_GIF_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameProductCategoryGif');
    })
    .send();
}

export function apiUpdateNameTextureCategoryGif({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${TEXTURE_V2_CATEGORIES_GIF_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameTextureCategoryGif');
    })
    .send();
}

export function apiUpdateProductCategoryGif({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(PRODUCT_V2_CATEGORIES_GIF_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateProductCategoryGif');
    })
    .send();
}

export function apiUpdateTextureCategoryGif({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(TEXTURE_V2_CATEGORIES_GIF_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateTextureCategoryGif');
    })
    .send();
}

export function apiDeleteProductCategoryGif({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      PRODUCT_V2_CATEGORIES_GIF_CONTENT_DELETE.replace(':id', id).replace(':content_id', content_id)
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiDeleteTextureCategoryGif({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      TEXTURE_V2_CATEGORIES_GIF_CONTENT_DELETE.replace(':id', id).replace(':content_id', content_id)
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiGetProductCategoryVideo({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_VIDEO_CONTENT.replace(':id', id)}?${_params}`,
    'apiGetProductCategoryVideo',
    successMessage,
    errorMessage
  );
}

export function apiGetProductCategoryVideoPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_VIDEO_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetProductCategoryVideo',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoryVideo({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_VIDEO_CONTENT.replace(':id', id)}?${_params}`,
    'apiGetTextureCategoryVideo',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoryVideoPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_VIDEO_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetTextureCategoryVideo',
    successMessage,
    errorMessage
  );
}

export function apiUpdateNameProductCategoryVideo({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${PRODUCT_V2_CATEGORIES_VIDEO_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameProductCategoryVideo');
    })
    .send();
}

export function apiUpdateNameTextureCategoryVideo({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${TEXTURE_V2_CATEGORIES_VIDEO_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameTextureCategoryVideo');
    })
    .send();
}

export function apiUpdateProductCategoryVideo({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(PRODUCT_V2_CATEGORIES_VIDEO_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateProductCategoryVideo');
    })
    .send();
}

export function apiUpdateTextureCategoryVideo({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(TEXTURE_V2_CATEGORIES_VIDEO_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateTextureCategoryVideo');
    })
    .send();
}

export function apiDeleteProductCategoryVideo({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      PRODUCT_V2_CATEGORIES_VIDEO_CONTENT_DELETE.replace(':id', id).replace(
        ':content_id',
        content_id
      )
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiDeleteTextureCategoryVideo({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      TEXTURE_V2_CATEGORIES_VIDEO_CONTENT_DELETE.replace(':id', id).replace(
        ':content_id',
        content_id
      )
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDeleteProductVideo({ id, data }) {
  return api()
    .root(API_ROOT_URL)
    .delete(PRODUCT_V2_VIDEO_MULTI_DELETE.replace(':id', id))
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDeleteTextureVideo({ id, data }) {
  return api()
    .root(API_ROOT_URL)
    .delete(TEXTURE_V2_VIDEO_MULTI_DELETE.replace(':id', id))
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiGetProductCategoryConfigurator({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT.replace(':id', id)}?${_params}`,
    'apiGetProductCategoryConfigurator',
    successMessage,
    errorMessage
  );
}

export function apiGetProductCategoryConfiguratorPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetProductCategoryConfigurator',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoryConfigurator({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT.replace(':id', id)}?${_params}`,
    'apiGetTextureCategoryConfigurator',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategoryConfiguratorPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetTextureCategoryConfigurator',
    successMessage,
    errorMessage
  );
}

export function apiUpdateNameProductCategoryConfigurator({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameProductCategoryConfigurator');
    })
    .send();
}

export function apiUpdateNameTextureCategoryConfigurator({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameTextureCategoryConfigurator');
    })
    .send();
}

export function apiUpdateProductCategoryConfigurator({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateProductCategoryConfigurator');
    })
    .send();
}

export function apiUpdateTextureCategoryConfigurator({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateTextureCategoryConfigurator');
    })
    .send();
}

export function apiDeleteProductCategoryConfigurator({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      PRODUCT_V2_CATEGORIES_CONFIGURATOR_CONTENT_DELETE.replace(':id', id).replace(
        ':content_id',
        content_id
      )
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiDeleteTextureCategoryConfigurator({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      TEXTURE_V2_CATEGORIES_CONFIGURATOR_CONTENT_DELETE.replace(':id', id).replace(
        ':content_id',
        content_id
      )
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDeleteProductConfigurator({ id, data }) {
  return api()
    .root(API_ROOT_URL)
    .delete(PRODUCT_V2_CONFIGURATOR_MULTI_DELETE.replace(':id', id))
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDeleteTextureConfigurator({ id, data }) {
  return api()
    .root(API_ROOT_URL)
    .delete(TEXTURE_V2_CONFIGURATOR_MULTI_DELETE.replace(':id', id))
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiGetProductCategory360Viewer({
  id,
  contentId,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT.replace(':id', id)}${
      contentId ? `${contentId}/` : ''
    }?${_params}`,
    'apiGetProductCategory360Viewer',
    successMessage,
    errorMessage
  );
}

export function apiGetProductCategory360ViewerPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetProductCategory360Viewer',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategory360Viewer({
  id,
  contentId,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT.replace(':id', id)}${
      contentId ? `${contentId}/` : ''
    }?${_params}`,
    'apiGetTextureCategory360Viewer',
    successMessage,
    errorMessage
  );
}

export function apiGetTextureCategory360ViewerPublic({
  id,
  params,
  page,
  perPage,
  successMessage = null,
  errorMessage = null,
} = {}) {
  if (!id) return;
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(
    `${TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT_PUBLIC.replace(':id', id)}?${_params}`,
    'apiGetTextureCategory360Viewer',
    successMessage,
    errorMessage
  );
}

export function apiUpdateNameProductCategory360Viewer({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameProductCategory360Viewer');
    })
    .send();
}

export function apiUpdateNameTextureCategory360Viewer({
  id,
  content_id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT.replace(':id', id)}${content_id}/`)
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateNameTextureCategory360Viewer');
    })
    .send();
}

export function apiUpdateProductCategory360Viewer({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateProductCategory360Viewer');
    })
    .send();
}

export function apiUpdateTextureCategory360Viewer({
  id,
  data,
  successMessage = null,
  errorMessage = null,
} = {}) {
  return api()
    .root(API_ROOT_URL)
    .patch(TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT_UPDATE.replace(':id', id))
    .data(data)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      apiErrorHandler(error, 'apiUpdateTextureCategory360Viewer');
    })
    .send();
}

export function apiDeleteProductCategory360Viewer({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      PRODUCT_V2_CATEGORIES_360_VIEWER_CONTENT_DELETE.replace(':id', id).replace(
        ':content_id',
        content_id
      )
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiDeleteTextureCategory360Viewer({ id, content_id }) {
  return api()
    .root(API_ROOT_URL)
    .delete(
      TEXTURE_V2_CATEGORIES_360_VIEWER_CONTENT_DELETE.replace(':id', id).replace(
        ':content_id',
        content_id
      )
    )
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDeleteProduct360Viewer({ id, data }) {
  return api()
    .root(API_ROOT_URL)
    .delete(PRODUCT_V2_360_VIEWER_MULTI_DELETE.replace(':id', id))
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDeleteTexture360Viewer({ id, data }) {
  return api()
    .root(API_ROOT_URL)
    .delete(TEXTURE_V2_360_VIEWER_MULTI_DELETE.replace(':id', id))
    .data(data)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export function apiMultiDownloadProductV2({
  isTexture = false,
  formData,
  successMessage = null,
  errorMessage = null,
}) {
  const URL = isTexture ? TEXTURE_V2_DOWNLOAD_ZIP : PRODUCT_V2_DOWNLOAD_ZIP;
  return api()
    .root(API_ROOT_URL)
    .post(URL)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .send();
}

export function apiResendJoinOrgRequest(id, formData, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .patch(`${SEND_ORG_REQUEST}${id}/`)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error(() => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
    })
    .send();
}

export function apiUpdateTextureConfiguratorLink(
  textureId,
  id,
  formData,
  successMessage = null,
  errorMessage = null
) {
  return api()
    .root(API_ROOT_URL)
    .patch(UPDATE_TEXTURE_CONFIGURATOR_LINK?.replace(':textureid', textureId)?.replace(':id', id))
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error(() => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
    })
    .send();
}

export function apiUpdateProductConfiguratorLink(
  productId,
  id,
  formData,
  successMessage = null,
  errorMessage = null
) {
  return api()
    .root(API_ROOT_URL)
    .patch(UPDATE_PRODUCT_CONFIGURATOR_LINK?.replace(':productid', productId)?.replace(':id', id))
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error(() => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
    })
    .send();
}

export function apiHomeGetProp(id, successMessage = null, errorMessage = null) {
  return apiGet(`${HOME_GET_PROP}?id=${id}`, 'apiHomeGetProp', successMessage, errorMessage);
}

export function apiHomeGetTexture(id, successMessage = null, errorMessage = null) {
  return apiGet(`${HOME_GET_TEXTURE}?id=${id}`, 'apiHomeGetTexture', successMessage, errorMessage);
}

export function apiAddConfiguratorLink(formData, successMessage = null, errorMessage = null) {
  return api()
    .root(API_ROOT_URL)
    .post(ADD_CONFIGURATOR_LINK)
    .data(formData)
    .success((res) => {
      if (successMessage) {
        successToast(successMessage);
      }
      return res;
    })
    .error(() => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
    })
    .send();
}

export async function apiUpdateProductV2GenerateStatus({ id, data } = {}) {
  return await apiPatch(PRODUCT_V2_GENERATE_STATUS.replaceAll(':id', id), data);
}

export async function apiUpdateTextureV2GenerateStatus({ id, data } = {}) {
  return await apiPatch(TEXTURE_V2_GENERATE_STATUS.replaceAll(':id', id), data);
}

export async function assignThisTexture(ids) {
  const formObj = new FormData();
  let url = ALLOW_TEXTURE_TO_ALL;
  for (let i = 0; i < ids.length; i++) {
    formObj.append('id', ids[i]);
  }
  return apiPostV2(url, {
    data: formObj,
    isFormData: false,
    showMessage: false,
    successMessage: 'Texture assigned successfully!',
    errorMessage: 'Something went wrong. Please try again!',
  }).send();
}

export function apiGetAPIKeyList(query, successMessage = null, errorMessage = null) {
  const _query = query ? `?${query}` : '';
  return apiGet(`${GET_API_KEY_API}${_query}`, 'apiGetAPIKeyList', successMessage, errorMessage);
}

export function apiPatchAPIKeyDomains(
  data,
  successMessage = null,
  errorMessage = null,
  isFormData = false
) {
  return apiPatch(
    GET_API_KEY_API,
    data,
    'apiPatchAPIKeyDomains',
    successMessage,
    errorMessage,
    isFormData
  );
}

export function apiGetScopes(query, successMessage = null, errorMessage = null) {
  const _query = query ? `?${query}` : '';
  return apiGet(`${GET_SCOPES_API}${_query}`, 'apiGetScopes', successMessage, errorMessage);
}

export async function apiGetSalsifyOrgDetails() {
  const _cat = localStorage.getItem('CACHE_TIMESTAMP') || '';
  const params = _cat ? objectToSearchParams({ _cat }) : '';
  return api()
    .root(API_ROOT_URL)
    .get(SALSIFY_ORG_DETAILS_API + `?${params}`)
    .success((data) => {
      return data;
    })
    .notFound404(() => {})
    .send();
}

export function apiPostSalsifyOrgDetails(
  data,
  successMessage = null,
  errorMessage = null,
  isFormData = false
) {
  return apiPost(
    SALSIFY_ORG_DETAILS_API,
    data,
    'apiPostSalsifyOrgDetails',
    successMessage,
    errorMessage,
    isFormData
  );
}

export async function apiGetSalsifyVerifyConnection() {
  const _cat = localStorage.getItem('CACHE_TIMESTAMP') || '';
  const params = _cat ? objectToSearchParams({ _cat }) : '';
  const result = await apiGet(
    SALSIFY_VERIFY_CONNECTION_API + `?${params}`,
    'apiGetSalsifyVerifyConnection'
  );
  return result;
}

export async function apiUploadAssetsToSalsify(formData, successMessage = '', errorMessage = '') {
  return apiPost(
    SALSIFY_UPLOAD_ASSETS_API,
    formData,
    'apiUploadAssetsToSalsify',
    successMessage,
    errorMessage,
    true // isFormData
  );
}

export async function apiGetSalsifySyncProductIdsStatus() {
  return apiGet(SALSIFY_SYNC_PRODUCT_IDS_API, 'apiGetSalsifySyncProductIdsStatus');
}

export function apiPostSalsifySyncProductIds() {
  const payload = new FormData();
  return apiPost(
    SALSIFY_SYNC_PRODUCT_IDS_API,
    payload,
    'apiPostSalsifySyncProductIds',
    null,
    null,
    false
  );
}

export async function apiGetSalsifySyncAssetsStatus() {
  return apiGet(SALSIFY_SYNC_ASSETS_API, 'apiGetSalsifySyncAssetsStatus');
}

export function apiPostSalsifySyncAssets() {
  const payload = new FormData();
  return apiPost(SALSIFY_SYNC_ASSETS_API, payload, 'apiPostSalsifySyncAssets', null, null, false);
}

// Public / Secret key APIs
export function apiGetAPIKeysList(query, successMessage = null, errorMessage = null) {
  const _query = query ? `?${query}` : '';
  return apiGet(`${GET_API_KEYS_API}${_query}`, 'apiGetAPIKeysList', successMessage, errorMessage);
}

/**
 * Creates a new API key (public or secret)
 * @param {Object} payload - The API key configuration
 * @param {string} payload.key_type - Type of key: "public" or "secret"
 * @param {string} payload.label - A descriptive label for the API key
 * @param {Array<string>} payload.allowed_domain - Array of allowed domains for this key
 * @param {string|null} [successMessage=null] - Optional success message to display
 * @param {string|null} [errorMessage=null] - Optional error message to display
 * @returns {Promise} API response with created key details
 *
 * @example
 * // Example with public key
 * const publicKeyPayload = {
 *   key_type: 'public',
 *   label: 'My Frontend App - Public Key2',
 *   allowed_domain: ['localhost', '127.0.0.1', 'app.example.com']
 * };
 *
 * // Example with secret key
 * const secretKeyPayload = {
 *   key_type: 'secret',
 *   label: 'My Backend Service - Secret Key2',
 *   allowed_domain: ['localhost', '127.0.0.1', 'clicup.example.com']
 * };
 *
 * const response = await apiCreateAPIKey(
 *   publicKeyPayload,
 *   'API Key created successfully',
 *   'Failed to create API Key'
 * );
 */
export function apiCreateAPIKey(payload, successMessage = null, errorMessage = null) {
  return apiPost(
    CREATE_API_KEY_API,
    payload,
    'apiCreateAPIKey',
    successMessage,
    errorMessage,
    false // isFormData = false to send JSON array properly
  );
}

/**
 * Revokes an existing API key by its ID
 * @param {number|string} keyId - The ID of the API key to revoke
 * @param {string|null} [successMessage=null] - Optional success message to display
 * @param {string|null} [errorMessage=null] - Optional error message to display
 * @returns {Promise} API response confirming key revocation
 *
 * @example
 * const response = await apiRevokeAPIKey(
 *   114,
 *   'API Key revoked successfully',
 *   'Failed to revoke API Key'
 * );
 */
export function apiRevokeAPIKey(keyId, successMessage = null, errorMessage = null) {
  return apiPatch(
    `${CREATE_API_KEY_API}${keyId}/`,
    { revoke: true },
    'apiRevokeAPIKey',
    successMessage,
    errorMessage
  );
}

/**
 * Renews a temporary (trial) API key — resets its expiry to now + 3h and
 * re-enables it. Works even when the key is already expired or disabled.
 * @param {number|string} keyId - The ID of the temporary API key to renew
 * @param {string|null} [successMessage=null] - Optional success message to display
 * @param {string|null} [errorMessage=null] - Optional error message to display
 * @returns {Promise} API response with the renewed key details
 */
export function apiRenewAPIKey(keyId, successMessage = null, errorMessage = null) {
  return apiPatch(
    `${CREATE_API_KEY_API}${keyId}/`,
    { renew: true },
    'apiRenewAPIKey',
    successMessage,
    errorMessage,
    false // isFormData = false to send JSON properly
  );
}

/**
 * Re-enables (resumes) a temporary (trial) API key via `{ enable: true }`.
 * Keeps the original expiry if time is still left; renews to a fresh 3h only if
 * the window had already lapsed (see `data.renewed` in the response).
 * @param {number|string} keyId - The ID of the API key to enable
 * @param {string|null} [successMessage=null] - Optional success message to display
 * @param {string|null} [errorMessage=null] - Optional error message to display
 * @returns {Promise} API response with the enabled key details
 */
export function apiEnableAPIKey(keyId, successMessage = null, errorMessage = null) {
  return apiPatch(
    `${CREATE_API_KEY_API}${keyId}/`,
    { enable: true },
    'apiEnableAPIKey',
    successMessage,
    errorMessage,
    false // isFormData = false to send JSON properly
  );
}

/**
 * Pauses (disables) a temporary (trial) API key via `{ disable: true }`.
 * Reversible — the key/row survives and keeps the org's one-temp-key slot, so it
 * can later be resumed with `enable`. Only supported for temporary keys.
 * @param {number|string} keyId - The ID of the API key to disable
 * @param {string|null} [successMessage=null] - Optional success message to display
 * @param {string|null} [errorMessage=null] - Optional error message to display
 * @returns {Promise} API response with the disabled key details
 */
export function apiDisableAPIKey(keyId, successMessage = null, errorMessage = null) {
  return apiPatch(
    `${CREATE_API_KEY_API}${keyId}/`,
    { disable: true },
    'apiDisableAPIKey',
    successMessage,
    errorMessage,
    false // isFormData = false to send JSON properly
  );
}

/**
 * Updates the allowed domains for an existing API key
 * @param {number|string} keyId - The ID of the API key to update
 * @param {Array<string>} allowedDomains - Array of allowed domains to set for this key
 * @param {string|null} [successMessage=null] - Optional success message to display
 * @param {string|null} [errorMessage=null] - Optional error message to display
 * @returns {Promise} API response confirming domains update
 *
 * @example
 * const response = await apiUpdateAPIKeyDomains(
 *   114,
 *   ['localhost', 'https://chatgpt.com/'],
 *   'API Key domains updated successfully',
 *   'Failed to update API Key domains'
 * );
 */
export function apiUpdateAPIKeyDomains(
  keyId,
  allowedDomains,
  successMessage = null,
  errorMessage = null
) {
  return apiPatch(
    `${CREATE_API_KEY_API}${keyId}/`,
    { allowed_domain: allowedDomains },
    'apiUpdateAPIKeyDomains',
    successMessage,
    errorMessage,
    false // isFormData = false to send JSON array properly
  );
}

/**
 * Updates the scopes for an API key
 * @param {number|string} keyId - The ID of the API key to update
 * @param {Array<number>} scopeIds - Array of scope IDs to assign to the key
 * @param {string|null} [successMessage=null] - Optional success message to display
 * @param {string|null} [errorMessage=null] - Optional error message to display
 * @returns {Promise} API response confirming scopes update
 */
export function apiUpdateAPIKeyScopes(
  keyId,
  scopeIds,
  successMessage = null,
  errorMessage = null
) {
  return apiPatch(
    `${CREATE_API_KEY_API}${keyId}/`,
    { scope_ids: scopeIds },
    'apiUpdateAPIKeyScopes',
    successMessage,
    errorMessage,
    false // isFormData = false to send JSON array properly
  );
}

/**
 * Regenerates an API key with optional label update
 * @param {number|string} keyId - The ID of the API key to regenerate
 * @param {string|null} [label=null] - Optional new label for the API key
 * @param {string|null} [successMessage=null] - Optional success message to display
 * @param {string|null} [errorMessage=null] - Optional error message to display
 * @returns {Promise} API response with regenerated key details
 *
 * @example
 * // Regenerate without changing label
 * const response = await apiRegenerateAPIKey(
 *   114,
 *   null,
 *   'API Key regenerated successfully',
 *   'Failed to regenerate API Key'
 * );
 *
 * // Regenerate and update label
 * const response = await apiRegenerateAPIKey(
 *   114,
 *   'My Backend Service - Secret Key2 (rotated)',
 *   'API Key regenerated successfully',
 *   'Failed to regenerate API Key'
 * );
 */
export function apiRegenerateAPIKey(
  keyId,
  label = null,
  successMessage = null,
  errorMessage = null
) {
  const payload = { regenerate_api_key: true };
  if (label) {
    payload.label = label;
  }

  return apiPatch(
    `${CREATE_API_KEY_API}${keyId}/`,
    payload,
    'apiRegenerateAPIKey',
    successMessage,
    errorMessage,
    false // isFormData = false to send JSON properly
  );
}

export const apiGetHubspotVisitorIdentificationToken = async ({ data } = {}) => {
  const response = await apiPost(
    HUSBPOT_VISITOR_IDENTIFICATION_API,
    data,
    'apiGetHubspotVisitorIdentificationToken'
  );
  if (response && response?.token) {
    return response?.token;
  }
  return null;
};

// raindrop APIs
export function apiPostDataToRaindrop({ data, updateData = false }) {
  const formData = objectToFormData(data);

  return api()
    .root(API_ROOT_URL)
    .post(updateData ? UPDATE_RAINDROP_API : CREATE_RAINDROP_API)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export const saveMaterialApi = (payload) => {
  let url = SAVE_MATERIAL_PRESET;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: false,
  }).send();
};

export function apiBulkDeleteMaterials(
  payload,
  successMessage = null,
  errorMessage = null,
  isFormData = true,
  callback,
  successDescription
) {
  const allIds = [];
  for (let [key, value] of payload.entries()) {
    allIds.push(value);
  }
  const url = MULTIPLE_MATERIAL_DELETE;
  return api()
    .root(API_ROOT_URL)
    .post(url)
    .data(payload)
    .success((data) => {
      if (successMessage) {
        successToast(successMessage, successDescription);
      }
      if (callback) {
        callback(data);
      }
      return data;
    })
    .error((error) => {
      if (errorMessage) {
        errorToast(errorMessage);
      }
      if (callback) {
        callback(error);
      }
      throw error;
    })
    .badRequest400((error) => {
      throw error;
    })
    .send();
}

export const createMaterialJob = (payload) => {
  let url = CREATE_MATERIAL_JOB;
  const data = payload;
  return apiPostV2(url, {
    data,
    isFormData: false,
  }).send();
};

// product page viewed APIs
export function apiPostProductPageViewed({ data }) {
  const formData = objectToFormData(data);

  return api()
    .root(API_ROOT_URL)
    .post(PAGE_VIEWED_EMAIL)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export function apiGetPropsForProductSetup(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${OPTIMIZED_PRODUCT_GET_API_HOMEPAGE}?${query}`,
    'apiGetPropsForProductSetup',
    successMessage,
    errorMessage
  );
}

export function apiGetTexturesForProductSetup(query, successMessage = null, errorMessage = null) {
  return apiGet(
    `${OP_GET_TEXTURES_API}?${query}`,
    'apiGetTexturesForProductSetup',
    successMessage,
    errorMessage
  );
}

// Product page share and invite API
export function apiPostProductAccessPermission(data) {
  // const formData = objectToFormData(data)
  return api()
    .root(API_ROOT_URL)
    .post(ADD_PERMISSION_ACCESS)
    .data(data)
    .success((data) => {
      return data;
    })
    .error((error) => {
      return error;
    })
    .send();
}

export const apiGetSharedMemberList = ({ params = {}, page, perPage = 5 } = {}) => {
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(`${GET_SHARED_MEMBER_LIST}?${_params}`);
};

export async function updateSharedMemberAccess({ id, data } = {}) {
  return await apiPatch(`${ADD_PERMISSION_ACCESS}${id}/`, data);
}

export async function updateProductTrackingAnalytics({ id, data } = {}) {
  return await apiPatch(`${PUBLIC_LINK}${id}/`, data);
}
export async function updateTextureTrackingAnalytics({ id, data } = {}) {
  return await apiPatch(`${PUBLIC_LINK_TEXTURE}${id}/`, data);
}

export function apiRemoveSharedMemberAccess(id) {
  return api()
    .root(API_ROOT_URL)
    .delete(`${ADD_PERMISSION_ACCESS}${id}/`)
    .success((res) => {
      return res;
    })
    .error((error) => {
      apiErrorHandler(error);
      return error;
    })
    .send();
}

export async function assignProductPagePermissionToMember({ id, data } = {}) {
  return await apiPatch(
    `${ASSIGN_SHARED_MEMBER_ACCESS_PERMISSION}${id}/`,
    data,
    null,
    null,
    null,
    false
  );
}

export async function saveProductPageViewData(data) {
  const formData = objectToFormData(data);

  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_PAGE_VIEWED)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export async function saveProductPageDownloadData(data) {
  const formData = objectToFormData(data);

  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_PAGE_DOWNLOADS)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export async function saveProductPageShareData(data) {
  const formData = objectToFormData(data);

  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_PAGE_SHARE)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}

export async function saveProductPageEngagementData(data) {
  const formData = objectToFormData(data);

  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_PAGE_ENGAGEMENTS)
    .data(formData)
    .success((data) => {
      return data;
    })
    .error((error) => {
      throw error;
    })
    .send();
}
export const apiGetRequestStatusCount = ({ params = {}, page = 1, perPage = 20 } = {}) => {
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });
  return apiGet(`${GET_REQUESTS_COUNT_API}?${_params}`);
};

export const apiGetRequestHelpdeskUrl = () => {
  const token = localStorage.getItem('token');
  const site = FRAPPE_APP_URL;
  const email = getLocalStorage(CURRENT_USER, true)?.user?.email;

  const _data = { token, email: email || '' };
  return fetch(site + '/api/method/helpdesk.login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json', // Specify the content type
    },
    body: JSON.stringify(_data),
  });
};

export async function updateRenderImageConfig({ id, data } = {}) {
  const url = UPDATE_RENDER_IMAGE_CONFIG?.replace(':id', id);
  return await apiPatch(url, data, null, null, null, false);
}

export async function apiGetPdpProductsVariants({ brands, base_model }) {
  const params = new URLSearchParams();
  if (brands) params.append('brands', brands);
  if (base_model) params.append('base_model', base_model);
  const query = params.toString();
  const result = await fetchAllPages((page) => {
    const url = `${GET_PDP_PRODUCTS_VARIANTS_API}?${query}&page=${page}`;
    return apiGet(url, 'apiGetPdpProductsVariants');
  });
  return result;
}

export async function updateBulkRenderImageConfig({ payload }) {
  return await apiPost(UPDATE_BULK_RENDER_IMAGE_CONFIG, payload);
}

export async function apiGetAppData() {
  return apiGet(APP_DATA_API, 'apiGetAppData', null, null, true);
}
